/*
 * inselvolt Kompatibilitätsberater — Datenbasis, Teil QUELLEN (Audit-Trail).
 *
 * ÄNDERUNGEN NUR NACH v2/DATENPFLEGE.md (Rezepte A–C, G). Seit E5 (2026-08-25)
 * ist die Datenbasis in vier Teildateien geteilt; daten/berater-daten.js fügt
 * sie zusammen und bleibt die einzige Schnittstelle (IVBeraterDaten).
 * Ausgeliefert wird weiterhin EIN Theme-Asset (iv-berater-daten.js) — der Bau
 * konkateniert die Teile, der nächtliche Datendeploy bleibt unberührt.
 */
(function (root) {
  'use strict';

  var QUELLEN = {
    /*
     * Erneut geprüft gegen einen Ausdruck derselben Seite vom 29.08.2026 MESZ
     * (`Datenblätter/Wechselrichter/fronius Kompatible Batterien 29082026.pdf`,
     * liegt daneben). `abruf_datum` ist der zugehörige UTC-Tag — die Datenbasis
     * datiert nach UTC, genau wie der tägliche Preislauf. Die Tabelle ist
     * unverändert: Alle
     * Freigaben aus dieser Quelle decken sich Zeile für Zeile mit dem Ausdruck,
     * einschließlich der sechs Reserva-Pro-Größen.
     *
     * Zitiert bleibt bewusst die Bilddatei: Der Ausdruck schneidet die letzte
     * Tabellenspalte (Verto Plus) am rechten Rand ab, der Screenshot zeigt alle
     * sechs Spalten vollständig. Ein abgeschnittener Beleg ist der schlechtere
     * Beleg, auch wenn er frischer ist.
     */
    'fronius-web': {
      titel: 'Fronius Batteriekompatibilitäts-Übersicht (fronius.com)',
      herausgeber: 'Fronius International GmbH (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/fronius kompatible speicher komplettübersicht web.jpeg',
      stand: '© 2026 (Website-Abruf)',
      abruf_datum: '2026-08-28',
      typ: 'hersteller',
      nennt_hersteller: ['Fronius', 'BYD', 'LG'],
      /*
       * Die Spaltenköpfe der Tabelle, vollständig. Drei der sechs
       * Hybrid-Baureihen führt der Katalog nicht — sie stehen hier als
       * Arbeitsliste, nicht als stilles Weglassen (DATENPFLEGE A.5b).
       */
      nennt_geraete: [
        { name: 'Primo GEN24 Plus', familie: 'fronius-primo-gen24-plus' },
        { name: 'Primo GEN24 Plus SC', familie: null,
          grund: 'Eigene Baureihe neben Primo GEN24 Plus; kein Datenblatt in der Datenbasis, deshalb keine Familie.' },
        { name: 'Symo GEN24 Plus', familie: 'fronius-symo-gen24-plus' },
        { name: 'Symo GEN24 Plus SC', familie: null,
          grund: 'Eigene Baureihe neben Symo GEN24 Plus; kein Datenblatt in der Datenbasis, deshalb keine Familie.' },
        { name: 'Symo Hybrid', familie: null,
          grund: 'Vorgängerbaureihe vor GEN24; kein Datenblatt in der Datenbasis. Führt in dieser Liste ausschließlich BYD Battery-Box Premium HVM.' },
        { name: 'Verto Plus', familie: 'fronius-verto-plus' },
      ],
    },
    'fronius-gen24-byd-lg': {
      titel: 'Fronius Batteriespeicherlösung mit GEN24 Plus, Kompatibilitäten und maximale Lade-/Entladeleistungen (BYD Battery-Box Premium HVS/HVM, LG RESU FLEX)',
      herausgeber: 'Fronius International GmbH (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Fronius_GEN24Plus_Batteriekompatibilität.pdf',
      /*
       * Geprueft 2026-09-07 (#92), Stand bleibt. Der Monitor fand dieselbe
       * Broschuere bei zwei Distributoren in 2024er-Upload-Ordnern. Das ist ein
       * Hosting-Datum, kein Versionscode — und ein Distributor traegt eine
       * Herstellerangabe ohnehin nicht allein (DATENPFLEGE, Abschluss-Checkliste).
       * Eine neuere Fassung bei Fronius selbst gibt es nicht; die aktuelle
       * Kompatibilitaetsaussage von Fronius fuehren wir ohnehin ueber
       * 'fronius-web' (Abruf 2026-08-28), das ist die juengere Quelle.
       */
      stand: 'DE v11 Nov 2022',
      abruf_datum: '2026-08-09',
      typ: 'hersteller',
    },
    'byd-v15': {
      titel: 'BYD Battery-Box HVB & HVM+ & HVS+ Compatible Inverter List V1.5',
      herausgeber: 'BYD Company Limited (Hersteller)',
      dokument: 'Datenblätter/Speicher/BYD HVS+ HVM+ HVB.pdf',
      stand: 'V1.5',
      abruf_datum: '2026-07-02',
      typ: 'hersteller',
    },
    /*
     * Loest die Fassung 04/2026 (DOC02048988-0035) ab. Das alte PDF bleibt im
     * Ordner liegen, damit die Vorgeschichte nachvollziehbar ist; Freigaben
     * zeigen nur noch hierher. Was 07/2026 aendert:
     *   - PLENTICORE BI 25 G3 kommt in fast jeder Zeile hinzu (Fussnote 12:
     *     nur EINE Batterie dieses Typs, keine Parallelschaltung).
     *   - Dyness Stack100 Pro bekommt die Groesse 15s — ausschliesslich fuer
     *     den BI 25 G3.
     *   - Sonst dieselben Freigaben, nur andere Seitenaufteilung.
     */
    /*
     * Nachfolger von 'kostal-0726' (07/2026), eingepflegt am 2026-09-07 aus dem
     * Quellen-Monitor 2026-W37 (#92). Die Version steht IM Dokument („Version:
     * 08 / 2026", Fußzeile jeder Seite „08 / 2026 - DE/EN - DOC02048988-0037") —
     * der Monitor hatte nur einen Suchtreffer-Titel und konnte die Datei wegen
     * ihrer Größe (10,7 MB) nicht öffnen.
     *
     * Beide Fassungen wurden Seite für Seite verglichen (22 Seiten, Textauszug
     * je Seite, Fußzeile ausgenommen). Inhaltlich unterscheiden sich genau zwei
     * Stellen, beide auf der Wechselrichter-Spalte:
     *
     *  - Seite 3, Dyness Tower (T7–T21): PLENTICORE BI 25 G3 ist GESTRICHEN.
     *    Die Zeile nennt jetzt nur noch plus, plus G2, BI xx/26, BI xx/26 G2,
     *    G3 und MP G3. Die zugehörige Freigabe ist entfernt (Rezept G:
     *    entfallene Kombinationen ersatzlos löschen) — sie war der einzige
     *    Beleg dafür, die Dyness-eigene Liste führt den BI 25 G3 nicht. Die
     *    Kombination heißt damit wieder „noch nicht bestätigt", nicht
     *    „inkompatibel" (Invariante 1).
     *  - Seite 4, PYLONTECH Force: Die bis 07/2026 gemeinsame Zelle für H1, H2
     *    und H3 10,24–25,6 ist geteilt. H1 und H2 verlieren dadurch den
     *    BI 25 G3, H3 10,24–25,6 behält ihn. Ohne Wirkung auf uns: Force H1 und
     *    H2 sind nicht geführt, und die H3-Zeilen standen bereits so da.
     *
     * Alle übrigen 20 Seiten sind zeichengleich. Damit ist jede Zeile dieser
     * Quelle gegen 08/2026 geprüft, nicht nur die geänderten.
     */
    /*
     * Die Freigabeliste zum Sunny Island X. Sie ist der Beleg dafuer, DASS die
     * Paarung gilt — die Leistungswerte stehen im Datenblatt daneben
     * ('sma-si-x-db'). Zwei Angaben dieser Liste gehoeren zur Freigabe-Aussage
     * und stehen deshalb in jeder einschraenkung (Invariante 1):
     *
     *   - Firmware: Batterie ab 00.00.121.R, Wechselrichter ab 3.07.09.R —
     *     fuer SI30-20 und SI50-20 gleichermassen.
     *   - Mindestkonfiguration: SI30-20 ab 7 Modulen, SI50-20 ab 12 Modulen.
     *     Das ist eine MINDESTzahl, keine Obergrenze; nach oben begrenzt die
     *     Batterie selbst (15 Module).
     *
     * On-Grid und Off-Grid sind beide angehakt, Kommunikation CAN.
     */
    'sma-si-x-batterien': {
      titel: 'SUNNY ISLAND X 30 / 50 — Zugelassene Batterien und Informationen zum Anschluss von Batterien',
      herausgeber: 'SMA Solar Technology AG (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/SMA Sunny Island X 30-50 Zugelassene Batterien SIxx-20-Batteries-TI-de-14.pdf',
      stand: 'SIxx-20-Batteries-TI-de-14 | Version 1.4',
      abruf_datum: '2026-09-07',
      typ: 'hersteller',
      /*
       * BEWUSST OHNE nennt_hersteller / nennt_geraete — und der Grund gehört
       * hierher, damit niemand es später als Versäumnis nachträgt:
       *
       * Beide Felder sind für Dokumente gebaut, die WECHSELRICHTER aufzählen;
       * `familie` wird gegen den Wechselrichter-Katalog aufgelöst und
       * `nennt_geraete` erscheint dem Kunden als „offenes Gerät" unter einem
       * Speicher. Diese Liste zählt umgekehrt BATTERIEN auf. Ein „BYD Maxlite"
       * als offenes Gerät unter dem Dyness-Turm wäre schlicht falsch.
       *
       * Die Gerätespalte steht deshalb hier im Text, vollständig, damit nichts
       * stillschweigend fehlt (DATENPFLEGE A.5b). Genauso hält es die
       * Schwesterquelle 'sma-approved-2026-02' — dieselbe Dokumentart,
       * derselbe Hersteller.
       *
       * Zugelassen laut Liste, mit Firmware-Stand:
       *   BYD       Maxlite                  Batterie ≥ 2.00.06
       *   Cegasa    E/Xpand, E/Scale         Batterie ≥ 1.21
       *   Dyness    Stack 100, Stack 100 Pro Batterie ≥ 00.00.121.R   ← eingepflegt
       *   Pylontech M1C (RackBMS 1.10), M5A ≥ 1.8
       *
       * Von diesen vier führen wir nur Dyness in den genannten Baureihen. BYD
       * Battery-Box Max Lite, Cegasa (Hersteller nicht geführt) und die
       * Pylontech-Rackreihen M1C/M5A sind nicht modelliert — sie sind
       * Arbeitsliste für Rezept D, nicht Auslassung.
       */
    },
    /*
     * Das Geraetedatenblatt zum Sunny Island X. Alle Leistungswerte der
     * Baureihe stammen aus seiner Tabelle "Technische Daten", nichts ist
     * gerechnet oder aus dem Produktnamen geschlossen — auch die 30 und 50 kW
     * nicht, die im Namen stehen.
     */
    'sma-si-x-db': {
      titel: 'SMA Sunny Island X 30 / 50 (SI30-20 / SI50-20) — Datenblatt',
      herausgeber: 'SMA Solar Technology AG (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/SMA Sunny Island X 30-50 Datenblatt SIxx-20-DS-de-21.pdf',
      stand: 'SIxx-20-DS-de-21',
      abruf_datum: '2026-09-07',
      typ: 'hersteller',
    },
    /*
     * Datenblatt des STACK100 Pro, Version unten links im Dokument gelesen.
     * Elektrisch ist der Pro je Modul identisch mit dem STACK100 (5,12 kWh,
     * 51,2 V, 100 Ah, empfohlen 0,5C = 50 A); er unterscheidet sich in Gehaeuse
     * und Aufstellung (IP66 statt IP20, natuerliche statt erzwungener Kuehlung,
     * bis zu 12 Cluster parallel). Deshalb dieselben Groessen und Werte — aber
     * als eigene Baureihe, weil die SMA-Freigabeliste beide getrennt nennt.
     */
    'dyness-stack100-pro-db': {
      titel: 'Dyness STACK100 Pro Datenblatt',
      herausgeber: 'Dyness (Hersteller)',
      dokument: 'Datenblätter/Speicher/Dyness STACK100 Pro Datenblatt 20251103-EN.pdf',
      stand: 'File version-20251103-EN',
      abruf_datum: '2026-09-07',
      typ: 'hersteller',
    },
    'kostal-0826': {
      titel: 'Freigegebene Batterien für PLENTICORE',
      herausgeber: 'KOSTAL Solar Electric (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Kostal Plenticore Komplettübersicht Freigegebene-Batterien-und-Anschluss-PLENTICORE 08-2026.pdf',
      stand: '08/2026 (DOC02048988-0037)',
      abruf_datum: '2026-09-07',
      typ: 'hersteller',
      nennt_hersteller: ['KOSTAL', 'AXITEC', 'BMZ', 'BYD', 'Dyness', 'LG', 'Pylontech', 'VARTA', 'ZYC'],
      /*
       * Die Geraetespalte des Dokuments, vollstaendig. Genau hier lag der
       * Fehler, der zu diesem Nachtrag gefuehrt hat: "PLENTICORE plus" steht in
       * fast jeder Zeile, aber es gab keine Familie dafuer — und weil KOSTAL als
       * MARKE laengst gefuehrt war, meldete `nennt_hersteller` nichts.
       * `familie: null` heisst: bewusst nicht gefuehrt, steht als Wortlaut in
       * den `einschraenkung`-Texten und ist die Arbeitsliste fuer spaeter.
       */
      nennt_geraete: [
        { name: 'PLENTICORE plus', familie: 'kostal-plenticore-plus-g1' },
        { name: 'PLENTICORE plus G2', familie: 'kostal-plenticore-plus-g2' },
        { name: 'PLENTICORE G3', familie: 'kostal-plenticore-g3' },
        { name: 'PLENTICORE BI 25 G3', familie: 'kostal-plenticore-bi-25-g3' },
        { name: 'PLENTICORE MP G3', familie: null },
        { name: 'PLENTICORE BI 5.5/13', familie: null },
        { name: 'PLENTICORE BI xx/26', familie: null },
        { name: 'PLENTICORE BI xx/26 G2', familie: null },
      ],
    },
    'kostal-g1-db': {
      titel: 'KOSTAL PLENTICORE plus Datenblatt (Hybrid-Wechselrichter 3.0–10 kW)',
      herausgeber: 'KOSTAL Solar Electric (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/DB_PLENTICORE-plus_de.pdf',
      stand: '11/2022 (DOC01904732)',
      abruf_datum: '2026-08-16',
      typ: 'hersteller',
    },
    'kostal-bi-g3-db': {
      titel: 'KOSTAL PLENTICORE BI 25 G3 Datenblatt (Batterie-Wechselrichter 25 kW)',
      herausgeber: 'KOSTAL Solar Electric (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/DB_PLENTICORE-BI-G3_de.pdf',
      stand: '06/2026 (DOC03698950)',
      abruf_datum: '2026-08-16',
      typ: 'hersteller',
    },
    'baywa-0226': {
      titel: 'BayWa r.e. Kompatibilitätsliste Stromspeicher',
      herausgeber: 'BayWa r.e. (Distributor, aggregiert Herstellerangaben)',
      dokument: 'Datenblätter/Speicher/BYD HVS HVM HVS+ HVM+ BayWa_r.e._Kompatibilitaetsliste_Feb_2026_deutsch_final.pdf',
      stand: '02/2026',
      abruf_datum: '2026-07-02',
      typ: 'distributor',
    },
    'kostal-g3-db': {
      titel: 'KOSTAL PLENTICORE G3 Datenblatt',
      herausgeber: 'KOSTAL Solar Electric (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Kostal Plenticore G3.pdf',
      stand: '09/2025 (DOC03090366)',
      abruf_datum: '2026-07-05',
      typ: 'hersteller',
    },
    /*
     * Ausgabe vom 10.02.2026, geholt am 2026-09-07 (#92). Der Monitor kannte
     * nur das CMS-Datum der Downloadseite („Last Updated February 10, 2026")
     * und kam an die Datei nicht heran — sie hängt hinter einem
     * JavaScript-Downloadknopf. Über den ist sie jetzt geholt und gelesen.
     *
     * ZUR VERSION, ehrlich: Diese Ausgabe trägt KEINEN Versionsvermerk mehr.
     * Die V3.0 hatte noch eine Änderungshistorie (1.0 / 2.0 / 3.0 mit
     * 2025.3 / 2025.4 / 2025.9), die neue Fassung hat sie ersatzlos gestrichen.
     * Der `stand` nennt deshalb das Datum der Downloadseite und sagt dazu,
     * woher es stammt — eine Versionsnummer zu erfinden, wäre schlimmer als
     * keine zu haben.
     *
     * INHALTLICH die wichtigste Änderung dieser Pflegerunde: Die Liste führt
     * 20 Wechselrichter-Marken statt 24. SAJ, Solplanet, GoodWe und Shinemann
     * sind ersatzlos raus, neu dazugekommen ist keine. Die vier Freigaben sind
     * entfernt (Begründung steht bei den Zeilen in freigaben.js). Die übrigen
     * 20 wurden Marke für Marke wiedergefunden; die Batterieseite ist
     * unverändert (LPBA/LPBF mit BMS V5, FLA-Serie).
     */
    'felicity-lv-liste': {
      titel: 'Felicity Solar Inverter matching list, Low voltage battery packs',
      herausgeber: 'Guangdong Felicity New Energy Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/Felicity Niedervolt Inverter matching list 10022026.pdf',
      stand: 'Ausgabe 10.02.2026 (Datum der Downloadseite; das Dokument selbst nennt keine Version mehr)',
      abruf_datum: '2026-09-07',
      typ: 'hersteller',
    },
    'felicity-fla-eu-db': {
    /*
     * Gegengeprüft 2026-09-07 (#92), Stand bleibt — mit einem Befund, der
     * wichtiger ist als jede Version:
     *
     * Die Fundstelle, die der Monitor für diese Quelle beobachtet
     * (felicitysolar.com/download/fla48100-fla48200-datasheet-en/), führt eine
     * ANDERE Baureihe. Dort stehen FLA48100 und FLA48200 ohne EU-Zusatz:
     * 10 kWh statt 8,75, Empfehlung „≤6.000 W", Garantie 7 Jahre. Unsere
     * Quelle ist das EU-Datenblatt mit FLA48100-EU / 48171-EU / 48230-EU /
     * 48250-EU, 10 Jahre Garantie. Der Monitor hat also monatelang das falsche
     * Dokument auf Änderungen beobachtet — deshalb blieb der Fund „Datum nicht
     * bestätigt" hängen. Korrigiert ist das in quellen-registry.js.
     *
     * Unsere Werte gegen das EU-Datenblatt gelesen und bestätigt: 5,12 / 8,75 /
     * 11,8 / 12,5 kWh nominal bei ≥95 % DoD (ergibt 4,86 / 8,31 / 11,21 /
     * 11,88 kWh nutzbar), Dauerstrom 100 / 120 / 150 / 150 A an 51,2 V (ergibt
     * 5,12 / 6,14 / 7,68 / 7,68 kW), 6000 Zyklen, 10 Jahre.
     */
      titel: 'Felicity Solar FLA48100-EU / 48171 / 48230 / 48250-EU Datenblatt',
      herausgeber: 'Guangzhou Felicity Solar Technology Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/Felicity FLA48100-48250-EU Datenblatt.pdf',
      stand: 'EN-Ausgabe',
      abruf_datum: '2026-07-29',
      typ: 'hersteller',
    },
    'felicity-fla280-db': {
    /*
     * Gegengeprüft 2026-09-07 (#92), Stand bleibt. Gleiche Verwechslung wie bei
     * felicity-fla-eu-db: Die beobachtete Fundstelle
     * (/download/fla48300-datasheet-en/) führt den FLA48300 OHNE EU-Zusatz —
     * 15 kWh, 300 Ah, 7 Jahre Garantie. Unser Dokument ist das EU-Datenblatt
     * mit FLA48280-EU / FLA48300-EU. Registry korrigiert.
     */
      titel: 'Felicity Solar FLA48280-EU / FLA48300-EU Datenblatt',
      herausgeber: 'Guangzhou Felicity Solar Technology Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/Felicity FLA48280-48300-EU Datenblatt.pdf',
      stand: 'EN-Ausgabe',
      abruf_datum: '2026-07-29',
      typ: 'hersteller',
    },
    'byd-hvb-db': {
      titel: 'BYD Battery-Box HVB Datenblatt',
      herausgeber: 'BYD Lithium Battery Co., Ltd (Hersteller)',
      dokument: 'Datenblätter/Speicher/BYD Battery-Box HVB Datenblatt V1.5 DE.pdf',
      stand: 'V1.5 DE (2026-06-03)',
      abruf_datum: '2026-08-24',
      typ: 'hersteller',
    },
    'axitec-sv-db': {
      titel: 'AXITEC AXIstorage Li SV1 / Li SV2 Datenblatt',
      herausgeber: 'AXITEC Energy GmbH & Co. KG (Hersteller)',
      dokument: 'Datenblätter/Speicher/AXITEC AXIstorage Li SV1 SV2 DB_storage_SV_DE.pdf',
      stand: 'LiSVDE260330',
      abruf_datum: '2026-07-29',
      typ: 'hersteller',
    },
    'deye-sg01hp3-db': {
      titel: 'Deye Dreiphasen-Hybrid-Wechselrichter SUN-5/6/8/10/12/15/20/25K-SG01HP3-EU-AM2',
      herausgeber: 'Ningbo Deye Inverter Technology Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Deye SUN 5-25K SG01HP3-EU-AM2 Datenblatt.pdf',
      stand: 'DE-Ausgabe',
      abruf_datum: '2026-07-29',
      typ: 'hersteller',
    },
    'deye-sg02hp3-em6-db': {
      titel: 'Deye Three Phase Hybrid Inverter SUN-60/70/75/80K-SG02HP3-EU-EM6',
      herausgeber: 'Ningbo Deye Inverter Technology Co., Ltd. (Hersteller)',
      /*
       * Neu geholt am 2026-09-07 (#92) vom Ablagepfad, den der Monitor gefunden
       * hatte — deye.com/wp-content/uploads/2025/10/. Die Datei liegt bei Deye
       * selbst, ist also kein Distributor-Fund; ein Versionscode steht nirgends
       * im Dokument, deshalb bleibt der `stand` beim Ablagedatum und sagt das.
       *
       * Der Gewinn liegt nicht in der Version, sondern im Inhalt: Diese Fassung
       * fuehrt den SUN-70K, den unsere bisherige nicht kannte. Damit hat er
       * einen belegten AC-Wert (70 kW) statt einer Luecke. Batterieseitig
       * unveraendert: Spannungsbereich 160-1000 V, max. Lade-/Entladestrom
       * 80+80 A.
       */
      dokument: 'Datenblätter/Wechselrichter/Deye SUN 60-80K SG02HP3-EU-EM6 Datasheet 202510.pdf',
      stand: 'EN-Ausgabe ohne Versionscode (Ablagepfad des Herstellers: 2025/10)',
      abruf_datum: '2026-09-07',
      typ: 'hersteller',
    },
    'kostal-plenticoin-fs': {
      titel: 'KOSTAL PLENTICOIN Factsheet, Produkterweiterungen und benötigte Coins',
      herausgeber: 'KOSTAL Solar Electric (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Kostal PLENTICOIN Factsheet DE V4.0.pdf',
      stand: '05/2024 - DE - Version 4.0',
      abruf_datum: '2026-07-29',
      typ: 'hersteller',
    },
    'kostal-g2-db': {
      titel: 'KOSTAL PLENTICORE plus G2 3.0–10 kW Datenblatt',
      herausgeber: 'KOSTAL Solar Electric (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/DB_PLENTICORE_plus-G2_de.pdf',
      stand: '02/2026 - DE - DOC01904732',
      abruf_datum: '2026-08-15',
      typ: 'hersteller',
    },
    'sma-stpse-db': {
      titel: 'SMA Sunny Tripower 5.0 / 6.0 / 8.0 / 10.0 Smart Energy Datenblatt',
      herausgeber: 'SMA Solar Technology AG (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/STPxx-3SE-40-DS-de-20.pdf',
      stand: 'DS-de-20, Datenstand 04/2023',
      abruf_datum: '2026-08-15',
      typ: 'hersteller',
    },
    'fronius-primo-gen24-db': {
      titel: 'Fronius Primo GEN24 & GEN24 Plus 3.0–6.0 kW Datenblatt',
      herausgeber: 'Fronius International GmbH (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/SE_DS_Fronius_Primo_GEN24_GEN24Plus_3_to_6_kW_DE.pdf',
      stand: 'DE V04 June 2025',
      abruf_datum: '2026-08-15',
      typ: 'hersteller',
    },
    'fronius-gen24-db': {
      titel: 'Fronius Symo GEN24 & GEN24 Plus 3.0–10.0 kW Datenblatt',
      herausgeber: 'Fronius International GmbH (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Fronius Symo Gen24 SE_DS_Fronius_Symo_GEN24_GEN24Plus_3_to_10_kW_DE.pdf',
      stand: 'aktuelle DE-Ausgabe',
      abruf_datum: '2026-07-05',
      typ: 'hersteller',
    },
    'fronius-verto-db': {
      titel: 'Fronius Verto Plus Datenblatt',
      herausgeber: 'Fronius International GmbH (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Fronius Verto Plus SE_DS_Fronius_Verto_Plus_DE.pdf',
      stand: 'aktuelle DE-Ausgabe',
      abruf_datum: '2026-07-05',
      typ: 'hersteller',
    },
    /*
     * Bis 2026-09-07 stand hier EIN Eintrag 'byd-hvs-hvm-db' auf das gemeinsame
     * Datenblatt V1.6 DE von 2022. BYD führt HVS und HVM inzwischen getrennt
     * (#92); beide DE-Fassungen sind am 2026-09-07 von bydbatterybox.com/downloads
     * geholt und Zeile für Zeile gegen unsere Werte gelesen worden. Deshalb hier
     * zwei Einträge statt einem — ein Beleg soll auf das Dokument zeigen, das
     * die Zahl trägt, nicht auf dessen Vorgänger.
     *
     * EHRLICH ZUR VERSION: Die Seite selbst druckt keinen Versionsvermerk. „V1.0
     * / 240703" steht ausschließlich im Dateinamen, und Dateinamen sind kein
     * gelesener Beleg (genau daran ist der AlphaESS-Fund derselben Woche
     * gescheitert). Der `stand` sagt das deshalb dazu, statt eine Sicherheit zu
     * behaupten, die die Seite nicht hergibt.
     */
    'byd-hvs-db': {
      titel: 'BYD Battery-Box Premium HVS Datenblatt (DE)',
      herausgeber: 'BYD Company Limited (Hersteller)',
      dokument: 'Datenblätter/Speicher/BYD BBOX_HVS_Datasheet_DE_V1.0_240703_L.pdf',
      stand: 'DE-Ausgabe ohne Versionsvermerk im Dokument (Datei: V1.0, 03.07.2024)',
      abruf_datum: '2026-09-07',
      typ: 'hersteller',
    },
    'byd-hvm-db': {
      titel: 'BYD Battery-Box Premium HVM Datenblatt (DE)',
      herausgeber: 'BYD Company Limited (Hersteller)',
      dokument: 'Datenblätter/Speicher/BYD BBOX_HVM_Datasheet_DE_V1.0_240703_L.pdf',
      stand: 'DE-Ausgabe ohne Versionsvermerk im Dokument (Datei: V1.0, 03.07.2024)',
      abruf_datum: '2026-09-07',
      typ: 'hersteller',
    },
    'byd-hvs-plus-db': {
      titel: 'BYD Battery-Box HVS+ Datenblatt',
      herausgeber: 'BYD Company Limited (Hersteller)',
      dokument: 'Datenblätter/Speicher/BYD HVS+.pdf',
      stand: 'V1.0 DE',
      abruf_datum: '2026-07-05',
      typ: 'hersteller',
    },
    'byd-hvm-plus-db': {
      titel: 'BYD Battery-Box HVM+ Datenblatt',
      herausgeber: 'BYD Company Limited (Hersteller)',
      dokument: 'Datenblätter/Speicher/BYD HVM+.pdf',
      stand: 'V1.0',
      abruf_datum: '2026-07-05',
      typ: 'hersteller',
    },
    'sungrow-sh-rt-db': {
      titel: 'Sungrow SH5.0/6.0/8.0/10RT-20 Datenblatt',
      herausgeber: 'Sungrow Power Supply Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Sungrow SH5.0-10RT-20 Datasheet V23 2024-01-11.pdf',
      stand: 'Version 23 (2024-01-11)',
      abruf_datum: '2026-08-24',
      typ: 'hersteller',
    },
    'fronius-reserva-db': {
      titel: 'Fronius Reserva Datenblatt',
      herausgeber: 'Fronius International GmbH (Hersteller)',
      dokument: 'Datenblätter/Speicher/Fronius Reserva Datenblatt_-_Datenblatt_01-2026.pdf',
      stand: '01/2026',
      abruf_datum: '2026-07-05',
      typ: 'hersteller',
    },
    'fronius-reserva-pro-db': {
      titel: 'Fronius Reserva Pro Datenblatt',
      herausgeber: 'Fronius International GmbH (Hersteller)',
      dokument: 'Datenblätter/Speicher/Fronius Reserva Pro Datenblatt SE_DS_Reserva_Pro_DE-German.pdf',
      // Fußzeile des Dokuments wörtlich; das Kürzel lautet auch in der
      // deutschen Ausgabe „EN_V02" (Fronius vergibt es je Layout, nicht je Sprache).
      stand: 'EN_V02 Jan 2026 (DE-Ausgabe)',
      abruf_datum: '2026-07-05',
      typ: 'hersteller',
    },
    'kostal-helivor-db': {
      titel: 'KOSTAL HELIVOR HV Datenblatt',
      herausgeber: 'KOSTAL Solar Electric (Hersteller)',
      dokument: 'Datenblätter/Speicher/Kostal HELIVOR HV Datenblatt DOC03862193 10-2025.pdf',
      stand: '10/2025 (DOC03862193)',
      abruf_datum: '2026-08-24',
      typ: 'hersteller',
    },
    // ---------- Neue Hersteller-Quellen (2026-07-05) ----------
    "alphaess-bat-3.8s": {
      titel: "AlphaESS STORION SMILE-G3-BAT-3.8S — Battery Datenblatt",
      herausgeber: "Alpha ESS Co., Ltd. (Hersteller)",
      dokument: "Datenblätter/Speicher/AlphaESS SMILE-G3-BAT-3.8S Datenblatt V03.07122023.pdf",
      stand: "V03. 07122023",
      abruf_datum: "2026-08-24",
      typ: "hersteller"
    },
    /*
     * Die Zeile "Module Compatibility" dieses Datenblatts IST die Freigabeliste
     * der 9.3S — AlphaESS pflegt die Freigaben am SPEICHER, die drei
     * Wechselrichter-Datenblaetter erwaehnen die 9.3S mit keinem Wort. Wortlaut:
     *
     *   G3-S3.6/S5/B5(1~4), G3-T4/5/6/8/10(1~6,8,10,12), G3-T12/15/20(2~6,8,10,12)
     *
     * Sie steht deshalb hier als `nennt_geraete`. Anlass war ein Fund vom
     * 2026-08-16: Beim Transkribieren am 2026-07-05 wurden vier der fuenf
     * T-Geraete angelegt, der T5 fiel lautlos aus. Die Familie gibt es, sie
     * traegt auch eine Freigabe aus dieser Quelle — die Pruefung auf
     * Familienebene schwieg also. Erst die Variantenspalte macht das sichtbar.
     */
    "alphaess-bat-9.3s": {
      titel: "AlphaESS STORION SMILE-G3-BAT-9.3S — Battery Datenblatt",
      herausgeber: "Alpha ESS Co., Ltd. (Hersteller)",
      dokument: "Datenblätter/Speicher/AlphaESS Smile G3-9.3 Datenblatt.pdf",
      stand: "V09.04292025",
      abruf_datum: "2026-07-05",
      typ: "hersteller",
      nennt_geraete: [
        /*
         * `gilt_fuer` sagt, fuer welchen Speicher die Nennung gilt — hier fuer
         * alle, denn die Zeile "Module Compatibility" steht im Datenblatt genau
         * dieser Batterie. Ohne dieses Feld bleibt ein Eintrag reine
         * Arbeitsliste und erscheint dem Kunden nicht: Dass ein Dokument
         * irgendwo ein Geraet nennt, ist noch keine Freigabe fuer diese
         * Paarung (Invariante 1).
         */
        { name: "G3-S3.6", familie: null,
          gilt_fuer: ["alphaess-smile-g3-bat-9.3s"],
          grund: "Einphasiges Gerät, kein Datenblatt vorhanden." },
        { name: "G3-S5", familie: "alphaess-smile-g3-s5", variante: "g3-s5" },
        { name: "G3-B5", familie: null,
          gilt_fuer: ["alphaess-smile-g3-bat-9.3s"],
          grund: "AC-gekoppeltes Gerät, kein Datenblatt vorhanden." },
        { name: "G3-T4", familie: "alphaess-smile-g3-t4-t10", variante: "g3-t4" },
        /*
         * Der Fund. Bestaetigt durch die Broschuere AlphaESS_Brochure_Global_2026,
         * Seite 15: Der T5 steht in der Drei-Phasen-Tabelle als eigene Spalte
         * mit 5 kW. Bis 2026-09-07 fehlte das Datenblatt dazu, also blieb er
         * ein offenes Geraet — geschaetzt wurde nichts. Mit V09.15012025 des
         * T4-T10-Datenblatts ist er belegt: eigene Modellspalte
         * "SMILE-G3-T5", 5 kW Nennleistung, 5 kW max. Lade-/Entladeleistung.
         * Damit ist die Luecke geschlossen, ohne dass jemand rechnen musste.
         */
        { name: "G3-T5", familie: "alphaess-smile-g3-t4-t10", variante: "g3-t5" },
        { name: "G3-T6", familie: "alphaess-smile-g3-t4-t10", variante: "g3-t6" },
        { name: "G3-T8", familie: "alphaess-smile-g3-t4-t10", variante: "g3-t8" },
        { name: "G3-T10", familie: "alphaess-smile-g3-t4-t10", variante: "g3-t10" },
        { name: "G3-T12", familie: "alphaess-smile-g3-t12-t20", variante: "g3-t12" },
        { name: "G3-T15", familie: "alphaess-smile-g3-t12-t20", variante: "g3-t15" },
        { name: "G3-T20", familie: "alphaess-smile-g3-t12-t20", variante: "g3-t20" },
      ],
    },
    "alphaess-bat-10.1p-statement": {
      titel: "AlphaESS Compatibility Statement of Battery SMILE-G3-BAT-10.1P series",
      herausgeber: "Alpha ESS Co., Ltd. (Hersteller)",
      dokument: "Datenblätter/Speicher/AlphaESS G3 CompatibilityStatementofBatterySMILE-G3-BAT-10.1P.pdf",
      stand: "Nantong, 2022-07-12",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    /*
     * Stand am 2026-09-07 erstmals IM Dokument gelesen (Fußzeile
     * "V09.15012025"), Quellen-Monitor 2026-W37 (#92). Der Monitor hatte aus
     * dem Dateinamen "20250415" geschlossen — das ist nicht die Version des
     * Dokuments, sondern nur der Ablagepfad. Genau davor warnt die Registry bei
     * AlphaESS, und hier lag sie richtig: Das Dokument sagt 15.01.2025.
     *
     * Werte gegen die neue Fassung geprüft: Nennleistung 4/5/6/8/10 kW und
     * max. Lade-/Entladeleistung 4/5/6/8/10 kW bei 40 A Batteriestrom —
     * unverändert gegenüber unserem Stand. Neu belegt ist der G3-T5 (siehe
     * alphaess-bat-9.3s): Er steht mit eigener Spalte in der Modelltabelle
     * ("SMILE-G3-T5"), damit ist die Lücke "kein Datenblatt vorhanden"
     * geschlossen.
     */
    "alphaess-smile-g3-t4-t10": {
      titel: "AlphaESS STORION SMILE-G3-T4-T10 — Hybrid-Wechselrichter Datenblatt",
      herausgeber: "Alpha ESS Europe GmbH (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/AlphaESS SMILE-G3-T4-T10 Datenblatt V09.15012025.pdf",
      stand: "V09.15012025",
      abruf_datum: "2026-09-07",
      typ: "hersteller"
    },
    /*
     * V07.24072024 → V2.1.16102025, gelesen in der Fußzeile des Dokuments
     * (2026-09-07, #92). AlphaESS hat mit dieser Fassung die Versionszählung
     * gewechselt (V09/V10.MMTTJJJJ → V2.1.TTMMJJJJ) — deshalb ist "2.1" hier
     * NEUER als "07", auch wenn die Zahl kleiner aussieht. In Suchtreffern
     * kursierte zusätzlich eine "V09/07092025"; die steht nicht in diesem
     * Dokument und wurde nicht übernommen.
     *
     * Werte geprüft und unverändert: Nennleistung 12/15/20 kW, max. Lade-/
     * Entladeleistung 12/15/20 kW, Batteriestrom 60 A.
     */
    "alphaess-smile-g3-t12-t20": {
      titel: "AlphaESS SMILE-G3-T12/T15/T20 — Hybrid-Wechselrichter Datenblatt",
      herausgeber: "Alpha ESS Europe GmbH (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/AlphaESS SMILE-G3-T12 T15 T20 Datenblatt V2.1.16102025.pdf",
      stand: "V2.1.16102025",
      abruf_datum: "2026-09-07",
      typ: "hersteller"
    },
    /*
     * BEWUSST NICHT nachgezogen (2026-09-07, #92). Der Monitor fand ein
     * eigenständiges T15/T20-Dokument mit "V09.04162025" — geöffnet und in der
     * Fußzeile bestätigt, aber es liegt bei einem Distributor
     * (alphaess.solshare.nl), nicht bei AlphaESS. Zwei Gründe, es so zu lassen:
     *
     *  1. Ein Distributor-Beleg trägt eine Herstellerangabe nicht allein
     *     (DATENPFLEGE, Abschluss-Checkliste).
     *  2. Die offizielle Fassung führt T15 und T20 inzwischen im gemeinsamen
     *     Dokument T12/T15/T20 (V2.1.16102025, siehe oben) — die eigenständige
     *     Reihe wird vom Hersteller offenbar nicht mehr gepflegt.
     *
     * Diese Quelle bleibt deshalb mit ihrem alten, belegten Stand stehen und
     * dient nur noch als Zweitbeleg im spec_hinweis der Baureihe. Sie zu
     * ersetzen wäre erst richtig, wenn AlphaESS selbst eine neuere Fassung
     * veröffentlicht.
     */
    "alphaess-smile-g3-t15-t20": {
      titel: "AlphaESS SMILE-G3-T15/T20 — Hybrid-Wechselrichter Datenblatt",
      herausgeber: "Alpha ESS Europe GmbH (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/AlphaESS SMILE-G3-T15 T20 Datenblatt.pdf",
      stand: "V10.02222024",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "alphaess-smile-hi10": {
      titel: "AlphaESS STORION SMILE-Hi10 — Hybrid-Wechselrichter Datenblatt",
      herausgeber: "Alpha ESS Europe GmbH (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/AlphaESS SMILE-Hi10 Datenblatt.pdf",
      stand: "Datenblatt SMILE-Hi10",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "alphaess-smile-hi5": {
      titel: "AlphaESS STORION SMILE-Hi5 — Hybrid-Wechselrichter Datenblatt",
      herausgeber: "Alpha ESS Europe GmbH (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/AlphaESS SMILE-Hi5 Datenblatt.pdf",
      stand: "Datenblatt SMILE-Hi5",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "alphaess-smile-g3-s5": {
      titel: "AlphaESS STORION SMILE-G3-S5 — Hybrid-Wechselrichter Datenblatt",
      herausgeber: "Alpha ESS Europe GmbH (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/AlphaESS SMILE-G3-S3.6-S5-B5 Datenblatt V07.13122024.pdf",
      stand: "V07.13122024",
      abruf_datum: "2026-08-24",
      typ: "hersteller"
    },
    "huawei-luna2000-s1": {
      titel: "Huawei LUNA2000-7/14/21-S1 Smart String Energy Storage System Datasheet",
      herausgeber: "Huawei Technologies (Hersteller)",
      dokument: "Datenblätter/Speicher/Huawei LUNA2000-5-21-S1 Datasheet 01-202509.pdf",
      stand: "Version 01-202509",
      abruf_datum: "2026-08-24",
      quelle_hinweis: "Huawei liefert das Blatt im Document Center nur nach Anmeldung aus; "
        + "abgerufen ueber den Distributor-Spiegel ske-solar.com. Ausstellerangabe im Dokument: "
        + "Huawei. Die Fassung 01-202509 fuehrt zusaetzlich 5-kWh-Module (Groessen 5 bis 20,7 kWh); "
        + "aufgenommen sind weiterhin nur die Groessen, fuer die eine Freigabeliste vorliegt.",
      typ: "hersteller"
    },
    "huawei-luna2000-s0": {
      titel: "Huawei LUNA2000-5/10/15-S0 Smart String Energy Storage System, Technical Specification",
      herausgeber: "Huawei Technologies (Hersteller)",
      dokument: "Datenblätter/Speicher/Huawei LUNA2000-5-10-15-S0 Datasheet 01-202411.pdf",
      stand: "Version 01-202411",
      abruf_datum: "2026-09-14",
      quelle_hinweis: "Oeffentlicher Download von solar.huawei.com (kein Login noetig). "
        + "Fussnote 6 zur Zeile \"Compatible inverters\": \"Please contact a local engineer for "
        + "compatibility information.\" Eine Ladeleistung nennt das Blatt nicht.",
      typ: "hersteller",
      nennt_hersteller: ["Huawei"],
      /*
       * Zeile „Compatible inverters", vollstaendig. Vier der sieben Baureihen
       * fuehrt der Katalog nicht — Arbeitsliste statt stilles Weglassen
       * (DATENPFLEGE A.5b).
       */
      nennt_geraete: [
        { name: "SUN2000-3/4/5/6/8/10KTL-M1", familie: "huawei-sun2000-m1" },
        { name: "SUN2000-12/15/17/20/25K-MB0", familie: "huawei-sun2000-mb0" },
        { name: "SUN2000-5/6/8/10/12K-MAP0", familie: "huawei-sun2000-map0" },
        { name: "SUN2000-2/3/3.68/4/4.6/5/6KTL-L1", familie: null,
          grund: "Einphasige Baureihe; kein Datenblatt in der Datenbasis, deshalb keine Familie." },
        { name: "SUN2000-8/10K-LC0", familie: null,
          grund: "Einphasige Baureihe; kein Datenblatt in der Datenbasis, deshalb keine Familie." },
        { name: "SUN5000-8/12K-MAP0", familie: null,
          grund: "Eigene SUN5000-Serie neben SUN2000-MAP0; kein Datenblatt in der Datenbasis, deshalb keine Familie." },
        { name: "SUN5000-17/25K-MB0", familie: null,
          grund: "Eigene SUN5000-Serie neben SUN2000-MB0; kein Datenblatt in der Datenbasis, deshalb keine Familie." }
      ]
    },
    "huawei-sun2000-mb0": {
      titel: "Huawei SUN2000-12/15/17/20/25K-MB0 Smart Energy Controller Datasheet",
      herausgeber: "Huawei Technologies (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/Huawei SUN Inverter Datasheet.pdf",
      stand: "Version 01-202411",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "sma-stpse-batteries": {
      titel: "SMA Sunny Tripower Smart Energy — Zugelassene Batterien und Batteriekommunikationsanschluss (Technische Information)",
      herausgeber: "SMA Solar Technology AG (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/SMA Sunny Tripower Smart Energy Datenblatt.pdf",
      stand: "STPSE-Batteries-TI-de-14 | Version 1.4 (Stand Batterie-Zulassung: 10/2024)",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "sma-stp-hybrid-x-klein": {
      titel: "SMA Sunny Tripower Hybrid X 5/6/8/10/12/15 Datenblatt",
      herausgeber: "SMA Solar Technology AG (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/SMA Synn Tripower X Datenblatt.pdf",
      stand: "STPHxx-60-DS-de-10 | Stand 06/2026",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "sma-stp-hybrid-x-gross": {
      titel: "SMA Sunny Tripower Hybrid X 20/25/30 Datenblatt (preliminary)",
      herausgeber: "SMA Solar Technology AG (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/SMA Synn Tripower X Groß Datenblatt.pdf",
      stand: "STPHxx-70-DS-de-02 | Stand 05/2026 (preliminary)",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "dyness-tower-pro-datenblatt": {
      titel: "Dyness Tower Pro Datasheet",
      herausgeber: "Dyness (Hersteller)",
      /*
       * Nachgezogen 2026-09-07 (#92). "File version-20251030-EN" steht unten
       * links IM Dokument — der Monitor sah nur den Ablagepfad (20251124) und
       * konnte die Datei nicht lesen, sie ist bildbasiert.
       *
       * Werte gegengelesen und Zeile für Zeile gleich: Modul HV9640 mit
       * 3,84 kWh / 96 V / 40 Ah, 2-6 Module, nutzbar 7,296 / 10,944 / 14,592 /
       * 18,24 / 21,888 kWh bei 95 % DoD, max. Lade-/Entladeleistung 7,68 /
       * 11,52 / 15,36 / 19,2 / 23,04 kW. Es aendert sich also nichts ausser
       * Version und Sprache.
       *
       * Die deutsche Fassung 20250422-DE ist von der Downloadseite
       * verschwunden (Registry-Hinweis vom 2026-08-16) und liegt weiter im
       * Ordner daneben. Zitiert wird jetzt die englische: Ein Beleg, den der
       * Kunde nicht mehr aufrufen kann, ist der schlechtere Beleg.
       */
      dokument: "Datenblätter/Speicher/Dyness Tower Pro Datenblatt 20251030-EN.pdf",
      stand: "File version-20251030-EN (Vorgaenger 20250422-DE liegt daneben)",
      abruf_datum: "2026-09-07",
      typ: "hersteller"
    },
    "dyness-tower-pro-compat": {
      titel: "List of the Inverter Brands Compatible with Dyness Tower Pro Series",
      herausgeber: "Dyness (Hersteller)",
      dokument: "Datenblätter/Speicher/Dyness Tower Pro DynessTowerProSeriesCompatibilityList.pdf",
      stand: "Last updated 16/10/2025",
      abruf_datum: "2026-07-05",
      typ: "hersteller",
      nennt_hersteller: [
        'Afore', 'ATESS', 'Autarco', 'Bluesun', 'Deye', 'DUNEXT', 'Ecactus', 'GoodWe',
        'Hopewind', 'Hoymiles', 'HYPONTECH', 'Ingeteam', 'Jinko', 'KACO', 'KOYOE',
        'Megarevo', 'RENAC', 'SAJ', 'Senergy', 'SERMATEC', 'SINENG', 'Sinexcel',
        'SOLINTEG', 'Solis', 'SOSEN', 'Sunways', 'TBB power', 'Thinkpower', 'KOSTAL',
      ]
    },
    "dyness-tower-s2-datenblatt": {
      titel: "Dyness Tower Datasheet",
      herausgeber: "Dyness (Hersteller)",
      dokument: "Datenblätter/Speicher/Dyness Tower S2 TowerDatasheetDE20250422.pdf",
      stand: "Dateiversion 20250421-DE",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "dyness-tower-s2-compat": {
      titel: "List of the Inverter Brands Compatible with Dyness Tower Series",
      herausgeber: "Dyness (Hersteller)",
      dokument: "Datenblätter/Speicher/Dyness Tower S2 Kompatible Wechselrichter.pdf",
      stand: "Last updated 09/10/2025",
      abruf_datum: "2026-07-05",
      typ: "hersteller",
      nennt_hersteller: [
        'Afore', 'ATESS', 'Autarco', 'Bluesun', 'Deye', 'DUNEXT', 'Ecactus', 'GoodWe',
        'Hopewind', 'Hoymiles', 'HYPONTECH', 'Ingeteam', 'Jinko', 'KACO', 'KOYOE',
        'Megarevo', 'RENAC', 'SAJ', 'Senergy', 'SERMATEC', 'SINENG', 'Sinexcel',
        'SOLINTEG', 'Solis', 'SOSEN', 'Sunways', 'TBB power', 'Thinkpower', 'KOSTAL', 'Solplanet',
      ]
    },
    "dyness-tower-s3-datenblatt": {
      titel: "Dyness Tower S3 Datasheet",
      herausgeber: "Dyness (Hersteller)",
      dokument: "Datenblätter/Speicher/Dyness Tower S3 TowerS3DatasheetEN20250729-801.pdf",
      stand: "File version 20250729-EN",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "dyness-tower-s3-compat": {
      titel: "List of the Inverter Brands Compatible with Dyness Tower S3 Series",
      herausgeber: "Dyness (Hersteller)",
      dokument: "Datenblätter/Speicher/Dyness Tower S3 Series Compatibility List 20251208.pdf",
      stand: "Last updated 08/12/2025",
      abruf_datum: "2026-07-05",
      typ: "hersteller",
      nennt_hersteller: [
        'Afore', 'ATESS', 'Autarco', 'Bluesun', 'Deye', 'DUNEXT', 'Ecactus', 'GoodWe',
        'Hopewind', 'Hoymiles', 'HYPONTECH', 'Ingeteam', 'Jinko', 'KACO', 'KOYOE',
        'Megarevo', 'RENAC', 'SAJ', 'Senergy', 'SERMATEC', 'SINENG', 'Sinexcel',
        'SOLINTEG', 'Solis', 'SOSEN', 'Sunways', 'TBB power', 'Thinkpower',
      ]
    },
    "goodwe-esa-3-10-db": {
      titel: "GoodWe ESA Series 3-10kW/5-108kWh — Single Phase Home Storage Solution (HV)",
      herausgeber: "GoodWe (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/GoodWe GW_ESA-3-10kW_Datasheet-EN.pdf",
      stand: "GoodWe-Single page-20260616-EN-V2.1",
      abruf_datum: "2026-08-09",
      typ: "hersteller",
      nennt_hersteller: ['GoodWe']
    },
    "goodwe-esa-5-30-db": {
      titel: "GoodWe ESA Series 5-30kW/5-108kWh — Three Phase Energy Storage Solution (HV)",
      herausgeber: "GoodWe (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/GoodWe GW_ESA-5-30kW_Datasheet-EN.pdf",
      stand: "GoodWe-Single page-20260616-EN-V2.1",
      abruf_datum: "2026-08-09",
      typ: "hersteller",
      nennt_hersteller: ['GoodWe']
    },
    /*
     * Vier GoodWe-Datenblaetter, am 2026-08-10 vom Auftraggeber geliefert. Sie
     * schliessen Leistungsluecken bei Baureihen, die bisher nur aus fremden
     * Kompatibilitaetslisten bekannt waren — Freigaben gab es, Zahlen nicht.
     *
     * Kein `nennt_hersteller`: Ein Geraete-Datenblatt sagt, was das Geraet kann,
     * nicht welche Speicher freigegeben sind. Der Listen-Abgleich prueft nur
     * Kompatibilitaetslisten.
     */
    "goodwe-et-g2-6-15-db": {
      titel: "GoodWe ET G2 Series 6-15kW — Three Phase Hybrid Inverter (HV) — Datasheet",
      herausgeber: "GoodWe (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/GoodWe GW_ET-G2-6-15kW_Datasheet-EN.pdf",
      stand: "GoodWe-Single page-20250528-EN-V2.1",
      abruf_datum: "2026-08-10",
      typ: "hersteller",
    },
    "goodwe-et-15-30-db": {
      titel: "GoodWe ET Series 15-30kW — Three Phase Hybrid Inverter (HV) — Datasheet EMEA",
      herausgeber: "GoodWe (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/GoodWe GW_ET-15-30kW_Datasheet-EN.pdf",
      stand: "GoodWe-Single page-20240417-EMEA-EN-V1.1",
      abruf_datum: "2026-08-10",
      typ: "hersteller",
    },
    "goodwe-et-40-50-db": {
      titel: "GoodWe ET50 Series 40-50kW — C&I Hybrid Inverter — Datasheet EMEA",
      herausgeber: "GoodWe (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/GoodWe GW_ET-40-50kW_Datasheet-EN.pdf",
      stand: "GoodWe-Single page-20251022-EN-EMEA-V1.1",
      abruf_datum: "2026-08-10",
      typ: "hersteller",
    },
    "goodwe-eh-plus-db": {
      titel: "GoodWe EH PLUS+ Serie 3,6-6kW — Einphasiger Hybrid-Wechselrichter (HV) — Datenblatt",
      herausgeber: "GoodWe (Hersteller)",
      dokument: "Datenblätter/Wechselrichter/GoodWe GW_EH-PLUS-3.6-6kW_Datenblatt-DE.pdf",
      stand: "GoodWe-Single page-20221011-DE-EMEA-V1.2",
      abruf_datum: "2026-08-10",
      typ: "hersteller",
    },
    "varta-wall-bm2-db": {
      titel: "VARTA.wall BM2 — Datenblatt",
      herausgeber: "VARTA AG (Hersteller)",
      dokument: "Datenblätter/Speicher/VARTA.wall BM2 Datenblatt DBWALLBM2DE02.pdf",
      stand: "DBWALLBM2DE02",
      abruf_datum: "2026-08-09",
      typ: "hersteller",
      nennt_hersteller: ['VARTA', 'KOSTAL', 'SMA']
    },
    /*
     * Am 2026-08-16 beschafft, weil die gemeinsame Broschuere fuer BM1 keinen
     * Strom nennt und ihre Leistungsangabe (5 / 7,5 / 10 kW) ein gerundeter
     * gemeinsamer Wert fuer beide Richtungen ist. Das Einzeldatenblatt fuehrt
     * "22 A / 26 A" und zwei Leistungen je Groesse — Laden und Entladen sind
     * verschieden. Bezogen von varta-ag.com.
     */
    "varta-wall-bm1-db": {
      titel: "VARTA.wall BM1 — Datenblatt",
      herausgeber: "VARTA AG (Hersteller)",
      dokument: "Datenblätter/Speicher/VARTA.wall BM1 Datenblatt DBWALLBM1DE01.pdf",
      stand: "DBWALLBM1DE01",
      abruf_datum: "2026-08-16",
      typ: "hersteller",
    },
    "varta-wall-bm1-bm2-broschuere": {
      titel: "VARTA.wall BM1 / BM2 — Produktbroschüre mit technischen Daten",
      herausgeber: "VARTA Storage GmbH, ein Unternehmen der VARTA AG (Hersteller)",
      dokument: "Datenblätter/Speicher/VARTA.wall BM1 BM2 Broschuere BROWALLBM12DE01.pdf",
      stand: "BROWALLBM12DE01",
      abruf_datum: "2026-08-09",
      typ: "hersteller",
      /*
       * Bewusst OHNE nennt_hersteller: Die Broschuere ist ein Datenblatt, keine
       * Kompatibilitaetsliste. Sie nennt unter "Kompatible Wechselrichter" nur
       * "Kostal, SMA, Steca" und verweist mit Fussnote 3 auf die eigentliche
       * Kompatibilitaetsliste. Aus einem blossen Markennamen ohne Modell darf
       * keine Freigabe entstehen — dafuer stehen die KOSTAL- und SMA-Listen.
       */
    },
    "zyc-simpo-hv-db": {
      titel: "ZYC SIMPO HV — Produktflyer mit technischen Daten (DE)",
      herausgeber: "ZYC Energy (Hersteller)",
      dokument: "Datenblätter/Speicher/ZYC SIMPO HV Flyer DE 260408.pdf",
      stand: "260408 (DE)",
      abruf_datum: "2026-08-09",
      typ: "hersteller"
    },
    "zyc-simpo-hv-compat": {
      titel: "SIMPO HV — Inverters Compatibility List",
      herausgeber: "ZYC Energy Co., Ltd. (Hersteller)",
      dokument: "Datenblätter/Speicher/ZYC SIMPO HV Inverters Compatibility List V1.3.pdf",
      stand: "V1.3 (Released 2025-01-13)",
      abruf_datum: "2026-08-09",
      typ: "hersteller",
      nennt_hersteller: ['KOSTAL', 'Solis', 'GoodWe', 'SOLINTEG']
    },
    "dyness-stack100-datenblatt": {
      titel: "Dyness STACK100 — Datenblatt",
      herausgeber: "Dyness (Hersteller)",
      /*
       * NICHT nachgezogen, und das ist der Fund (2026-09-07, #92): Der Monitor
       * meldete eine neuere Fassung unter
       * .../20250227/STACK100datasheetENSEAPAK.pdf. Geoeffnet und gelesen sagt
       * sie zweierlei, was aus dem Dateinamen nicht hervorging:
       *
       *   - "File version-20250207-EN(SEA)" — nicht 20250227, das war das
       *     Ablagedatum.
       *   - Direkt unter der Tabelle: "This specification is only suitable for
       *     Southeast Asia".
       *
       * Das ist keine neuere Fassung unseres Dokuments, sondern eine andere
       * Regionalausgabe ("SEAPAK" im Dateinamen heisst genau das). Sie zu
       * uebernehmen haette europaeische Angaben durch suedostasiatische
       * ersetzt. Unser Stand 20241218-EN bleibt.
       */
      dokument: "Datenblätter/Speicher/Dyness STACK100 Datenblatt 20241218-EN.pdf",
      stand: "File version-20241218-EN",
      abruf_datum: "2026-08-09",
      typ: "hersteller"
    },
    "dyness-stack100-compat": {
      titel: "List of the Inverter Brands Compatible with Dyness STACK 100 Series",
      herausgeber: "Dyness (Hersteller)",
      dokument: "Datenblätter/Speicher/Dyness STACK100 Series Compatibility List 20250928.pdf",
      stand: "Last updated 28/09/2025",
      abruf_datum: "2026-08-09",
      typ: "hersteller",
      nennt_hersteller: [
        'ATESS', 'Deye', 'DUNEXT', 'GoodWe', 'Growatt', 'Hoymiles', 'Ingeteam', 'KOSTAL',
        'KOYOE', 'Megarevo', 'SAJ', 'Senergy', 'SERMATEC', 'SINENG', 'Sinexcel', 'SOLINTEG',
        'Solis', 'Solplanet', 'SOSEN', 'Sunways', 'TBB power',
      ]
    },
    "zyc-simpo5000-db": {
      titel: "ZYC SIMPO 5000 — Produktflyer mit technischen Daten (DE)",
      herausgeber: "ZYC Energy (Hersteller)",
      dokument: "Datenblätter/Speicher/ZYC SIMPO 5000 Flyer DE 260410.pdf",
      stand: "260410 (DE)",
      abruf_datum: "2026-08-09",
      typ: "hersteller"
    },
    "zyc-simpo5000-statement": {
      titel: "ZYC SIMPO5000 Inverter Compatibility Statement",
      herausgeber: "ZYC Energy Co., Ltd. (Hersteller)",
      dokument: "Datenblätter/Speicher/ZYC SIMPO5000 Inverter Compatibility Statement 2024-04-22.pdf",
      stand: "2024-04-22 (gezeichnet, Product Director)",
      abruf_datum: "2026-08-09",
      typ: "hersteller",
      nennt_hersteller: ['SMA', 'Victron', 'Selectronic', 'Studer', 'Deye', 'GoodWe', 'Noark']
    },
    "pylontech-hv-v243": {
      titel: "Compatibility List of Pylontech High Voltage ESS and Inverters Ver.2.43",
      herausgeber: "Pylontech (Hersteller)",
      dokument: "Datenblätter/Speicher/Pylontech High Voltage ESS Compatibility List V2.43.pdf",
      stand: "Ver.2.43 (Last Update 2026/5/1)",
      abruf_datum: "2026-08-09",
      typ: "hersteller"
      /*
       * Bewusst OHNE nennt_hersteller: Die Liste fuehrt rund 60 Zeilen von ueber
       * 40 Marken, und bei etlichen weicht die Modellbezeichnung von unserer ab
       * (Ingeteam "ISS 1Play 3TL" gegen unser "INGECON SUN STORAGE 3TL~6TLM",
       * Solis "S6-EH3P(5-10)K-H-EU" gegen unser "K2-H(EU)", Sofar HYD TL-3PH
       * gegen unsere Niedervolt-HYD-EP). Wer hier eine Markenspalte eintraegt,
       * behauptet, alle Zeilen geprueft zu haben. Nachtragen, sobald die
       * offenen Bezeichnungen geklaert sind.
       */
    },
    "growatt-ark-2.5h-a2-datasheet": {
      titel: "Growatt ARK HV Battery System — ARK 2.5H-A2 Datasheet",
      herausgeber: "Shenzhen Growatt New Energy Co., Ltd. (Hersteller)",
      dokument: "Datenblätter/Speicher/Growatt ARK 2.5H-A2-Battery-Datasheet-EN.pdf",
      stand: "ARK 2.5H-A2 / EN",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "growatt-ark-a1-a2-declaration": {
      titel: "Growatt ARK Battery A1/A2 Versions Differences Declaration",
      herausgeber: "Shenzhen Growatt New Energy Co., Ltd. (Hersteller)",
      dokument: "Datenblätter/Speicher/Growatt ARK A1 A2 Versions_Differences_Declaration.pdf",
      stand: "A1/A2 Versions Differences Declaration",
      abruf_datum: "2026-07-05",
      typ: "hersteller"
    },
    "growatt-compatibility-list-lv48": {
      titel: "Growatt Approved LV Battery List (Growatt-LV48-0009)",
      herausgeber: "Shenzhen Growatt New Energy Co., Ltd. (Hersteller)",
      dokument: "Datenblätter/Speicher/Growatt Approved LV Battery List LV48-0015 2025-11-13.pdf",
      stand: "Growatt-LV48-0015 / 2025-11-13",
      abruf_datum: "2026-08-24",
      quelle_hinweis: "Growatt liefert die Liste auf en.growatt.com/download nicht mehr aus; "
        + "abgerufen ueber den Distributor-Spiegel hungvietgt.com. Das Dokument selbst ist von "
        + "Growatt ausgestellt (Kopf: „Issued by: ShenZhen Growatt New Energy Co.,Ltd.\"), der "
        + "Spiegel ist nur der Abrufweg und begruendet keine Freigabe.",
      typ: "hersteller"
    },
    'sungrow-sh-t-db': {
      titel: 'Sungrow SH15/20/25T Hybrid Three Phase Inverter, Datasheet',
      herausgeber: 'Sungrow Power Supply Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/SH15_20_25T_Datasheet.pdf',
      stand: 'Version 3 (© 2024)',
      abruf_datum: '2026-07-30',
      typ: 'hersteller',
    },
    'sungrow-sbh-db': {
      titel: 'Sungrow SBH100/150/200/250/300/350/400 High Voltage LFP Battery, Datasheet (IEC)',
      herausgeber: 'Sungrow Power Supply Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/Sungrow SBH100-400 Datasheet V4 2024-03-29.pdf',
      stand: 'Version 4 (2024-03-29)',
      abruf_datum: '2026-08-24',
      typ: 'hersteller',
    },
    'sungrow-sbr-db': {
      titel: 'Sungrow SBR064–256 Hochspannungs-LFP-Batterie, Datenblatt (DE)',
      herausgeber: 'Sungrow Power Supply Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/Datenblatt_Sungrow_SBR_Battery_Series.pdf',
      stand: 'Version 4 (© 2024)',
      abruf_datum: '2026-07-30',
      typ: 'hersteller',
    },
    'growatt-mid-xh-db': {
      titel: 'Growatt MID 11~30KTL3-XH, Datenblatt (DE)',
      herausgeber: 'Shenzhen Growatt New Energy Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Growatt-MID.pdf',
      stand: 'Preliminary (DE-Ausgabe, undatiert)',
      abruf_datum: '2026-07-30',
      typ: 'hersteller',
    },
    'growatt-apx-db': {
      titel: 'Growatt APX HV Battery (APX 5.0–30.0P-S1/-S2), Datasheet für MOD-XH(BP)- und MID-XH-Wechselrichter',
      herausgeber: 'Shenzhen Growatt New Energy Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/Inselvolt_Growatt_Apx15_0P_Hochvolt_Batteriesystem_Fur_Mod_Xh_Bp_Und_Mid_Xh_Wechselrichter_Apx_Hv_Battery_S1_S2_Mod_Xh_Bp_Mid_Xh_Datasheet_En_202405_244ec5c2-2a24-4ea2-9268-373499622751.pdf',
      /*
       * Geprueft 2026-09-07 (#92), Stand bleibt: Der Monitor meldete ein
       * Datenblatt "APX_HV_Battery-S2_AU_Datasheet_202602" und die Ankuendigung
       * einer "APX HV Battery 2.0". Das AU-Dokument ist geholt und gelesen —
       * und es schliesst sich selbst aus: In der Fusszeile steht "APX series
       * battery has an EU model and a General model, the storage inverters sold
       * in European countries only work with EU model APX battery."
       *
       * Fuer unsere Freigabe (Growatt APX an MOD-XH(BP)/MID-XH in Europa) ist
       * das damit keine Quelle. Ein EU-Datenblatt der S2-/2.0-Generation war
       * nicht auffindbar. Der Fund bleibt offen und gehoert in den naechsten
       * Datenpflege-Lauf, sobald es eines gibt: Ein Generationswechsel kann
       * Leistungswerte aendern, und dann reicht es nicht, die Version
       * nachzuziehen.
       */
      stand: 'EN 202405',
      abruf_datum: '2026-07-30',
      typ: 'hersteller',
    },
    'huawei-sun2000-m1': {
      titel: 'Huawei SUN2000-3/4/5/6/8/10KTL-M1, Technical Specification',
      herausgeber: 'Huawei Technologies Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/SUN2000_3_10KTL_M1_Datasheet.pdf',
      stand: 'Version 04-(20201006)',
      abruf_datum: '2026-07-30',
      typ: 'hersteller',
    },
    'sma-approved-2026-02': {
      titel: 'SMA Approved Batteries, Sunny Tripower Smart Energy (STP 5.0/6.0/8.0/10.0-3SE-40)',
      herausgeber: 'SMA Solar Technology AG (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Approved Batteries SMA Tripower.pdf',
      stand: 'Status 2026/02',
      abruf_datum: '2026-08-04',
      typ: 'hersteller',
    },
    /*
     * TSYS-HS51: Datenblatt liegt vor, aber KEIN Dokument nennt die freigegebenen
     * Wechselrichter (KB-Seite „X1/X3 Hybrid G4 Battery Selection" führt nur
     * T30/T58/HS25/HS36, die Produktseite nennt gar keine WR). Familie bleibt
     * draußen, bis der Beleg da ist — siehe README „Bekannte Datenlücken".
     */
    'solax-tsys-hs51-db': {
      titel: 'SolaX TSYS-HS51 Hochvolt-Batteriesystem (10,2–66,5 kWh), Datenblatt (DE)',
      herausgeber: 'SolaX Power Network Technology (Zhejiang) Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/Datasheet-DE (2).pdf',
      stand: 'V1.6 (650.00071.00.DE)',
      abruf_datum: '2026-08-04',
      typ: 'hersteller',
    },
    'growatt-axe-db': {
      titel: 'Growatt AXE 5.0L Modular Battery, Datasheet (EN)',
      herausgeber: 'Shenzhen Growatt New Energy Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/AXE_5.0L_Modular_Battery_New_Datasheet_EN_202506.pdf',
      stand: 'EN 202506',
      abruf_datum: '2026-08-04',
      typ: 'hersteller',
    },
    'sungrow-a05428-v43': {
      titel: 'Sungrow Inverters, Batteries & HEMS Compatibility List (A05428)',
      herausgeber: 'Sungrow Power Supply Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Sungrow A05428 BAT-COMPAT V4.3.pdf',
      stand: 'Version 4.3 (01.06.2026)',
      abruf_datum: '2026-08-04',
      typ: 'hersteller',
    },
    'sungrow-cross-v24': {
      titel: 'Sungrow Battery Cross-Reference Chart, SBR and SBH (V2.4, Update for SBR224 & SBH300)',
      herausgeber: 'Sungrow Australia Group Pty. Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/GD_202510_SBR and SBH_Cross Reference Chart_V2.4.pdf',
      stand: 'GD_202510 / V2.4',
      abruf_datum: '2026-08-04',
      typ: 'hersteller',
    },
    'deye-approved-036': {
      titel: 'Deye Approved Battery List (DY-HV(160-800)-036)',
      herausgeber: 'Ningbo Deye Inverter Technology Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/Deye Approved Battery List DY-HV160-800-036.pdf',
      stand: 'DY-HV(160-800)-036 / 2026-04-21',
      abruf_datum: '2026-08-04',
      typ: 'hersteller',
    },
    /*
     * V.02 (14.10.2025) liegt vor und ist gelesen — "Information Version: 0.2"
     * steht IM Dokument (2026-09-07, #92; der Monitor hatte die Version bis
     * dahin nur aus dem Dateinamen und führte den Fund in #64 faelschlich als
     * erledigt). Die Datei liegt daneben:
     * `Datenblätter/Speicher/Pylontech Force-H3 Datasheet V.02 20251014.pdf`.
     *
     * TROTZDEM bleibt diese Quelle die maßgebliche, und zwar aus einem Grund,
     * der genannt gehört: V.02 WIDERSPRICHT SICH SELBST.
     *
     *   - Zeile "Usable Energy of the Battery System (kWh)": 5,12 / 10,24 /
     *     15,36 / 20,48 / 25,6 / 30,72 / 35,84 — also gleich der Systemenergie,
     *     100 % nutzbar.
     *   - Zeile "Usable battery capacity (Ah)": 47,5 von 50 Ah — also 95 %.
     *
     * Beides steht auf derselben Seite derselben Tabelle. Die Ausgabe von 2024
     * war in sich schlüssig ("Usable Capacity (kWh) 9.69 … 34.01", "Depth of
     * Discharge 95%") und trägt unsere `nutzbar_kwh`-Werte.
     *
     * Wir übernehmen die neue Zahl NICHT, denn sie ist nicht belegt, sondern
     * strittig — und die Richtung des Irrtums wäre die falsche: `nutzbar_kwh`
     * geht in den Preis je nutzbarer kWh ein. Der alte Wert lässt das Gerät
     * teurer aussehen als der neue; im Zweifel untertreiben wir, statt dem
     * Kunden Kapazität zu versprechen, die eine widersprüchliche Tabelle
     * hergibt. Aufgelöst wird das durch eine Rückfrage bei Pylontech, nicht
     * durch eine Auswahl zwischen zwei Zeilen (DATENPFLEGE §5). Bis dahin
     * steht der Fall in README, "Bekannte Datenlücken".
     *
     * Unstrittig und deshalb gegengeprüft: Modul FH10050, 5,12 kWh, 102,4 V,
     * 50 Ah, 1–7 Module, Lade-/Entladestrom normal 50 A (Spitze 55 A für
     * 15 Minuten). Diese Werte sind in beiden Ausgaben gleich — unsere
     * Leistungsrechnung je Turmgröße ist damit gegen V.02 bestätigt.
     */
    'pylontech-force-h3-db': {
      titel: 'Pylontech Force-H3 High-Voltage Stackable Battery, Datasheet',
      herausgeber: 'Pylon Technologies Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/Pylontech Force-H3 Datasheet.pdf',
      stand: 'FH10050-Ausgabe (Dateidatum 2024-09-26); V.02 vom 14.10.2025 liegt vor, '
        + 'ist aber in sich widersprüchlich — siehe Kommentar',
      abruf_datum: '2026-09-07',
      typ: 'hersteller',
    },
    'lg-resu-flex-db': {
      titel: 'LG Energy Solution RESU FLEX, Product Specification (EN)',
      herausgeber: 'LG Energy Solution, Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/LG RESU FLEX Datasheet EN.pdf',
      stand: 'EN-Ausgabe (Battery Product Specification)',
      abruf_datum: '2026-08-04',
      typ: 'hersteller',
    },
    'solax-x3-ies-db-v18': {
      titel: 'SolaX X3-IES All-in-one Residential ESS (4–15 kW), Datasheet (EN)',
      herausgeber: 'SolaX Power Network Technology (Zhejiang) Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/SolaX X3-IES Datasheet EN V1.8.pdf',
      stand: 'V1.8 (650.00039.00)',
      abruf_datum: '2026-08-04',
      typ: 'hersteller',
    },
    'sungrow-sh5-12t-db': {
      titel: 'Sungrow SH5/6/8/10/12T Hybrid Three Phase Inverter, Datasheet (EUROPE)',
      herausgeber: 'Sungrow Power Supply Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Datasheet-EN (1).pdf',
      stand: 'Version 1.1 (© 2024)',
      abruf_datum: '2026-07-31',
      typ: 'hersteller',
    },
    'huawei-sun2000-map0': {
      titel: 'Huawei SUN2000-5/6/8/10/12K-MAP0, Technical Specification',
      herausgeber: 'Huawei Technologies Co., Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/Inselvolt_Huawei_Sun2000_12K_Map0_Datenblatt_Englisch_ce36eb8a-2d69-4483-b7d9-3cd69c00132f.pdf',
      stand: 'Version 02-202406',
      abruf_datum: '2026-07-30',
      typ: 'hersteller',
    },

    /*
     * SolarEdge, aufgenommen 2026-08-14. Die Freigabelage steht bei SolarEdge an
     * DREI Stellen, die sich gegenseitig stuetzen — deshalb sind alle drei als
     * eigene Quellen gefuehrt und nicht zu einer zusammengefasst:
     *  - die Kompatibilitaetsmatrix (Dreiphasen-Geraete gegen alle Batterien),
     *  - die WR-Datenblaetter selbst (Zeile „Unterstuetzte Batterietypen"),
     *  - das Konfigurationsdokument der 400V-Batterie (Einphasen-Geraete).
     * Die BYD-Paarung tragen zusaetzlich BYDs eigene Listen — siehe 'byd-lvs-mcl'.
     */
    'solaredge-matrix-3ph-v15': {
      titel: 'Technischer Hinweis, Kompatibilitätsmatrix für SolarEdge Home Dreiphasen-Wechselrichter und Batterien',
      herausgeber: 'SolarEdge Technologies Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/se-compatibility-matrix-for-solaredge-three-phase-inverters-and-batteries-application-note-de.pdf',
      stand: 'Version 1.5 (September 2025)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
      /*
       * Die Matrix nennt in ihrer Batteriespalte ausserdem „LG Chem LV Battery"
       * (bis zu 2 Batterien mit RESU Plus). LG steht hier trotzdem NICHT: Der
       * Katalog fuehrt von LG allein die RESU FLEX, und RESU FLEX ist nicht die
       * RESU-Reihe mit RESU-Plus-Box. Ein Groessen-Mapping waere geraten — also
       * bleibt die Paarung aus (DATENPFLEGE Rezept A.6, Luecke in README).
       */
      nennt_hersteller: ['SolarEdge', 'BYD'],
    },
    'solaredge-hub-3ph-db': {
      titel: 'SolarEdge Home Hub-Wechselrichter Dreiphasig, für Europa, SE5K-RWB48 / SE8K-RWB48 / SE10K-RWB48',
      herausgeber: 'SolarEdge Technologies Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/se-solaredge-home-hub-inverter-three-phase-backup-datasheet-de.pdf',
      stand: 'DE-Ausgabe (Artikelnummer SExxK-RWB48Bxxx)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
      nennt_hersteller: ['SolarEdge'],
    },
    'solaredge-hub-1ph-db': {
      titel: 'SolarEdge Home Hub-Wechselrichter Einphasig, für Europa, SE2500H bis SE10000H',
      herausgeber: 'SolarEdge Technologies Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/se-home-hub-single-phase-inverter-datasheet-de.pdf',
      stand: 'DE-Ausgabe (Artikelnummer SEXXXXH-RWBMNBF54)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
      nennt_hersteller: ['SolarEdge'],
    },
    'solaredge-storedge-3ph-db': {
      titel: 'StorEdge Dreiphasen-Wechselrichter SE5K-RWS / SE7K-RWS / SE8K-RWS / SE10K-RWS, Datenblatt',
      herausgeber: 'SolarEdge Technologies Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/se_storedge_three_phase_inverter_datasheet_de.pdf',
      stand: '27. September 2022 (DS-000087-EU)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
      /*
       * Die Zeile „Unterstuetzte Batterietypen" nennt zusaetzlich LG Chem
       * RESU3.3/6.5/10/12/13 und die BYD Battery-Box LV 3,5–14,0. Beides fehlt
       * hier aus demselben Grund wie oben: Der Katalog fuehrt diese beiden
       * Reihen nicht (LG nur RESU FLEX, BYD nur Premium LVS und die HV-Reihen).
       */
      nennt_hersteller: ['SolarEdge', 'BYD'],
    },
    'solaredge-nexis-3ph-db': {
      titel: 'SolarEdge Nexis Inverter 3ph for Europe, NX8K / NX10K / NX13K / NX15K / NX17K / NX20K',
      herausgeber: 'SolarEdge Technologies Ltd. (Hersteller)',
      dokument: 'Datenblätter/Wechselrichter/se-nexis-inverter-3ph-datasheet-eu.pdf',
      stand: 'EU-Ausgabe (DS-000256-EU, Artikelnummer NX20K-RW000CYN4)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
      nennt_hersteller: ['SolarEdge'],
    },
    'solaredge-bat-48v-db': {
      titel: 'SolarEdge Home Batterie 48V für Europa, BAT-05K48',
      herausgeber: 'SolarEdge Technologies Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/se-solaredge-home-battery-48V-datasheet-de.pdf',
      stand: '17. Februar 2025 (DS-000141-DE)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
    },
    'solaredge-bat-400v-db': {
      titel: 'SolarEdge Home Batterie 400V für Europa, BAT-10K1P',
      herausgeber: 'SolarEdge Technologies Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/se-solaredge-home-battery-400v-datasheet-de.pdf',
      stand: 'DE-Ausgabe (BAT-10K1PS0B-x2)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
    },
    'solaredge-bat-400v-konfig': {
      titel: 'SolarEdge Einphasen-Wechselrichter mit SolarEdge Home Batterie 400V: Konfigurationsoptionen',
      herausgeber: 'SolarEdge Technologies Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/se-home-battery-400v-configuration-options-eu-de.pdf',
      stand: 'Version 1.0 (Dezember 2021)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
      nennt_hersteller: ['SolarEdge'],
    },
    'solaredge-nexis-bat-db': {
      titel: 'SolarEdge Nexis Battery for Europe, Battery Blocks je Stack',
      herausgeber: 'SolarEdge Technologies Ltd. (Hersteller)',
      dokument: 'Datenblätter/Speicher/se-nexis-battery-datasheet-eu.pdf',
      stand: 'EU-Ausgabe (NX-BLCK-5K / NX-BLCK-5K-NB)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
      nennt_hersteller: ['SolarEdge'],
    },
    'byd-lvs-db': {
      titel: 'BYD Battery-Box Premium LVS Datenblatt (LVS 4.0 bis LVS 24.0)',
      herausgeber: 'BYD Company Limited (Hersteller)',
      dokument: 'Datenblätter/Speicher/BYD LVS BBOX_LVS_Datasheet_DE_V1.0_240703.pdf',
      stand: 'V1.0 (03.07.2024, DE)',
      abruf_datum: '2026-08-14',
      typ: 'hersteller',
    },
    /*
     * BYDs eigene Freigabeliste fuer die LVS, eingepflegt 2026-09-16. Bis dahin
     * stand hier ein Vermerk „bewusst noch keine Quelle": Das Dokument lag seit
     * der SolarEdge-Aufnahme (2026-08-14) im Ordner, wurde aber als eigener
     * Pflegelauf zurueckgestellt, weil rund 40 Modellzeilen abzubilden waren.
     *
     * Eine aeltere Fassung V1.9 (Update 2023-03-01) wurde am selben Tag
     * gegengelesen und NICHT aufgenommen: Sie nennt kein Geraet, das V1.12 nicht
     * auch nennt, und traegt fuer Deye ueberholte Mindestwerte.
     *
     * Lesart (Entscheidung Auftraggeber 2026-09-16): Die Liste nennt
     * Mindest-Modulzahlen je Betriebsart. Freigegeben sind die Groessen ab dem
     * Minimum fuer Abschnitt 1 „ON Grid"; die hoeheren Mindestwerte fuer
     * Notstrom (2) und Inselbetrieb (3, 4) stehen als Hinweis in
     * `einschraenkung`. Unsere Groessen sind EIN Turm mit 1–6 Modulen. Verlangt
     * eine Zeile zwei oder mehr Tuerme, ist das mit keiner einzelnen Groesse
     * abbildbar und steht nur im Text. Die ON-Grid-Seiten tragen keine grau
     * markierten (noch nicht freigegebenen) Zeilen — am gerenderten PDF geprueft.
     *
     * Nicht in `nennt_hersteller`, obwohl im Dokument: Sungrow, Hoymiles und
     * SOSEN. Der Katalog fuehrt die Marken, aber keins der hier genannten Geraete
     * (SH5K-30; HYS/HAS…LV-EUG1; SSE-HL…-P1EU — geführt sind nur US-Fassungen
     * bzw. die Hochvolt-Reihe). Eine Freigabe auf eine Nachbarbaureihe waere
     * geraten. Dasselbe Vorgehen wie bei LG in 'solaredge-matrix-3ph-v15'; die
     * Geraete stehen als Luecke in `nennt_geraete`. Schneider und RAION fuehrt
     * der Katalog gar nicht.
     */
    'byd-lvs-mcl': {
      titel: 'BYD Battery-Box Premium LVS Minimum Configuration List',
      herausgeber: 'BYD Company Limited (Hersteller)',
      dokument: 'Datenblätter/Speicher/BYD LVS Minimum Configuration List V1.12 250516.pdf',
      stand: 'V1.12 (Update 2025-05-16)',
      abruf_datum: '2026-09-16',
      typ: 'hersteller',
      nennt_hersteller: ['SMA', 'Victron', 'Selectronic', 'Studer', 'GoodWe', 'SolarEdge', 'Solis', 'Deye', 'Schneider', 'RAION'],
      nennt_geraete: [
        { name: 'SI 4.4M', familie: 'sma-sunny-island', variante: 'si-4-4m' },
        { name: 'SI 6.0H', familie: 'sma-sunny-island', variante: 'si-6-0h' },
        { name: 'SI 8.0H', familie: 'sma-sunny-island', variante: 'si-8-0h' },
        /* Victron wie bei 'zyc-simpo5000-statement': eine Familie ueber den Cerbo GX. */
        { name: 'Multiplus 48/3000/35', familie: 'victron-cerbo' },
        { name: 'Multiplus 48/5000/70', familie: 'victron-cerbo' },
        { name: 'Multigrid 48/3000/35', familie: 'victron-cerbo' },
        { name: 'Quattro 48/5000/70-100/100', familie: 'victron-cerbo' },
        { name: 'Quattro 48/8000/110-100/100', familie: 'victron-cerbo' },
        { name: 'Quattro 48/10000/140-100/100', familie: 'victron-cerbo' },
        { name: 'Quattro 48/15000/200-100/100', familie: 'victron-cerbo' },
        { name: 'Easysolar 48/3000/35-50 MPPT150/70', familie: 'victron-cerbo' },
        { name: 'Easysolar 48/5000/70-100 MPPT150/100', familie: 'victron-cerbo' },
        { name: 'Multi RS Solar 48/6000', familie: 'victron-cerbo' },
        { name: 'SPMC480-AU', familie: 'selectronic-spmc', variante: 'spmc480-au' },
        { name: 'SPMC481-AU', familie: 'selectronic-spmc', variante: 'spmc481-au' },
        { name: 'SPMC482-AU', familie: 'selectronic-spmc', variante: 'spmc482-au' },
        { name: 'XTS1400-48', familie: 'studer-xt', variante: 'xts-1400-48' },
        { name: 'XTM2600-48', familie: 'studer-xt', variante: 'xtm-2600-48' },
        { name: 'XTM4000-48', familie: 'studer-xt', variante: 'xtm-4000-48' },
        { name: 'XTH6000-48', familie: 'studer-xt', variante: 'xth-6000-48' },
        { name: 'XTH8000-48', familie: 'studer-xt', variante: 'xth-8000-48' },
        { name: 'VT-65', familie: 'studer-xt', variante: 'vt-65' },
        { name: 'VT-80', familie: 'studer-xt', variante: 'vt-80' },
        { name: 'VS-70', familie: 'studer-xt', variante: 'vs-70' },
        { name: 'VS-120', familie: 'studer-xt', variante: 'vs-120' },
        { name: 'Next 3', familie: 'studer-xt', variante: 'next3' },
        /*
         * „ES/ EM/ BP/ SBP Series". Zugeordnet sind die drei Katalogvarianten,
         * deren Name die Baureihe traegt (…-ES, …-SBP). Der GW 12K-ES-C10 bleibt
         * aussen vor: juengere Baureihe, ob BYD sie mit „ES Series" meint, sagt
         * das Dokument nicht.
         */
        { name: 'GoodWe ES Series (GW5048D-ES)', familie: 'goodwe-es-sbp', variante: 'goodwe-es-sbp-1' },
        { name: 'GoodWe SBP Series (GW5000-SBP)', familie: 'goodwe-es-sbp', variante: 'goodwe-es-sbp-2' },
        { name: 'GoodWe SBP Series (GW3600-SBP)', familie: 'goodwe-es-sbp', variante: 'goodwe-es-sbp-3' },
        { name: 'GoodWe EM Series', familie: null, grund: 'Baureihe nicht im Katalog, kein Datenblatt.' },
        { name: 'GoodWe BP Series', familie: null, grund: 'Baureihe nicht im Katalog, kein Datenblatt.' },
        { name: 'SH5K-30', familie: null, grund: 'Sungrow-Niedervoltgerät, nicht im Katalog, kein Datenblatt.' },
        { name: 'SE 5K-RWS', familie: 'solaredge-storedge-3ph', variante: 'se5k-rws' },
        { name: 'SE 7K-RWS', familie: 'solaredge-storedge-3ph', variante: 'se7k-rws' },
        { name: 'SE 8K-RWS', familie: 'solaredge-storedge-3ph', variante: 'se8k-rws' },
        { name: 'SE 10K-RWS', familie: 'solaredge-storedge-3ph', variante: 'se10k-rws' },
        { name: 'RHI-3K-48ES-5G', familie: null, grund: 'Solis-Vorgängerbaureihe, nicht im Katalog, kein Datenblatt.' },
        { name: 'RHI-3.6K-48ES-5G', familie: null, grund: 'wie RHI-3K-48ES-5G' },
        { name: 'RHI-4.6K-48ES-5G', familie: null, grund: 'wie RHI-3K-48ES-5G' },
        { name: 'RHI-5K-48ES-5G', familie: null, grund: 'wie RHI-3K-48ES-5G' },
        { name: 'RHI-6K-48ES-5G', familie: null, grund: 'wie RHI-3K-48ES-5G' },
        { name: 'RAI-3K-48ES-5G', familie: null, grund: 'AC-gekoppeltes Solis-Gerät, nicht im Katalog.' },
        { name: 'RHI-(3-5)K-48ES', familie: null, grund: 'Solis-Vorgängerbaureihe, nicht im Katalog, kein Datenblatt.' },
        { name: 'S5-EH1P(3-6)K-L', familie: 'solis-eh', variante: 'solis-eh-3' },
        { name: 'S6-EH1P(3/ 3.6)K-L-EU', familie: 'solis-eh', variante: 'solis-eh-1' },
        { name: 'S6-EH1P(4.6/ 5/ 6)K-L-EU', familie: 'solis-eh', variante: 'solis-eh-1' },
        { name: 'S6-EH1P(3-6)K-L-PRO', familie: null, grund: 'Katalog führt aus der PRO-Reihe nur den S6-EH1P8K-L-PRO, den die Liste nicht nennt.' },
        { name: 'XW Pro 8548', familie: null, grund: 'Schneider Electric, Hersteller nicht im Katalog.' },
        { name: 'RAION J5', familie: null, grund: 'Hersteller nicht im Katalog.' },
        { name: 'RAION M8', familie: null, grund: 'Hersteller nicht im Katalog.' },
        { name: 'SUN-3.6/5/6/7.6/8K-SG01LP1-EU', familie: 'deye-sun-lp', variante: 'deye-sun-lp-5' },
        { name: 'SUN-3.6K-SG01LP1-EU', familie: null, grund: 'Katalog führt die SG01LP1 unter 7,6 kW nur als US-Fassung (SUN-5/6K-SG01LP1-US).' },
        { name: 'SUN-5K-SG01LP1-EU', familie: null, grund: 'wie SUN-3.6K-SG01LP1-EU' },
        { name: 'SUN-6K-SG01LP1-EU', familie: null, grund: 'wie SUN-3.6K-SG01LP1-EU' },
        { name: 'SUN-12/14/16K-SG01LP1-EU', familie: 'deye-sun-lp', variante: 'deye-sun-lp-7' },
        { name: 'SUN-3.6/5/6K-SG03LP1-EU', familie: 'deye-sun-lp', variante: 'deye-sun-lp-2' },
        { name: 'SUN-3/3.6/5/6K-SG04LP1-EU', familie: 'deye-sun-lp', variante: 'deye-sun-lp-1' },
        { name: 'SUN-3.6/5/6/7.6/8K-SG05LP1-EU', familie: 'deye-sun-lp', variante: 'deye-sun-lp-3' },
        { name: 'SUN-5/6/8/10/12K-SG04LP3-EU', familie: 'deye-sun-lp', variante: 'deye-sun-lp-6' },
        { name: 'HYS-(3.0-6.0)LV-EUG1', familie: null, grund: 'Hoymiles EU-Fassung; der Katalog führt nur die US-Fassungen HYS-…LV-USG1.' },
        { name: 'HAS-(3.0-5.0)LV-EUG1', familie: null, grund: 'AC-gekoppeltes Hoymiles-Gerät, nicht im Katalog.' },
        { name: 'SSE-HL3K-8K-P1EU', familie: null, grund: 'SOSEN-Niedervoltreihe; der Katalog führt nur die Hochvoltreihe SSE-HH.' },
      ],
    },
  };


  if (typeof module !== 'undefined' && module.exports) module.exports = QUELLEN;
  if (root) root.IVBeraterDatenQuellen = QUELLEN;
})(typeof window !== 'undefined' ? window : null);

/*
 * inselvolt Kompatibilitätsberater — Datenbasis, Teil WECHSELRICHTER.
 *
 * ÄNDERUNGEN NUR NACH v2/DATENPFLEGE.md (Rezept B). Teil der vierteiligen
 * Datenbasis — Zusammenbau und Schnittstelle: daten/berater-daten.js.
 * Leistungswerte NUR aus den WR-Datenblättern; null = „Datenblattwert folgt".
 */
(function (root) {
  'use strict';

  /*
   * Baureihen aus Speicher-Kompatibilitaetslisten ohne eigenes Wechselrichter-Datenblatt.
   * Sie gehoeren in den Katalog, weil der Hersteller sie freigegeben hat — ihre
   * Leistungswerte bleiben aber leer, bis ein Datenblatt vorliegt. Der Hinweis steht
   * einmal hier statt in jeder Familie.
   */
  /*
   * Baureihen aus dem ZYC-SIMPO5000-Statement. Es nennt die Geraete namentlich,
   * aber keine Leistungswerte — die stehen in den Datenblaettern der jeweiligen
   * Wechselrichter-Hersteller, die uns nicht vorliegen.
   */
  var ZYC_OHNE_DATENBLATT = 'Baureihe stammt aus einer Speicher-Kompatibilitätsliste des '
    + 'Batterieherstellers; ein Wechselrichter-Datenblatt liegt uns nicht vor. Deshalb weisen wir '
    + 'weder AC-Nennleistung noch Batteriegrenze aus. Die Kombinationsleistung bleibt eine Obergrenze.';

  var DYNESS_OHNE_DATENBLATT = 'Baureihe stammt aus einer Speicher-Kompatibilitätsliste des '
    + 'Herstellers; ein Wechselrichter-Datenblatt liegt uns nicht vor. Deshalb weisen wir weder '
    + 'AC-Nennleistung noch Batteriegrenze aus. Die Kombinationsleistung bleibt eine Obergrenze. '
    + 'Die Modellbezeichnung steht im Wortlaut der Liste: Sammelzeilen bleiben eine Zeile, weil '
    + 'das Auffächern in Einzelgeräte Modellnamen erfinden hieße.';

  /*
   * Wechselrichter. Leistungswerte NUR aus den WR-Datenblättern.
   *  - ac_kw: AC-Bemessungs-/Nennleistung (begrenzt die Entladung ins Hausnetz)
   *  - bat_lade_kw / bat_entlade_kw: dokumentierte Batterieanschluss-Grenzen
   *  - null = kein Datenblatt vorliegend („Datenblattwert folgt")
   */
  var WECHSELRICHTER = [
    {
      id: 'felicity-ivem',
      hersteller: 'Felicity',
      name: 'IVEM / IVGM / IVPS Hybrid (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'felicity-ivem-1', name: "IVEM Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'felicity-ivem-2', name: "IVGM5048 / T-REX-5KLP1G01", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'felicity-ivem-3', name: "IVGM10048 / T-REX-10KLP3G01", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'felicity-ivem-4', name: "IVPS / IVPM / IVPA Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'felicity-ivem-5', name: "IVGM8KLP1 / P2G1", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'felicity-ivem-6', name: "IVGM20KLP3G1", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'deye-sun-lp',
      hersteller: 'Deye',
      name: 'SUN LP-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'deye-sun-lp-1', name: "SUN-3/3.6/5/6K-SG04LP1-EU", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'deye-sun-lp-2', name: "SUN-3.6/5/6K-SG03LP1-EU", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'deye-sun-lp-3', name: "SUN-3.6/5/6/7.6/8K-SG05LP1-EU", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'deye-sun-lp-4', name: "SUN-5/6K-SG01LP1-US", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'deye-sun-lp-5', name: "SUN-7.6/8K-SG01LP1-US/EU", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'deye-sun-lp-6', name: "SUN-5/6/8/10/12K-SG04LP3-EU", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'deye-sun-lp-7', name: "SUN-12/14/16K-SG01LP1-EU", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'deye-sun-lp-8', name: "SUN-14/15/16/18/20K-SG05LP3-EU-SM2", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'luxpower-lxp',
      hersteller: 'Luxpower',
      name: 'LXP Hybrid (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'luxpower-lxp-1', name: "LXP 3.6K/4.6K/5K Hybrid", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'luxpower-lxp-2', name: "LXP 3600 ACS Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'luxpower-lxp-3', name: "LXP-LB-EU 6-8K", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'luxpower-lxp-4', name: "LXP-LB-EU 8-10K", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'luxpower-lxp-5', name: "LXP-LB-EU 12K", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'growatt-spf',
      hersteller: 'Growatt',
      name: 'SPF ES-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'growatt-spf-1', name: "SPF 3500-5000 ES", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'growatt-spf-2', name: "SPF 6000 ES Plus", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'voltronic-axpert',
      hersteller: 'Voltronic',
      name: 'Axpert / Infini Solar (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'voltronic-axpert-1', name: "Infini Solar V IV TWIN 6/6.5/8 kW", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'voltronic-axpert-2', name: "Axpert VM III", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'voltronic-axpert-3', name: "Axpert VM IV", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'voltronic-axpert-4', name: "Axpert MKS III", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'voltronic-axpert-5', name: "Axpert MKS IV", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'voltronic-axpert-6', name: "Axpert MAX", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'voltronic-axpert-7', name: "Axpert MAX II", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'sunsynk-sg',
      hersteller: 'Sunsynk',
      name: 'SUNSYNK Hybrid (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'sunsynk-sg-1', name: "SUNSYNK-3.6/5/8K-SG01LP1", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'sunsynk-sg-2', name: "SYNK-8/10/12K-SG04LP3", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'sunsynk-sg-3', name: "SUNSYNK MAX", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'megarevo-r',
      hersteller: 'Megarevo',
      name: 'R-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity in Zusammenarbeit mit dem Wechselrichter-Hersteller geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'megarevo-r-1', name: "R(5-8)KLNA", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'megarevo-r-2', name: "R(6-15)KH3", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'megarevo-r-3', name: "R(3-6)KL1", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'victron-cerbo',
      hersteller: 'Victron',
      name: 'Systeme mit Cerbo GX (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'victron-cerbo-1', name: "Wechselrichter mit Cerbo GX als Kommunikationsbrücke", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'srne-hf-hes',
      hersteller: 'SRNE',
      name: 'HF / HES-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity in Zusammenarbeit mit dem Wechselrichter-Hersteller geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'srne-hf-hes-1', name: "HF4830S60-H / HF4850S80-H", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'srne-hf-hes-2', name: "HF4835U60-H / HF4850U80-H", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'srne-hf-hes-3', name: "HF4850S80-145", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'srne-hf-hes-4', name: "HF4830U60-145 / HF4835U80-145", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'srne-hf-hes-5', name: "HES48(80-120)S200-H", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'srne-hf-hes-6', name: "HES48(80-120)U200-H", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'srne-hf-hes-7', name: "HES48(40-60)S200-H", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'solis-eh',
      hersteller: 'Solis',
      name: 'S5 / S6 EH-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity in Zusammenarbeit mit dem Wechselrichter-Hersteller geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'solis-eh-1', name: "S6-EH1P(3-6)K-L-EU", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'solis-eh-2', name: "S6-EH1P8K-L-PRO", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'solis-eh-3', name: "S5-EH1P(3-6)K-L", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'solis-eh-4', name: "S6-EH3P(8-15)K02-NV-YD-L", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'mppsolar-pip',
      hersteller: 'MPPsolar',
      name: 'PIP-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'mppsolar-pip-1', name: "PIP-MT Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mppsolar-pip-2', name: "U-GK / U-MS Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mppsolar-pip-3', name: "PIP-MKX Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mppsolar-pip-4', name: "PIP-MAX Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mppsolar-pip-5', name: "PIP-MGX Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mppsolar-pip-6', name: "PIP-MK Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mppsolar-pip-7', name: "PIP-GK Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'afore-sl',
      hersteller: 'Afore',
      name: 'AF SL-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'afore-sl-1', name: "AF(1-3.6)K-SL", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'afore-sl-2', name: "AF(3-6)K-SL", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'sofar-hyd-ep',
      hersteller: 'SOFAR',
      name: 'HYD EP-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'sofar-hyd-ep-1', name: "HYD 3000-6000-EP", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'chisage-mars-jup',
      hersteller: 'CHISAGE ESS',
      name: 'MARS / JUP-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity in Zusammenarbeit mit dem Wechselrichter-Hersteller geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'chisage-mars-jup-1', name: "MARS-5-14G2-LE", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'chisage-mars-jup-2', name: "MARS-5-14G1-LE", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'chisage-mars-jup-3', name: "JUP-5-10G2-LE", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'solax-x1-lv',
      hersteller: 'SolaX',
      name: 'X1 Niedervolt-Hybrid',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'solax-x1-lv-1', name: "X1 Hybrid LV 3-6K", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'solax-x1-lv-2', name: "X1-Lite-12K-LV", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'solark',
      hersteller: 'Sol-Ark',
      name: 'Sol-Ark Hybrid (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'solark-1', name: "Sol-Ark 15K-2P-N", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'solark-2', name: "Sol-Ark 12K / 8K / 5K (Outdoor)", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'solark-3', name: "Sol-Ark 12K / 8K Legacy (Indoor)", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'hoymiles-hys-lv',
      hersteller: 'Hoymiles',
      name: 'HYS LV-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity in Zusammenarbeit mit dem Wechselrichter-Hersteller geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'hoymiles-hys-lv-1', name: "HYS-7.6LV-USG1", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'hoymiles-hys-lv-2', name: "HYS-9.6LV-USG1", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'hoymiles-hys-lv-3', name: "HYS-11.5LV-USG1", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'invt-imars',
      hersteller: 'INVT',
      name: 'iMars XD-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity in Zusammenarbeit mit dem Wechselrichter-Hersteller geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'invt-imars-1', name: "iMars XD3-6KTL", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'aohai-ksl',
      hersteller: 'AOHAI',
      name: 'AH KSL-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity in Zusammenarbeit mit dem Wechselrichter-Hersteller geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'aohai-ksl-1', name: "AH-3-6KSL-G2", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'amensolar-n3h',
      hersteller: 'Amensolar',
      name: 'N3H-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'amensolar-n3h-1', name: "N3H-X5 / 8 / 10-US", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'saj-h1-s2',
      hersteller: 'SAJ',
      name: 'H1 S2-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'saj-h1-s2-1', name: "SAJ H1 3-6KW S2", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'solplanet-asw-h',
      hersteller: 'Solplanet',
      name: 'ASW H-S2 Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'solplanet-asw-h-1', name: "ASW H-S2 Serie", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'goodwe-es-sbp',
      hersteller: 'GoodWe',
      name: 'ES / SBP-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'gw12k-es-c10', name: 'GW 12K-ES-C10', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'goodwe-es-sbp-1', name: "GW5048D-ES", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'goodwe-es-sbp-2', name: "GW5000-SBP", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'goodwe-es-sbp-3', name: "GW3600-SBP", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'shinemann-m5000h',
      hersteller: 'Shinemann',
      name: 'M5000H (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: 'Von Felicity geprüft. Modellbezeichnungen aus der Felicity-Kompatibilitätsliste; '
        + 'ein Datenblatt dieses Wechselrichters liegt uns nicht vor, deshalb keine Leistungswerte.',
      varianten: [
        { id: 'shinemann-m5000h-1', name: "M5000H-48BP", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ],
    },
    {
      id: 'kostal-plenticore-g3',
      hersteller: 'KOSTAL',
      name: 'PLENTICORE G3',
      typ: 'hybrid',
      spec_quelle: 'kostal-g3-db',
      strom_hinweis: 'Datenblattzeile „Max. Lade-/Entladestrom Batterieeingang A 17/17 30/30 30/30“. Je Geräteklasse S/M/L; die Leistungsstufen teilen sich die Hardware.',
      spec_hinweis: 'Batteriegrenze = „Max. Bat-Leistung pro DC-Eingang" (ab SW 3.06.00), Lade-/Entladestrom symmetrisch (17 A bzw. 30 A). Entladung ins Hausnetz zusätzlich durch AC-Leistung begrenzt.',
      /*
       * Kostenpflichtige Freischaltungen über PLENTICOIN — Anzahl laut
       * PLENTICOIN-Factsheet V4.0 (Quelle kostal-plenticoin-fs):
       *   Batterie-Funktion PLENTICORE G3 ...... 3 Coins
       *   Leistungserweiterung (je Stufe) ...... 1 Coin
       * Die Leistungsstufe steckt in der Variante (freischaltung_stufen), weil
       * sie vom gewählten Gerät abhängt: „G3 M +Stufe 1" ist dasselbe Basisgerät
       * wie „G3 M", nur eine Stufe höher freigeschaltet. Beides zusammen ergibt
       * den Zuschlag, den der Preisvergleich einrechnet — sonst hinkt er.
       */
      batterie_freischaltung: {
        anzahl_plenticoin: 3,
        preis_schluessel: 'zubehoer:kostal-plenticoin:karte-de',
        text: 'Batterie-Freischaltung erforderlich: 3 × KOSTAL PLENTICOIN',
        quelle_hinweis: 'PLENTICOIN Factsheet V4.0 (KOSTAL): Batterie-Funktion für PLENTICORE G3 = 3 PLENTICOIN',
        quelle: 'kostal-plenticoin-fs',
      },
      varianten: [
        { id: 'g3-4.0', name: 'PLENTICORE G3 S (4,0 kW)', ac_kw: 4.0, bat_lade_kw: 6, bat_entlade_kw: 6, bat_strom_a: 17 },
        { id: 'g3-5.5', name: 'PLENTICORE G3 S +Stufe 1 (5,5 kW)', ac_kw: 5.5, bat_lade_kw: 8.25, bat_entlade_kw: 8.25, bat_strom_a: 17, freischaltung_stufen: 1, basis_variante: 'g3-4.0' },
        { id: 'g3-7.0', name: 'PLENTICORE G3 S +Stufe 2 (7,0 kW)', ac_kw: 7.0, bat_lade_kw: 8.25, bat_entlade_kw: 8.25, bat_strom_a: 17, freischaltung_stufen: 2, basis_variante: 'g3-4.0' },
        { id: 'g3-8.5', name: 'PLENTICORE G3 M (8,5 kW)', ac_kw: 8.5, bat_lade_kw: 12.75, bat_entlade_kw: 12.75, bat_strom_a: 30 },
        { id: 'g3-10', name: 'PLENTICORE G3 M +Stufe 1 (10 kW)', ac_kw: 10, bat_lade_kw: 13.5, bat_entlade_kw: 13.5, bat_strom_a: 30, freischaltung_stufen: 1, basis_variante: 'g3-8.5' },
        { id: 'g3-12.5', name: 'PLENTICORE G3 M +Stufe 2 (12,5 kW)', ac_kw: 12.5, bat_lade_kw: 13.5, bat_entlade_kw: 13.5, bat_strom_a: 30, freischaltung_stufen: 2, basis_variante: 'g3-8.5' },
        { id: 'g3-15', name: 'PLENTICORE G3 L (15 kW)', ac_kw: 15, bat_lade_kw: 21, bat_entlade_kw: 21, bat_strom_a: 30 },
        { id: 'g3-17.5', name: 'PLENTICORE G3 L +Stufe 1 (17,5 kW)', ac_kw: 17.5, bat_lade_kw: 21, bat_entlade_kw: 21, bat_strom_a: 30, freischaltung_stufen: 1, basis_variante: 'g3-15' },
        { id: 'g3-20', name: 'PLENTICORE G3 L +Stufe 2 (20 kW)', ac_kw: 20, bat_lade_kw: 21, bat_entlade_kw: 21, bat_strom_a: 30, freischaltung_stufen: 2, basis_variante: 'g3-15' },
      ],
    },
    {
      id: 'fronius-symo-gen24-plus',
      hersteller: 'Fronius',
      name: 'Symo GEN24 Plus',
      typ: 'hybrid',
      spec_quelle: 'fronius-gen24-db',
      spec_hinweis: 'Batteriegrenze = „Max. DC-Eingangs-/Ausgangsleistung" (abhängig von der angeschlossenen Batterie).',
      varianten: [
        { id: 'symo-3.0', name: 'Symo GEN24 3.0 Plus', ac_kw: 3.0, bat_lade_kw: 3.15, bat_entlade_kw: 3.15 },
        { id: 'symo-4.0', name: 'Symo GEN24 4.0 Plus', ac_kw: 4.0, bat_lade_kw: 4.18, bat_entlade_kw: 4.18 },
        { id: 'symo-5.0', name: 'Symo GEN24 5.0 Plus', ac_kw: 5.0, bat_lade_kw: 5.2, bat_entlade_kw: 5.2 },
        { id: 'symo-6.0', name: 'Symo GEN24 6.0 Plus', ac_kw: 6.0, bat_lade_kw: 6.22, bat_entlade_kw: 6.22 },
        { id: 'symo-8.0', name: 'Symo GEN24 8.0 Plus', ac_kw: 8.0, bat_lade_kw: 8.26, bat_entlade_kw: 8.26 },
        { id: 'symo-10.0', name: 'Symo GEN24 10.0 Plus', ac_kw: 10.0, bat_lade_kw: 10.3, bat_entlade_kw: 10.3 },
      ],
    },
    {
      id: 'fronius-verto-plus',
      hersteller: 'Fronius',
      name: 'Verto Plus',
      typ: 'hybrid',
      spec_quelle: 'fronius-verto-db',
      spec_hinweis: 'Lade- und Entladeleistung sind im Datenblatt getrennt ausgewiesen (abhängig von Strom/Spannung der Batterie). Ausgenommen laut Datenblatt: BYD HVM 8.3 und 3× HVM 22.1.',
      varianten: [
        { id: 'verto-15.0', name: 'Verto 15.0 Plus', ac_kw: 15.0, bat_lade_kw: 22.5, bat_entlade_kw: 15.0 },
        { id: 'verto-17.5', name: 'Verto 17.5 Plus', ac_kw: 17.5, bat_lade_kw: 26.25, bat_entlade_kw: 17.5 },
        { id: 'verto-20.0', name: 'Verto 20.0 Plus', ac_kw: 20.0, bat_lade_kw: 30.0, bat_entlade_kw: 20.0 },
        { id: 'verto-25.0', name: 'Verto 25.0 Plus', ac_kw: 25.0, bat_lade_kw: 33.25, bat_entlade_kw: 25.0 },
        { id: 'verto-30.0', name: 'Verto 30.0 Plus', ac_kw: 29.99, bat_lade_kw: 35.0, bat_entlade_kw: 29.99 },
        { id: 'verto-33.3', name: 'Verto 33.3 Plus', ac_kw: 33.3, bat_lade_kw: 35.0, bat_entlade_kw: 33.3 },
      ],
    },
    {
      id: 'fronius-primo-gen24-plus',
      hersteller: 'Fronius',
      name: 'Primo GEN24 Plus',
      typ: 'hybrid',
      spec_quelle: 'fronius-primo-gen24-db',
      /*
       * Datenblatt seit 2026-08-15 (vorher: „liegt nicht vor" — es fehlte
       * schlicht im Ordner, während das vorhandene Fronius-Blatt ein reines
       * Symo-Blatt ist). Dieselben zwei Zeilen wie beim Symo, damit beide
       * Baureihen vergleichbar bleiben.
       *
       * Bemerkenswert und der Grund, warum hier nichts aus dem Modellnamen
       * abgeleitet werden durfte: Das Modell „3.6" hat laut Blatt 3.680 W
       * AC-Nennleistung, nicht 3.600 W.
       */
      spec_hinweis: 'AC-Nennleistung = Datenblattzeile „AC-Nennleistung (Pac,r)", '
        + 'Batteriegrenze = „Max. nutzbare DC-Leistung" (Summe beider MPP-Tracker). '
        + 'Entladung ins Hausnetz zusätzlich durch die AC-Leistung begrenzt.',
      varianten: [
        { id: 'primo-3.0', name: 'Primo GEN24 3.0 Plus', ac_kw: 3.0, bat_lade_kw: 3.11, bat_entlade_kw: 3.11 },
        // 3.6 und 4.6 stehen zusätzlich in der Fronius-Speicherlösung DE v11
        // (Quelle `fronius-gen24-byd-lg`) als eigene Zeilen der Kompatibilitätstabelle.
        { id: 'primo-3.6', name: 'Primo GEN24 3.6 Plus', ac_kw: 3.68, bat_lade_kw: 3.81, bat_entlade_kw: 3.81 },
        { id: 'primo-4.0', name: 'Primo GEN24 4.0 Plus', ac_kw: 4.0, bat_lade_kw: 4.14, bat_entlade_kw: 4.14 },
        { id: 'primo-4.6', name: 'Primo GEN24 4.6 Plus', ac_kw: 4.6, bat_lade_kw: 4.75, bat_entlade_kw: 4.75 },
        { id: 'primo-5.0', name: 'Primo GEN24 5.0 Plus', ac_kw: 5.0, bat_lade_kw: 5.17, bat_entlade_kw: 5.17 },
        { id: 'primo-6.0', name: 'Primo GEN24 6.0 Plus', ac_kw: 6.0, bat_lade_kw: 6.2, bat_entlade_kw: 6.2 },
      ],
    },
    {
      id: 'kostal-plenticore-plus-g2',
      /*
       * PLENTICORE plus (G1/G2): Batterie-Funktion = 1 PLENTICOIN
       * (PLENTICOIN Factsheet V4.0 — dort ausdrücklich nur ein Coin, die beiden
       * weiteren sind durchgestrichen). Eine Leistungserweiterung gibt es für
       * diese Baureihe nicht; das Factsheet nennt sie nur für G3 und MP G3.
       */
      batterie_freischaltung: {
        anzahl_plenticoin: 1,
        preis_schluessel: 'zubehoer:kostal-plenticoin:karte-de',
        text: 'Batterie-Freischaltung erforderlich: 1 × KOSTAL PLENTICOIN',
        quelle_hinweis: 'PLENTICOIN Factsheet V4.0 (KOSTAL): Batterie-Funktion für PLENTICORE plus (G1/G2) = 1 PLENTICOIN',
        quelle: 'kostal-plenticoin-fs',
      },
      hersteller: 'KOSTAL',
      name: 'PLENTICORE plus (G2)',
      typ: 'hybrid',
      spec_quelle: 'kostal-g2-db',
      /*
       * Datenblatt seit 2026-08-15. Anders als beim G3 nennt es KEINE
       * Batterieleistung in kW — es gibt nur den Strom. `bat_lade_kw` und
       * `bat_entlade_kw` bleiben deshalb offen; die Paarungsgrenze rechnet die
       * Engine aus Strom × Turmspannung und weist sie als „berechnet" aus.
       * Einen Wert zu erfinden, nur weil das G3-Blatt eine solche Zeile hat,
       * wäre die Ableitung, die Invariante 3 ausschließt.
       */
      strom_hinweis: 'Datenblattzeile „Max. Ladestrom/Entladestrom Batterieeingang A 15/15", '
        + 'für alle sechs Leistungsklassen derselbe Wert.',
      spec_hinweis: 'AC-Nennleistung = Datenblattzeile „Bemessungsleistung, cos φ = 1 (PAC,r)". '
        + 'Eine Batterieleistung in kW weist das G2-Blatt nicht aus, nur den Batteriestrom, '
        + 'die Paarungsgrenze wird daraus errechnet.',
      varianten: [
        { id: 'g2-3.0', name: 'PLENTICORE plus G2 3.0', ac_kw: 3.0, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 15 },
        { id: 'g2-4.2', name: 'PLENTICORE plus G2 4.2', ac_kw: 4.2, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 15 },
        { id: 'g2-5.5', name: 'PLENTICORE plus G2 5.5', ac_kw: 5.5, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 15 },
        { id: 'g2-7.0', name: 'PLENTICORE plus G2 7.0', ac_kw: 7.0, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 15 },
        { id: 'g2-8.5', name: 'PLENTICORE plus G2 8.5', ac_kw: 8.5, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 15 },
        { id: 'g2-10.0', name: 'PLENTICORE plus G2 10.0', ac_kw: 10.0, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 15 },
      ],
    },
    {
      /*
       * PLENTICORE plus der ERSTEN Generation — nachgetragen 2026-08-16.
       *
       * Die Baureihe fehlte, obwohl die KOSTAL-Freigabeliste sie in fast jeder
       * Zeile fuehrt ("PLENTICORE plus" ohne Zusatz, neben "PLENTICORE plus G2").
       * Erfasst war sie nur als Prosa in `einschraenkung` — sichtbar im Beleg,
       * unsichtbar in der Auswahl. Wer ein Geraet dieser Generation besitzt und
       * nachruesten will, ist genau der Fall, fuer den es den Berater gibt.
       *
       * Das Geraet wird nicht mehr verkauft; im Shop gibt es dafuer keinen
       * Preis. Das ist richtig so — gefragt ist die Nachruestung eines
       * vorhandenen Wechselrichters, nicht sein Kauf.
       *
       * Wie beim G2 nennt das Blatt KEINE Batterieleistung in kW, nur den
       * Strom: 13 A statt 15 A. Genau diese 13 A stehen auch in Fussnote 1 der
       * Freigabeliste ("UBat x 13 A max. Eingangsstrom des WR") — die Fussnote
       * ist damit aus dem Geraetedatenblatt belegt und nicht nur zitiert.
       */
      id: 'kostal-plenticore-plus-g1',
      hersteller: 'KOSTAL',
      name: 'PLENTICORE plus (G1)',
      typ: 'hybrid',
      spec_quelle: 'kostal-g1-db',
      batterie_freischaltung: {
        anzahl_plenticoin: 1,
        preis_schluessel: 'zubehoer:kostal-plenticoin:karte-de',
        text: 'Batterie-Freischaltung erforderlich: 1 × KOSTAL PLENTICOIN',
        quelle_hinweis: 'PLENTICOIN Factsheet V4.0 (KOSTAL): Batterie-Funktion für PLENTICORE plus (G1/G2) = 1 PLENTICOIN',
        quelle: 'kostal-plenticoin-fs',
      },
      strom_hinweis: 'Datenblattzeile „Max. Ladestrom/Entladestrom Batterieeingang A 13/13", '
        + 'für alle sechs Leistungsklassen derselbe Wert.',
      spec_hinweis: 'AC-Nennleistung = Datenblattzeile „Bemessungsleistung, cos φ = 1 (PAC,r)". '
        + 'Eine Batterieleistung in kW weist das Blatt nicht aus, nur den Batteriestrom (13 A), '
        + 'die Paarungsgrenze wird daraus errechnet. Der Batterieeingang (DC3) ist optional und '
        + 'muss freigeschaltet werden.',
      varianten: [
        { id: 'g1-3.0', name: 'PLENTICORE plus 3.0', ac_kw: 3.0, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 13 },
        { id: 'g1-4.2', name: 'PLENTICORE plus 4.2', ac_kw: 4.2, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 13 },
        { id: 'g1-5.5', name: 'PLENTICORE plus 5.5', ac_kw: 5.5, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 13 },
        { id: 'g1-7.0', name: 'PLENTICORE plus 7.0', ac_kw: 7.0, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 13 },
        { id: 'g1-8.5', name: 'PLENTICORE plus 8.5', ac_kw: 8.5, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 13 },
        { id: 'g1-10.0', name: 'PLENTICORE plus 10', ac_kw: 10.0, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 13 },
      ],
    },
    {
      /*
       * PLENTICORE BI 25 G3 — reiner Batterie-Wechselrichter, ein Modell mit
       * 25 kW. Neu in der Freigabeliste 07/2026 und dort in fast jeder Zeile;
       * bei Dyness Stack100 Pro 15s ist er sogar das einzige freigegebene
       * Geraet. Das Datenblatt (06/2026) nennt keine Batterieleistung in kW,
       * sondern den Strom — wie bei PLENTICORE plus, nur deutlich hoeher.
       *
       * Kein `batterie_freischaltung`: Das PLENTICOIN-Factsheet fuehrt die
       * kostenpflichtige Batterie-Funktion nur fuer PLENTICORE plus und G3.
       * Bei einem Geraet, dessen einziger Zweck die Batterie ist, waere das
       * auch schwer zu erklaeren — belegt ist es jedenfalls nicht.
       */
      id: 'kostal-plenticore-bi-25-g3',
      hersteller: 'KOSTAL',
      name: 'PLENTICORE BI 25 G3',
      typ: 'batterie',
      spec_quelle: 'kostal-bi-g3-db',
      strom_hinweis: 'Datenblattzeile „Max. Lade-/Entladestrom (IDCmax) Summe aller DC-Eingänge A 68".',
      spec_hinweis: 'AC-Nennleistung = Datenblattzeile „Bemessungsleistung, cos φ = 1 (PAC,r)" (25 kW). '
        + 'Eine Batterieleistung in kW weist das Blatt nicht aus, nur den Batteriestrom (68 A für alle '
        + 'DC-Eingänge zusammen), die Paarungsgrenze wird daraus errechnet. Batteriespannung 95–880 V. '
        + 'Reiner Batterie-Wechselrichter ohne PV-Eingang — gedacht zum Nachrüsten bestehender Anlagen.',
      varianten: [
        { id: 'bi-25-g3', name: 'PLENTICORE BI 25 G3', ac_kw: 25.0, bat_lade_kw: null, bat_entlade_kw: null, bat_strom_a: 68 },
      ],
    },
    {
      id: 'sungrow-sh-rt',
      hersteller: 'Sungrow',
      name: 'SH-RT-20 Hybrid',
      typ: 'hybrid',
      spec_quelle: 'sungrow-sh-rt-db',
      strom_hinweis: 'Datenblattzeile „Max Lade-/Entladestrom 30 A / 30 A“ im Abschnitt Batteriedaten.',
      spec_hinweis: 'Lade- und Entladeleistung laut Datenblatt getrennt ausgewiesen („je nach angeschlossener Batterie"); Batteriestrom max. 30 A.',
      varianten: [
        { id: 'sh-5.0rt', name: 'SH5.0RT-20', ac_kw: 5.0, bat_lade_kw: 7.5, bat_entlade_kw: 6.0, bat_strom_a: 30 },
        { id: 'sh-6.0rt', name: 'SH6.0RT-20', ac_kw: 6.0, bat_lade_kw: 9.0, bat_entlade_kw: 7.2, bat_strom_a: 30 },
        { id: 'sh-8.0rt', name: 'SH8.0RT-20', ac_kw: 8.0, bat_lade_kw: 10.6, bat_entlade_kw: 10.6, bat_strom_a: 30 },
        { id: 'sh-10rt', name: 'SH10RT-20', ac_kw: 10.0, bat_lade_kw: 10.6, bat_entlade_kw: 10.6, bat_strom_a: 30 },
      ],
    },
    {
      /*
       * ET G2 6–15 kW. Bis 2026-08-10 stand hier eine einzige Sammelvariante
       * ohne Zahlen: Die Baureihe war nur aus fremden Kompatibilitaetslisten
       * bekannt (BYD fuehrt sie als „ET G2"), ein Datenblatt fehlte. Mit dem
       * Blatt zerfaellt sie in ihre fuenf Modelle — eine Sammelvariante koennte
       * die fuenf verschiedenen Batteriegrenzen gar nicht tragen.
       */
      id: 'goodwe-et',
      hersteller: 'GoodWe',
      name: 'ET-Serie (GW6000–GW15K ET-20)',
      typ: 'hybrid',
      spec_quelle: 'goodwe-et-g2-6-15-db',
      spec_hinweis: 'Batteriegrenzen = „Max. Charging Power (W)" / „Max. Discharging Power (W)" je Modell. '
        + 'Auffällig, aber so gedruckt: Die Ladeleistung liegt über der AC-Nennleistung (15 kW bei 10 kW AC), '
        + 'geladen wird DC-seitig aus PV, entladen ins Netz nur bis zur AC-Grenze. Batterie 500 V nominal, 150–720 V.',
      strom_hinweis: 'Batteriestrom aus der Zeile „Max. Continuous Charging/Discharging Current (A)", '
        + '30 A bei GW6000/GW8000, 40 A ab GW10K, jeweils ein Batterieeingang.',
      varianten: [
        { id: 'gw6000-et-20', name: 'GW6000-ET-20', ac_kw: 6, bat_lade_kw: 9.0, bat_entlade_kw: 6.6, bat_strom_a: 30 },
        { id: 'gw8000-et-20', name: 'GW8000-ET-20', ac_kw: 8, bat_lade_kw: 12.0, bat_entlade_kw: 8.8, bat_strom_a: 30 },
        { id: 'gw10k-et-20', name: 'GW10K-ET-20', ac_kw: 10, bat_lade_kw: 15.0, bat_entlade_kw: 11.0, bat_strom_a: 40 },
        { id: 'gw12k-et-20', name: 'GW12K-ET-20', ac_kw: 12, bat_lade_kw: 18.0, bat_entlade_kw: 13.2, bat_strom_a: 40 },
        { id: 'gw15k-et-20', name: 'GW15K-ET-20', ac_kw: 15, bat_lade_kw: 24.0, bat_entlade_kw: 16.5, bat_strom_a: 40 },
      ],
    },
    // ---------- Neue Hersteller-Wechselrichter (2026-07-05) ----------
    {
      id: "alphaess-smile-g3-t4-t10",
      hersteller: "AlphaESS",
      name: "SMILE-G3-T4-T10",
      typ: "hybrid",
      spec_quelle: "alphaess-smile-g3-t4-t10",
      spec_hinweis: "Dreiphasig. Batterie-Lade-/Entladeleistung je Variante = Max. Lade-/Entladeleistung laut Datenblatt (Batteriestrom 40 A).",
      varianten: [
        {
          id: "g3-t4",
          name: "SMILE-G3-T4",
          ac_kw: 4,
          bat_lade_kw: 4,
          bat_entlade_kw: 4
        },
        {
          /*
           * Nachgetragen 2026-09-07 (#92). Der T5 war seit jeher als Spalte der
           * Modulkompatibilitaets-Tabelle bekannt, aber ohne Datenblatt — er
           * stand deshalb als offenes Geraet ohne Werte. Das Datenblatt
           * V09.15012025 fuehrt ihn mit eigener Modellspalte "SMILE-G3-T5":
           * Nennleistung 5 kW, max. Lade-/Entladeleistung 5 kW. Beide Werte
           * abgeschrieben, nicht interpoliert.
           */
          id: "g3-t5",
          name: "SMILE-G3-T5",
          ac_kw: 5,
          bat_lade_kw: 5,
          bat_entlade_kw: 5
        },
        {
          id: "g3-t6",
          name: "SMILE-G3-T6",
          ac_kw: 6,
          bat_lade_kw: 6,
          bat_entlade_kw: 6
        },
        {
          id: "g3-t8",
          name: "SMILE-G3-T8",
          ac_kw: 8,
          bat_lade_kw: 8,
          bat_entlade_kw: 8
        },
        {
          id: "g3-t10",
          name: "SMILE-G3-T10",
          ac_kw: 10,
          bat_lade_kw: 10,
          bat_entlade_kw: 10
        }
      ]
    },
    {
      id: "alphaess-smile-g3-t12-t20",
      hersteller: "AlphaESS",
      name: "SMILE-G3-T12/T15/T20",
      typ: "hybrid",
      spec_quelle: "alphaess-smile-g3-t12-t20",
      spec_hinweis: "Dreiphasig. Batteriestrom 60 A. Batterie-Lade-/Entladeleistung je Variante = Max. Lade-/Entladeleistung laut Datenblatt; systemseitig durch Batterie begrenzt (eine 8.2P-Batterie: 8,2 kW; zwei oder mehr: 15 kW). T15/T20 zusätzlich belegt durch separates Datenblatt (V10.02222024).",
      varianten: [
        {
          id: "g3-t12",
          name: "SMILE-G3-T12",
          ac_kw: 12,
          bat_lade_kw: 12,
          bat_entlade_kw: 12
        },
        {
          id: "g3-t15",
          name: "SMILE-G3-T15",
          ac_kw: 15,
          bat_lade_kw: 15,
          bat_entlade_kw: 15
        },
        {
          id: "g3-t20",
          name: "SMILE-G3-T20",
          ac_kw: 20,
          bat_lade_kw: 20,
          bat_entlade_kw: 20
        }
      ]
    },
    {
      id: "alphaess-smile-hi10",
      hersteller: "AlphaESS",
      name: "SMILE-Hi10",
      typ: "hybrid",
      spec_quelle: "alphaess-smile-hi10",
      spec_hinweis: "Dreiphasig. Batteriestrom 40 A. Max. AC-Scheinleistung 10.000 VA. Max. Lade-/Entladeleistung 10 kW; bei einer Batterie systemseitig auf 7,8 kW begrenzt (Fußnote).",
      varianten: [
        {
          id: "hi10",
          name: "SMILE-Hi10",
          ac_kw: 10,
          bat_lade_kw: 10,
          bat_entlade_kw: 10
        }
      ]
    },
    {
      id: "alphaess-smile-hi5",
      hersteller: "AlphaESS",
      name: "SMILE-Hi5",
      typ: "hybrid",
      spec_quelle: "alphaess-smile-hi5",
      spec_hinweis: "Einphasig / 3-Phasenkompensation. Batteriestrom 40 A. AC-Nennleistung 5 kW (DE: 4,6 kW). Max. Lade-/Entladeleistung 5 kW (DE: 4,6 kW).",
      varianten: [
        {
          id: "hi5",
          name: "SMILE-Hi5",
          ac_kw: 5,
          bat_lade_kw: 5,
          bat_entlade_kw: 5
        }
      ]
    },
    {
      id: "alphaess-smile-g3-s5",
      hersteller: "AlphaESS",
      name: "SMILE-G3-S5",
      typ: "hybrid",
      spec_quelle: "alphaess-smile-g3-s5",
      spec_hinweis: "Einphasig / 3-Phasenkompensation. Batteriestrom 60 A. AC-Nennleistung 5 kW (DE: 4,6 kW). Max. Lade-/Entladeleistung 5 kW (DE: 4,6 kW).",
      varianten: [
        {
          id: "g3-s5",
          name: "SMILE-G3-S5",
          ac_kw: 5,
          bat_lade_kw: 5,
          bat_entlade_kw: 5
        }
      ]
    },
    {
      id: "huawei-sun2000-mb0",
      hersteller: "Huawei",
      name: "SUN2000 K-MB0 Smart Energy Controller",
      typ: "hybrid",
      spec_quelle: "huawei-sun2000-mb0",
      spec_hinweis: "Dreiphasiger Hybrid-WR mit 2 Batterie-Terminals. Kompatible Batterie laut Datenblatt: LUNA2000-5/10/15-S0 und LUNA2000-7/14/21-S1. Max. Ladeleistung 21 kW (ein String) / 25 kW (zwei Strings), Batterie-Betriebsspannung 600–980 V, max. Betriebsstrom 26,25 A pro String. Laden und Entladen getrennt dokumentiert.",
      varianten: [
        {
          id: "mb0-12",
          name: "SUN2000-12K-MB0",
          ac_kw: 12,
          bat_lade_kw: 25,
          bat_entlade_kw: 13.2
        },
        {
          id: "mb0-15",
          name: "SUN2000-15K-MB0",
          ac_kw: 15,
          bat_lade_kw: 25,
          bat_entlade_kw: 16.5
        },
        {
          id: "mb0-17",
          name: "SUN2000-17K-MB0",
          ac_kw: 17,
          bat_lade_kw: 25,
          bat_entlade_kw: 18.7
        },
        {
          id: "mb0-20",
          name: "SUN2000-20K-MB0",
          ac_kw: 20,
          bat_lade_kw: 25,
          bat_entlade_kw: 22
        },
        {
          id: "mb0-25",
          name: "SUN2000-25K-MB0",
          ac_kw: 25,
          bat_lade_kw: 25,
          bat_entlade_kw: 25
        }
      ]
    },
    {
      id: "sma-sunny-tripower-smart-energy",
      hersteller: "SMA",
      name: "Sunny Tripower Smart Energy",
      typ: "hybrid",
      spec_quelle: "sma-stpse-db",
      /*
       * Datenblatt seit 2026-08-15. Vorher stand hier die Batterie-Zulassungsliste
       * als Quelle, weil die Datei mit „Datenblatt" im Namen genau die ist. Die
       * Zulassungsliste bleibt die Quelle für die Freigaben je Batterie; die
       * Geräteleistungen kommen jetzt aus dem echten Blatt.
       *
       * Die Zeile „Max. Ladeleistung / max. Entladeleistung" fasst 8.0 und 10.0
       * in einer Zelle zusammen — beide 10.600 W. Das ist am Seitenbild geprüft,
       * nicht aus dem Textauszug geraten.
       *
       * Kein `bat_strom_a`: Die 30 A des Blattes gelten laut Fußnote nur bei
       * einer Batteriespannung über 220 V. Unsere Rechnung Strom × Turmspannung
       * greift aber gerade bei den niedrigen Türmen — dort wäre der Wert nicht
       * gedeckt und die Rechnung zu optimistisch. Die Leistungsangaben oben
       * gelten unbedingt und reichen.
       */
      spec_hinweis: "AC-Nennleistung = Datenblattzeile „Bemessungsleistung (bei 230 V, 50 Hz)“. "
        + "Batteriegrenze = „Max. Ladeleistung / max. Entladeleistung“, laut Fußnote abhängig von "
        + "der angeschlossenen Batterie; die Batterie-Zulassungsliste nennt die vermessenen Werte "
        + "je Batteriemodell für den STP10.0.",
      varianten: [
        {
          id: "stpse-5.0",
          name: "STP5.0-3SE-40",
          ac_kw: 5.0,
          bat_lade_kw: 7.5,
          bat_entlade_kw: 6.0
        },
        {
          id: "stpse-6.0",
          name: "STP6.0-3SE-40",
          ac_kw: 6.0,
          bat_lade_kw: 9.0,
          bat_entlade_kw: 7.2
        },
        {
          id: "stpse-8.0",
          name: "STP8.0-3SE-40",
          ac_kw: 8.0,
          bat_lade_kw: 10.6,
          bat_entlade_kw: 10.6
        },
        {
          id: "stpse-10.0",
          name: "STP10.0-3SE-40",
          ac_kw: 10.0,
          bat_lade_kw: 10.6,
          bat_entlade_kw: 10.6
        }
      ]
    },
    {
      id: "sma-sunny-tripower-hybrid-x",
      hersteller: "SMA",
      name: "Sunny Tripower Hybrid X",
      typ: "hybrid",
      spec_quelle: "sma-stp-hybrid-x-klein",
      strom_hinweis: 'Datenblattzeilen „Max. nutzbarer Ladestrom 50 A“ und „Max. nutzbarer Entladestrom 50 A“ im Abschnitt „DC-Eingang Batterie“ (beide Datenblätter, klein und groß).',
      spec_hinweis: "Dreiphasiger Hybrid-WR mit Batterie-DC-Eingang (80–600 V bzw. 120–800 V bei 20–30). Laden und Entladen getrennt dokumentiert (\"Max. nutzbare Ladeleistung\" / \"Max. nutzbare Entladeleistung\"). Kompatible Batterien laut Datenblatt: SMA Home Storage, SMA Storage M, BYD Battery-Box HVB/HVS+/HVM+. Modelle 20/25/30 aus separatem (preliminary) Datenblatt.",
      varianten: [
        {
          id: "stph-5",
          name: "Sunny Tripower Hybrid X 5",
          ac_kw: 5,
          bat_lade_kw: 10,
          bat_entlade_kw: 5,
          bat_strom_a: 50
        },
        {
          id: "stph-6",
          name: "Sunny Tripower Hybrid X 6",
          ac_kw: 6,
          bat_lade_kw: 10,
          bat_entlade_kw: 6,
          bat_strom_a: 50
        },
        {
          id: "stph-8",
          name: "Sunny Tripower Hybrid X 8",
          ac_kw: 8,
          bat_lade_kw: 10,
          bat_entlade_kw: 8,
          bat_strom_a: 50
        },
        {
          id: "stph-10",
          name: "Sunny Tripower Hybrid X 10",
          ac_kw: 10,
          bat_lade_kw: 15,
          bat_entlade_kw: 10,
          bat_strom_a: 50
        },
        {
          id: "stph-12",
          name: "Sunny Tripower Hybrid X 12",
          ac_kw: 12,
          bat_lade_kw: 15,
          bat_entlade_kw: 12,
          bat_strom_a: 50
        },
        {
          id: "stph-15",
          name: "Sunny Tripower Hybrid X 15",
          ac_kw: 15,
          bat_lade_kw: 15,
          bat_entlade_kw: 15,
          bat_strom_a: 50
        },
        {
          id: "stph-20",
          name: "Sunny Tripower Hybrid X 20",
          ac_kw: 20,
          bat_lade_kw: 29.99,
          bat_entlade_kw: 20,
          bat_strom_a: 50
        },
        {
          id: "stph-25",
          name: "Sunny Tripower Hybrid X 25",
          ac_kw: 25,
          bat_lade_kw: 29.99,
          bat_entlade_kw: 25,
          bat_strom_a: 50
        },
        {
          id: "stph-30",
          name: "Sunny Tripower Hybrid X 30",
          ac_kw: 29.99,
          bat_lade_kw: 29.99,
          bat_entlade_kw: 29.99,
          bat_strom_a: 50
        }
      ]
    },
    {
      id: "deye-sun-sg-hybrid",
      hersteller: "Deye",
      name: "SUN SG-Serie (Hybrid)",
      typ: "hybrid",
      spec_quelle: "deye-sg01hp3-db",
      /*
       * Zwei Datenblaetter liegen vor (SG01HP3-EU-AM2 5–25 kW und
       * SG02HP3-EU-EM6 60–80 kW); daraus stammt die AC-Nennleistung je Modell.
       *
       * Die Batteriegrenzen bleiben BEWUSST offen: Die Datenblaetter nennen fuer
       * den Batterieeingang nur einen Spannungsbereich (160–700 V bzw.
       * 160–1000 V) und Maximalstroeme, deren Zuordnung zu den einzelnen
       * Modellen ueber verbundene Tabellenzellen laeuft und damit nicht
       * eindeutig ablesbar ist. Aus einem Spannungsbereich eine Leistung zu
       * rechnen hiesse, eine Spannung zu waehlen — also zu schaetzen.
       * Die Baureihen ohne Datenblatt (AM3, BM3, BM4) behalten ihre
       * Sammelbezeichnung aus der Deye Approved Battery List.
       */
      spec_hinweis: "AC-Nennleistung laut Deye-Datenblatt je Modell. Batterieeingang: Spannungsbereich 160–700 V (SG01HP3-EU-AM2) bzw. 160–1000 V (SG02HP3-EU-EM6), max. Lade-/Entladestrom 30–50 A bzw. 80+80 A — die Zuordnung der Ströme zu den einzelnen Modellen ist im Datenblatt nicht eindeutig, deshalb keine Batteriegrenze in kW.",
      varianten: [
        { id: "deye-sun-5k-sg01hp3", name: "SUN-5K-SG01HP3-EU-AM2", ac_kw: 5, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-6k-sg01hp3", name: "SUN-6K-SG01HP3-EU-AM2", ac_kw: 6, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-8k-sg01hp3", name: "SUN-8K-SG01HP3-EU-AM2", ac_kw: 8, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-10k-sg01hp3", name: "SUN-10K-SG01HP3-EU-AM2", ac_kw: 10, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-12k-sg01hp3", name: "SUN-12K-SG01HP3-EU-AM2", ac_kw: 12, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-15k-sg01hp3", name: "SUN-15K-SG01HP3-EU-AM2", ac_kw: 15, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-20k-sg01hp3", name: "SUN-20K-SG01HP3-EU-AM2", ac_kw: 20, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-25k-sg01hp3", name: "SUN-25K-SG01HP3-EU-AM2", ac_kw: 25, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-60k-sg02hp3-em6", name: "SUN-60K-SG02HP3-EU-EM6", ac_kw: 60, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-75k-sg02hp3-em6", name: "SUN-75K-SG02HP3-EU-EM6", ac_kw: 75, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "deye-sun-80k-sg02hp3-em6", name: "SUN-80K-SG02HP3-EU-EM6", ac_kw: 80, bat_lade_kw: null, bat_entlade_kw: null },
        /*
         * Bis 2026-09-07 ohne AC-Wert: Die Deye Approved Battery List fuehrte
         * den 70K, das uns vorliegende EM6-Datenblatt nicht. Die Fassung, die
         * Deye seit Oktober 2025 selbst ausliefert, fuehrt ihn — Kopfzeile
         * "SUN-60/70/75/80K-SG02HP3-EU-EM6", Spalte "SUN-70K-SG02HP3",
         * "Rated AC Input/Output Active Power (W) 60000 70000 75000 80000".
         * Abgeschrieben, nicht zwischen 60 und 75 interpoliert (#92).
         */
        { id: "deye-sun-70k-sg02hp3-em6", name: "SUN-70K-SG02HP3-EU-EM6", ac_kw: 70, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "sun-sg02hp3-eu-am3", name: "SUN-25/29.9/30K-SG02HP3-EU-AM3", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "sun-sg01hp3-eu-bm3", name: "SUN-30/35K-SG01HP3-EU-BM3", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: "sun-sg01hp3-eu-bm4", name: "SUN-40/50K-SG01HP3-EU-BM4", ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null }
      ]
    },
    {
      id: 'sungrow-sh-t',
      hersteller: 'Sungrow',
      name: 'SH-T Hybrid (15–25 kW)',
      typ: 'hybrid',
      spec_quelle: 'sungrow-sh-t-db',
      spec_hinweis: 'Batteriegrenzen = „Max. charge / discharge power" (je Modell getrennt). '
        + 'Laden bis 30 kW erfolgt DC-seitig aus PV-Überschuss; Batteriestrom max. 50 A.',
      varianten: [
        { id: 'sh15t', name: 'SH15T', ac_kw: 15.0, bat_lade_kw: 30.0, bat_entlade_kw: 15.0 },
        { id: 'sh20t', name: 'SH20T', ac_kw: 20.0, bat_lade_kw: 30.0, bat_entlade_kw: 20.0 },
        { id: 'sh25t', name: 'SH25T', ac_kw: 25.0, bat_lade_kw: 30.0, bat_entlade_kw: 25.0 },
      ],
    },
    {
      /*
       * Gleiche Baureihe wie SH15/20/25T, aber eigenes Sungrow-Datenblatt
       * (SH5/6/8/10/12T, EUROPE V1.1) — deshalb eine eigene Familie, wie überall
       * sonst gilt: eine Familie je Datenblatt, damit spec_quelle exakt zitiert.
       */
      id: 'sungrow-sh5-12t',
      hersteller: 'Sungrow',
      name: 'SH-T Hybrid (5–12 kW)',
      typ: 'hybrid',
      spec_quelle: 'sungrow-sh5-12t-db',
      spec_hinweis: 'Batteriegrenzen = „Max. charge / discharge power" (je Modell getrennt): '
        + 'Laden einheitlich 15 kW (DC-seitig aus PV-Überschuss), Entladen = AC-Nennleistung. '
        + 'Batteriestrom max. 50 A.',
      varianten: [
        { id: 'sh5t', name: 'SH5T', ac_kw: 5.0, bat_lade_kw: 15.0, bat_entlade_kw: 5.0 },
        { id: 'sh6t', name: 'SH6T', ac_kw: 6.0, bat_lade_kw: 15.0, bat_entlade_kw: 6.0 },
        { id: 'sh8t', name: 'SH8T', ac_kw: 8.0, bat_lade_kw: 15.0, bat_entlade_kw: 8.0 },
        { id: 'sh10t', name: 'SH10T', ac_kw: 10.0, bat_lade_kw: 15.0, bat_entlade_kw: 10.0 },
        { id: 'sh12t', name: 'SH12T', ac_kw: 12.0, bat_lade_kw: 15.0, bat_entlade_kw: 12.0 },
      ],
    },
    {
      id: 'growatt-mid-xh',
      hersteller: 'Growatt',
      name: 'MID KTL3-XH',
      typ: 'hybrid',
      spec_quelle: 'growatt-mid-xh-db',
      spec_hinweis: 'Batteriegrenze = „Max. Ladeleistung / Max. Entladeleistung": 15 kW je '
        + 'Batterieanschluss (25 A), 30 kW nur bei Belegung beider Anschlüsse mit zwei Türmen. '
        + 'Angesetzt ist der Wert für einen Anschluss. Datenblatt trägt den Vermerk „Preliminary".',
      varianten: [
        { id: 'mid-11ktl3-xh', name: 'MID 11KTL3-XH', ac_kw: 11.0, bat_lade_kw: 15.0, bat_entlade_kw: 15.0 },
        { id: 'mid-12ktl3-xh', name: 'MID 12KTL3-XH', ac_kw: 12.0, bat_lade_kw: 15.0, bat_entlade_kw: 15.0 },
        { id: 'mid-13ktl3-xh', name: 'MID 13KTL3-XH', ac_kw: 13.0, bat_lade_kw: 15.0, bat_entlade_kw: 15.0 },
        { id: 'mid-15ktl3-xh', name: 'MID 15KTL3-XH', ac_kw: 15.0, bat_lade_kw: 15.0, bat_entlade_kw: 15.0 },
        { id: 'mid-17ktl3-xh', name: 'MID 17KTL3-XH', ac_kw: 17.0, bat_lade_kw: 15.0, bat_entlade_kw: 15.0 },
        { id: 'mid-20ktl3-xh', name: 'MID 20KTL3-XH', ac_kw: 20.0, bat_lade_kw: 15.0, bat_entlade_kw: 15.0 },
        { id: 'mid-25ktl3-xh', name: 'MID 25KTL3-XH', ac_kw: 25.0, bat_lade_kw: 15.0, bat_entlade_kw: 15.0 },
        { id: 'mid-30ktl3-xh', name: 'MID 30KTL3-XH', ac_kw: 30.0, bat_lade_kw: 15.0, bat_entlade_kw: 15.0 },
      ],
    },
    {
      id: 'huawei-sun2000-m1',
      hersteller: 'Huawei',
      name: 'SUN2000 KTL-M1',
      typ: 'hybrid',
      spec_quelle: 'huawei-sun2000-m1',
      spec_hinweis: 'Batteriegrenzen = „Max charge Power" (10 kW, alle Modelle) und '
        + '„Max discharge Power" (je Modell). Batteriestrom max. 16 A.',
      varianten: [
        { id: 'sun2000-3ktl-m1', name: 'SUN2000-3KTL-M1', ac_kw: 3.0, bat_lade_kw: 10.0, bat_entlade_kw: 3.3 },
        { id: 'sun2000-4ktl-m1', name: 'SUN2000-4KTL-M1', ac_kw: 4.0, bat_lade_kw: 10.0, bat_entlade_kw: 4.4 },
        { id: 'sun2000-5ktl-m1', name: 'SUN2000-5KTL-M1', ac_kw: 5.0, bat_lade_kw: 10.0, bat_entlade_kw: 5.5 },
        { id: 'sun2000-6ktl-m1', name: 'SUN2000-6KTL-M1', ac_kw: 6.0, bat_lade_kw: 10.0, bat_entlade_kw: 6.6 },
        { id: 'sun2000-8ktl-m1', name: 'SUN2000-8KTL-M1', ac_kw: 8.0, bat_lade_kw: 10.0, bat_entlade_kw: 8.8 },
        { id: 'sun2000-10ktl-m1', name: 'SUN2000-10KTL-M1', ac_kw: 10.0, bat_lade_kw: 10.0, bat_entlade_kw: 10.0 },
      ],
    },
    {
      id: 'huawei-sun2000-map0',
      hersteller: 'Huawei',
      name: 'SUN2000 K-MAP0',
      typ: 'hybrid',
      spec_quelle: 'huawei-sun2000-map0',
      spec_hinweis: 'Batteriegrenzen = „Max. charging power" (12 kW, alle Modelle) und '
        + '„Max. discharging power" (je Modell). Batteriestrom max. 20 A.',
      varianten: [
        { id: 'sun2000-5k-map0', name: 'SUN2000-5K-MAP0', ac_kw: 5.0, bat_lade_kw: 12.0, bat_entlade_kw: 5.5 },
        { id: 'sun2000-6k-map0', name: 'SUN2000-6K-MAP0', ac_kw: 6.0, bat_lade_kw: 12.0, bat_entlade_kw: 6.6 },
        { id: 'sun2000-8k-map0', name: 'SUN2000-8K-MAP0', ac_kw: 8.0, bat_lade_kw: 12.0, bat_entlade_kw: 8.8 },
        { id: 'sun2000-10k-map0', name: 'SUN2000-10K-MAP0', ac_kw: 10.0, bat_lade_kw: 12.0, bat_entlade_kw: 11.0 },
        { id: 'sun2000-12k-map0', name: 'SUN2000-12K-MAP0', ac_kw: 12.0, bat_lade_kw: 12.0, bat_entlade_kw: 12.0 },
      ],
    },
    {
      /*
       * Integriertes Komplettsystem: Wechselrichter und Batteriemodule sind EIN
       * Produkt. In der Datenbasis trotzdem als WR-Familie + Speicher-Familie
       * modelliert, damit Auswahl, Rechnung und Freigabe-Anzeige dem gewohnten
       * Muster folgen — die Freigabe trägt das Systemdatenblatt selbst.
       */
      id: 'solax-x3-ies',
      hersteller: 'SolaX',
      name: 'X3-IES (Komplettsystem)',
      typ: 'hybrid',
      spec_quelle: 'solax-x3-ies-db-v18',
      spec_hinweis: 'Batteriegrenze laut Fußnote des Systemdatenblatts: „The max. charge/discharge '
        + 'power must not exceed the rated output power". Je Variante gilt die AC-Nennleistung '
        + 'als Lade- und Entladegrenze. Batteriestrom max. 50 A.',
      varianten: [
        { id: 'x3-ies-4k', name: 'X3-IES-4K', ac_kw: 4.0, bat_lade_kw: 4.0, bat_entlade_kw: 4.0 },
        { id: 'x3-ies-5k', name: 'X3-IES-5K', ac_kw: 5.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0 },
        { id: 'x3-ies-6k', name: 'X3-IES-6K', ac_kw: 6.0, bat_lade_kw: 6.0, bat_entlade_kw: 6.0 },
        { id: 'x3-ies-8k', name: 'X3-IES-8K', ac_kw: 8.0, bat_lade_kw: 8.0, bat_entlade_kw: 8.0 },
        { id: 'x3-ies-10k', name: 'X3-IES-10K', ac_kw: 10.0, bat_lade_kw: 10.0, bat_entlade_kw: 10.0 },
        { id: 'x3-ies-12k', name: 'X3-IES-12K', ac_kw: 12.0, bat_lade_kw: 12.0, bat_entlade_kw: 12.0 },
        { id: 'x3-ies-15k', name: 'X3-IES-15K', ac_kw: 15.0, bat_lade_kw: 15.0, bat_entlade_kw: 15.0 },
      ],
    },

    /* ---- GoodWe ESA (Leistungsmodul) — recherchiert 2026-08-09 ----
     * Das ist die Reihe, die inselvolt tatsaechlich fuehrt (ETA-G20 dreiphasig,
     * EHA-G20 einphasig). Sie ist NICHT die ET-/ET-20-Reihe: Die Dyness-Listen
     * fuehren ET, ET-20, BT, EH, BH und EHB — keine ESA-Zeile. Die beiden
     * Familien deshalb strikt getrennt halten.
     */
    {
      id: 'goodwe-esa-eta-g20',
      hersteller: 'GoodWe',
      name: 'ESA-Serie dreiphasig (ETA-G20)',
      typ: 'hybrid',
      spec_quelle: 'goodwe-esa-5-30-db',
      spec_hinweis: 'Batteriegrenzen = "Max. Charging Power" / "Max. Discharging Power" je Modell (Datenblatt-Zeilen, nicht gerechnet). Batterieeingang 700–950 V, Nennspannung 750 V, Startspannung 720 V. Die ESA ist ein vorverdrahtetes Gesamtsystem aus Leistungs- und Batteriemodul; das Datenblatt führt beide getrennt auf.',
      varianten: [
        { id: 'gw5k-eta-g20', name: 'GW5K-ETA-G20', ac_kw: 5, bat_lade_kw: 5.0, bat_entlade_kw: 5.5 },
        { id: 'gw6k-eta-g20', name: 'GW6K-ETA-G20', ac_kw: 6, bat_lade_kw: 6.0, bat_entlade_kw: 6.6 },
        { id: 'gw8k-eta-g20', name: 'GW8K-ETA-G20', ac_kw: 8, bat_lade_kw: 8.0, bat_entlade_kw: 8.8 },
        { id: 'gw9-999k-eta-g20', name: 'GW9.999K-ETA-G20', ac_kw: 9.999, bat_lade_kw: 10.0, bat_entlade_kw: 11.0 },
        { id: 'gw10k-eta-g20', name: 'GW10K-ETA-G20', ac_kw: 10, bat_lade_kw: 10.0, bat_entlade_kw: 11.0 },
        { id: 'gw12k-eta-g20', name: 'GW12K-ETA-G20', ac_kw: 12, bat_lade_kw: 12.0, bat_entlade_kw: 13.2 },
        { id: 'gw15k-eta-g20', name: 'GW15K-ETA-G20', ac_kw: 15, bat_lade_kw: 15.0, bat_entlade_kw: 16.5 },
        { id: 'gw20k-eta-g20', name: 'GW20K-ETA-G20', ac_kw: 20, bat_lade_kw: 20.0, bat_entlade_kw: 22.0 },
        { id: 'gw25k-eta-g20', name: 'GW25K-ETA-G20', ac_kw: 25, bat_lade_kw: 25.0, bat_entlade_kw: 27.5 },
        { id: 'gw29-999k-eta-g20', name: 'GW29.999K-ETA-G20', ac_kw: 29.999, bat_lade_kw: 30.0, bat_entlade_kw: 33.0 },
        { id: 'gw30k-eta-g20', name: 'GW30K-ETA-G20', ac_kw: 30, bat_lade_kw: 30.0, bat_entlade_kw: 33.0 },
      ],
    },
    {
      id: 'goodwe-esa-eha-g20',
      hersteller: 'GoodWe',
      name: 'ESA-Serie einphasig (EHA-G20)',
      typ: 'hybrid',
      spec_quelle: 'goodwe-esa-3-10-db',
      spec_hinweis: 'Batteriegrenzen = "Max. Charging Power" / "Max. Discharging Power" je Modell (Datenblatt-Zeilen, nicht gerechnet). Batterieeingang 350–550 V, Nennspannung 380 V, Startspannung 380 V. Die ESA ist ein vorverdrahtetes Gesamtsystem aus Leistungs- und Batteriemodul; das Datenblatt führt beide getrennt auf.',
      varianten: [
        { id: 'gw3k-eha-g20', name: 'GW3K-EHA-G20', ac_kw: 3.0, bat_lade_kw: 4.5, bat_entlade_kw: 3.3 },
        { id: 'gw3-6k-eha-g20', name: 'GW3.6K-EHA-G20', ac_kw: 3.6, bat_lade_kw: 5.4, bat_entlade_kw: 3.96 },
        { id: 'gw5k-eha-g20', name: 'GW5K-EHA-G20', ac_kw: 5.0, bat_lade_kw: 7.5, bat_entlade_kw: 5.5 },
        { id: 'gw6k-eha-g20', name: 'GW6K-EHA-G20', ac_kw: 6.0, bat_lade_kw: 9.0, bat_entlade_kw: 6.6 },
        { id: 'gw8k-eha-g20', name: 'GW8K-EHA-G20', ac_kw: 8.0, bat_lade_kw: 12.0, bat_entlade_kw: 8.8 },
        { id: 'gw9-999k-eha-g20', name: 'GW9.999K-EHA-G20', ac_kw: 9.999, bat_lade_kw: 13.5, bat_entlade_kw: 11.0 },
        { id: 'gw10k-eha-g20', name: 'GW10K-EHA-G20', ac_kw: 10.0, bat_lade_kw: 13.5, bat_entlade_kw: 11.0 },
      ],
    },

    /* ---- Aus dem ZYC-SIMPO5000-Statement (22.04.2024) ---- */
    {
      /*
       * Sunny Island X — neue Baureihe, angelegt 2026-09-07 (Rezept D).
       *
       * NICHT zu verwechseln mit der klassischen Sunny-Island-Reihe darunter:
       * Das ist ein Niedervolt-Batteriewechselrichter (SI 4.4M / 6.0H / 8.0H),
       * der X ist Hochvolt (200-980 V DC) und dreiphasig. Gleicher Markenname,
       * anderes Geraet — deshalb eine eigene Familie und kein Anhaengsel.
       *
       * Alle Werte aus der Tabelle "Technische Daten" des Datenblatts
       * SIxx-20-DS-de-21, Abschnitt "Batterieanschluss (DC)" und
       * "Netzanschluss (AC)". Auch die 30 und 50 kW sind abgeschrieben, nicht
       * aus dem Produktnamen geschlossen — der Name ist keine Quelle.
       *
       * bat_lade_kw / bat_entlade_kw = "Max. DC-Leistung" (30.600 W / 51.000 W).
       * Das ist eine ausdrueckliche Herstellerangabe fuer den Batterieanschluss
       * und gilt damit vor jeder Rechnung (Belegpflicht Stufe 1). Der Strom
       * steht zusaetzlich als bat_strom_a: 150 A ("Max. nutzbarer
       * Eingangsstrom IDC max"), damit die Engine die Paarungsgrenze je
       * Turmgroesse gegenrechnen kann — bei Gleichstand gewinnt die belegte
       * Angabe (Invariante 3).
       */
      id: 'sma-sunny-island-x',
      hersteller: 'SMA',
      name: 'Sunny Island X',
      typ: 'batterie',
      spec_quelle: 'sma-si-x-db',
      spec_hinweis: 'Dreiphasiger Hochvolt-Batteriewechselrichter. DC-Spannungsbereich 200–980 V '
        + '(SI50-20 bei Nennleistung 350–980 V), max. nutzbarer Eingangsstrom 150 A, Batterietyp '
        + 'Li-Ion über Modbus TCP oder CAN-Bus. Lade-/Entladeleistung = „Max. DC-Leistung" laut '
        + 'Datenblatt SIxx-20-DS-de-21.',
      varianten: [
        {
          id: 'si30-20',
          name: 'Sunny Island X 30 (SI30-20)',
          ac_kw: 30,
          bat_lade_kw: 30.6,
          bat_entlade_kw: 30.6,
          bat_strom_a: 150,
        },
        {
          id: 'si50-20',
          name: 'Sunny Island X 50 (SI50-20)',
          ac_kw: 50,
          bat_lade_kw: 51,
          bat_entlade_kw: 51,
          bat_strom_a: 150,
        },
      ],
    },
    {
      id: 'sma-sunny-island',
      hersteller: 'SMA',
      name: 'Sunny Island (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: ZYC_OHNE_DATENBLATT,
      varianten: [
        { id: 'si-4-4m', name: 'SI 4.4M', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'si-6-0h', name: 'SI 6.0H', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'si-8-0h', name: 'SI 8.0H', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'selectronic-spmc',
      hersteller: 'Selectronic',
      name: 'SP PRO SPMC-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: ZYC_OHNE_DATENBLATT,
      varianten: [
        { id: 'spmc480-au', name: 'SPMC480-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'spmc481-au', name: 'SPMC481-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'spmc482-au', name: 'SPMC482-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'studer-xt',
      hersteller: 'Studer',
      name: 'XT / Next3 / VarioTrack (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: ZYC_OHNE_DATENBLATT,
      varianten: [
        { id: 'xts-1400-48', name: 'XTS 1400-48', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'xtm-2600-48', name: 'XTM 2600-48', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'xtm-4000-48', name: 'XTM 4000-48', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'xth-6000-48', name: 'XTH 6000-48', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'xth-8000-48', name: 'XTH 8000-48', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'next3', name: 'Next3', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'vt-40', name: 'VT-40', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'vt-65', name: 'VT-65', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'vt-80', name: 'VT-80', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'vs-70', name: 'VS-70', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'vs-120', name: 'VS-120', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'noark-ex9n-dh',
      hersteller: 'Noark',
      name: 'Ex9N-DH-Serie (Niedervolt)',
      typ: 'hybrid',
      spannungsklasse: 'niedervolt',
      spec_quelle: null,
      spec_hinweis: ZYC_OHNE_DATENBLATT,
      varianten: [
        { id: 'ex9n-dh-3ks-au', name: 'Ex9N-DH-3KS-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-3ks-24-au', name: 'Ex9N-DH-3KS-24-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-3-6ks-au', name: 'Ex9N-DH-3.6KS-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-5ks-au', name: 'Ex9N-DH-5KS-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-6ks-au', name: 'Ex9N-DH-6KS-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-7-6ks-au', name: 'Ex9N-DH-7.6KS-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-8ks-au', name: 'Ex9N-DH-8KS-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-5kt-au', name: 'Ex9N-DH-5KT-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-6kt-au', name: 'Ex9N-DH-6KT-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-8kt-au', name: 'Ex9N-DH-8KT-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-10kt-au', name: 'Ex9N-DH-10KT-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ex9n-dh-12kt-au', name: 'Ex9N-DH-12KT-AU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },

    /* ---- Aus der Dyness-STACK100-Liste (28.09.2025), ohne eigenes Datenblatt ----
     * Vier Zeilen, die keine der bisher eingelesenen Listen fuehrt.
     */
    {
      id: 'growatt-wit',
      hersteller: 'Growatt',
      name: 'WIT-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'wit-50-100k', name: 'WIT 50~100K', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'wit-29-9-50k-xhu', name: 'WIT 29.9~50K-XHU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },

    /* ---- Aus den Dyness-Turmlisten (Pro / S2 / S3), ohne eigenes Datenblatt ----
     * 35 Baureihen von 30 Herstellern, die die drei Listen freigeben. Aufgenommen am
     * 2026-08-09, nachdem der Katalog zuvor nur die Marken enthielt, die inselvolt fuehrt.
     */
    {
      id: 'afore-af-hv',
      hersteller: 'Afore',
      name: 'AF-DH / AF-TH (Hochvolt)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'af3k-9-6k-dh', name: 'AF3K~9.6K-DH', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'af3k-30k-th', name: 'AF3K~30K-TH', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'atess-hps',
      hersteller: 'ATESS',
      name: 'HPS-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'hps-30000-50000tl', name: 'HPS30000/40000/50000TL', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'hps-5000-10000tls', name: 'HPS 5000/7500/10000TLS', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'hps-30-150', name: 'HPS 30/50/100/120/150', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'autarco-lh',
      hersteller: 'Autarco',
      name: 'S2.LH / LH-MII',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 's2-lh-5k-10k', name: 'S2.LH 5K~10K', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'lh5k-10k-mii', name: 'LH5K~10K-MII', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'bluesun-bse',
      hersteller: 'Bluesun',
      name: 'BSE-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'bse12khina', name: 'BSE12KHINA', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'dunext-hybrid',
      hersteller: 'DUNEXT',
      name: 'NI / DN3H',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'ni-hv3-6', name: 'NI HV3.0-6.0', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'dn3h-6-10ktl', name: 'DN3H 6-10KTL', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'ecactus-wh',
      hersteller: 'Ecactus',
      name: 'WH-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'wh-spa-3-6-5-0h', name: 'WH-SPA-3.6/5.0H', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'wh-shc-362-602', name: 'WH-SHC-362~602', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'goodwe-et-5-10',
      hersteller: 'GoodWe',
      name: 'ET-Serie (GW5K–10K ET, inkl. ET PLUS+)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'gw5k-10k-et', name: 'GW5K-10K-ET', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'goodwe-et-15-30',
      hersteller: 'GoodWe',
      name: 'ET-Serie (GW15–30K ET)',
      typ: 'hybrid',
      spec_quelle: 'goodwe-et-15-30-db',
      spec_hinweis: 'Batteriegrenzen = „Max. Charging Power (W)" / „Max. Discharging Power (W)" je Modell; '
        + 'Lade- und Entladewert sind hier gleich. Batterie 500 V nominal, 200–800 V. '
        + 'GW29.9K-ET: AC-Nennleistung laut Datenblatt 29.900 W.',
      strom_hinweis: 'Batteriestrom aus „Max. Continuous Charging/Discharging Current (A)": 50 A bei GW15K und '
        + 'GW20K. Beide mit EINEM Batterieeingang. GW25K und GW29.9K haben ZWEI Eingänge („50 × 2"); '
        + 'was davon an einem einzelnen Speicherturm ankommt, sagt das Blatt nicht. Deshalb bleibt der Wert '
        + 'dort leer, statt eine Paarungsgrenze zu errechnen, die der Hersteller so nie ausgesprochen hat.',
      varianten: [
        { id: 'gw15k-et', name: 'GW15K-ET', ac_kw: 15, bat_lade_kw: 15.0, bat_entlade_kw: 15.0, bat_strom_a: 50 },
        { id: 'gw20k-et', name: 'GW20K-ET', ac_kw: 20, bat_lade_kw: 20.0, bat_entlade_kw: 20.0, bat_strom_a: 50 },
        { id: 'gw25k-et', name: 'GW25K-ET', ac_kw: 25, bat_lade_kw: 25.0, bat_entlade_kw: 25.0 },
        { id: 'gw29-9k-et', name: 'GW29.9K-ET', ac_kw: 29.9, bat_lade_kw: 30.0, bat_entlade_kw: 30.0 },
      ],
    },
    {
      id: 'goodwe-et-40-50',
      hersteller: 'GoodWe',
      name: 'ET-Serie (GW40–50K ET-10)',
      typ: 'hybrid',
      spec_quelle: 'goodwe-et-40-50-db',
      spec_hinweis: 'Batteriegrenzen = „Max. Charging Power (W)" / „Max. Discharging Power (W)" je Modell; '
        + 'Lade- und Entladewert sind hier gleich und liegen über der AC-Nennleistung (44 kW bei 40 kW AC). '
        + 'Batterie 500 V nominal, 200–800 V, ein Batterieeingang.',
      strom_hinweis: 'Batteriestrom aus „Max. Continuous Charging/Discharging Current (A)": 100 A, ein Eingang, '
        + 'für beide Modelle derselbe Wert.',
      varianten: [
        { id: 'gw40k-et-10', name: 'GW40K-ET-10', ac_kw: 40, bat_lade_kw: 44.0, bat_entlade_kw: 44.0, bat_strom_a: 100 },
        { id: 'gw50k-et-10', name: 'GW50K-ET-10', ac_kw: 50, bat_lade_kw: 55.0, bat_entlade_kw: 55.0, bat_strom_a: 100 },
      ],
    },
    {
      id: 'goodwe-bt',
      hersteller: 'GoodWe',
      name: 'BT-Serie (5–10 kW)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'bt-5k-10k', name: 'BT(5K-10K)', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'goodwe-eh',
      hersteller: 'GoodWe',
      name: 'EH-Serie (3–6 kW)',
      typ: 'hybrid',
      spec_quelle: 'goodwe-eh-plus-db',
      spec_hinweis: 'Deutsches Datenblatt der EH PLUS+ Serie. AC-Nennleistung = „Nenn-Scheinleistung an das '
        + 'Stromversorgungsnetz (VA)". Entladen = „Max. Entladeleistung (W)" je Modell. Laden = „Max. '
        + 'Ladeleistung (W)": Das Blatt nennt dafür EINEN Wert (6.000 W) für alle drei Modelle. Er steht '
        + 'deshalb auch beim 3,6-kW-Gerät, obwohl er über dessen AC-Leistung liegt; geladen wird DC-seitig. '
        + 'Batterie 350 V nominal, 85–460 V.',
      strom_hinweis: 'Batteriestrom aus „Max. Dauerladestrom (A)" / „Max. Dauerentladestrom (A)": 25 A, '
        + 'im Blatt als ein Wert für die ganze Baureihe geführt.',
      varianten: [
        { id: 'gw3600n-eh', name: 'GW3600N-EH', ac_kw: 3.6, bat_lade_kw: 6.0, bat_entlade_kw: 3.6, bat_strom_a: 25 },
        { id: 'gw5000n-eh', name: 'GW5000N-EH', ac_kw: 5.0, bat_lade_kw: 6.0, bat_entlade_kw: 5.0, bat_strom_a: 25 },
        { id: 'gw6000n-eh', name: 'GW6000N-EH', ac_kw: 6.0, bat_lade_kw: 6.0, bat_entlade_kw: 6.0, bat_strom_a: 25 },
      ],
    },
    {
      id: 'goodwe-bh',
      hersteller: 'GoodWe',
      name: 'BH-Serie (3–6 kW)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'bh-3k-6k', name: 'BH(3K-6K)', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'goodwe-ehb',
      hersteller: 'GoodWe',
      name: 'EHB-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'ehb', name: 'EHB', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'hopewind-hynv',
      hersteller: 'Hopewind',
      name: 'HYNV-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'hynv5-12k-g01', name: 'HYNV5~12K-G01', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'hoymiles-hv',
      hersteller: 'Hoymiles',
      name: 'HY3 / HYT / HAT (Hochvolt)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'hy3-5k-10k-hv', name: 'HY3 5K~10K HV', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'hyt-5-12-hveug1', name: 'HYT-5.0~12.0HVEUG1', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'hat-5-10-hveug1', name: 'HAT-5.0~10.0HVEUG1', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'hypontech-hh',
      hersteller: 'HYPONTECH',
      name: 'HHS / HHT',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'hhs-3680-5000', name: 'HHS-3680/5000', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'hht-5k-12k', name: 'HHT-5K-12K', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'ingeteam-sun-storage',
      hersteller: 'Ingeteam',
      name: 'INGECON SUN STORAGE',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'ingecon-100tl', name: 'INGECON SUN STORAGE 100TL', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ingecon-3tl-6tlm', name: 'INGECON SUN STORAGE 3TL~6TLM', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'jinko-jks',
      hersteller: 'Jinko',
      name: 'JKS-EI-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'jks-6-20h-ei', name: 'JKS-6~20H-EI', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'kaco-blueplanet-hybrid',
      hersteller: 'KACO',
      name: 'blueplanet hybrid NH3',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'bp-hybrid-6-12-nh3', name: 'blueplanet hybrid 6.0 NH3-12.0 NH3', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'koyoe-ky-est',
      hersteller: 'KOYOE',
      name: 'KY-EST-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'ky-est-6k-10kh', name: 'KY-EST-6K~10KH', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'ky-est-12-20kh', name: 'KY-EST-12~20KH', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'magarevo-hv',
      hersteller: 'Megarevo',
      /*
       * Die Dyness-Listen schreiben die Marke in der Textspalte "MAGAREVO",
       * ihr eigenes eingebettetes Logo liest "MEGAREVO". Wir fuehren die Marke
       * einheitlich als "Megarevo" — sonst stuende derselbe Hersteller zweimal
       * in der Auswahl, einmal neben der bereits gefuehrten Niedervolt-Reihe.
       */
      name: 'R-Serie H1/H3 / MEGA (Hochvolt)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'r5k-11k4-h1', name: 'R5K~11K4 H1', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'r6k-12k-h3', name: 'R6K~12K H3', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mega0100ts', name: 'MEGA0100TS', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'renac-n3-hv',
      hersteller: 'RENAC',
      name: 'N3-HV-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'n3-hv-5-10', name: 'N3-HV 5.0~10.0', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'saj-h2',
      hersteller: 'SAJ',
      name: 'H2-Serie (Hochvolt)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'h2-5k-10k-t2', name: 'H2-5K~10K-T2', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'h2-3k-6k-s2', name: 'H2-3K~6K-S2', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'senergy-se-khb',
      hersteller: 'Senergy',
      name: 'SE-KHB-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'se-5-10khb-d3', name: 'SE 5-10KHB-D3', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'sermatec-smt',
      hersteller: 'SERMATEC',
      name: 'SMT-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'smt-10k-tl-th', name: 'SMT-10K-TL-TH', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'sineng-sn',
      hersteller: 'SINENG',
      name: 'SN-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'sn-3-6-0hs', name: 'SN-3.0~6.0HS', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'sn5-15ht', name: 'SN5.0~15HT', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'sinexcel-pw',
      hersteller: 'Sinexcel',
      name: 'PWG2 / PWS1',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'pwg2-50k-100k-cn', name: 'PWG2-50K/100K- CN', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'pws1-150-250k', name: 'PWS1-150~250K', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'solinteg-mh',
      hersteller: 'SOLINTEG',
      name: 'MHT / MHS',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'mht-25-50k-100', name: 'MHT-25~50K-100', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mht-4k-12k-25', name: 'MHT-4K~12K-25', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mht-10k-20k-40', name: 'MHT-10K~20K-40', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'mhs-3k-8k-30', name: 'MHS-3K~8K-30', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'solis-rhi-hves',
      hersteller: 'Solis',
      name: 'RHI-HVES-5G (Hochvolt)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'rhi-3p-5-10k-hves-5g', name: 'RHI-3P(5-10)K-HVES-5G', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'rhi-1p7-6k-hves-5g', name: 'RHI-1P7.6K-HVES-5G', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'solis-s6-eh-hv',
      hersteller: 'Solis',
      name: 'S6-EH-H-Serie (Hochvolt)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 's6-eh3p-3-10k-h-pro', name: 'S6-EH3P(3-10)K-H(PRO)', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 's6-eh3p-5-10k2-h-eu', name: 'S6-EH3P(5-10)K2-H(EU)', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 's6-eh1p-3-8-11-4k-h-us', name: 'S6-EH1P(3.8-11.4)K-H-US', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 's6-eh3p-12-20k-h', name: 'S6-EH3P(12-20)K-H', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 's6-eh3p-29-9-50k-h', name: 'S6-EH3P(29.9-50)K-H', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'solplanet-asw-kh',
      hersteller: 'Solplanet',
      name: 'ASW KH-Serie (Hochvolt)',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'asw08-12kh-t1', name: 'ASW08~12KH-T1', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'asw08-12kh-t3', name: 'ASW08~12KH-T3', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'sosen-sse-hh',
      hersteller: 'SOSEN',
      name: 'SSE-HH-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'sse-hh30-60k-p3', name: 'SSE-HH30-60K-P3(SA/US/EU)', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'sse-hh3-6k-p1eu', name: 'SSE-HH3-6K-P1EU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'sse-hh8-12k-p3eu', name: 'SSE-HH8-12K-P3EU', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'sunways-sth',
      hersteller: 'Sunways',
      name: 'STH-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'sth-4-12-ktl-ht-p-cn', name: 'STH-4~12 KTL-HT-P(CN)', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
        { id: 'sth-3-8k-tl-hs', name: 'STH- 3~8K TL-HS', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'tbb-qoma',
      hersteller: 'TBB power',
      name: 'Qoma-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'qoma33h-h-r', name: 'Qoma33H&H-R', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },
    {
      id: 'thinkpower-eph',
      hersteller: 'Thinkpower',
      name: 'EPH-Serie',
      typ: 'hybrid',
      spec_quelle: null,
      spec_hinweis: DYNESS_OHNE_DATENBLATT,
      varianten: [
        { id: 'eph-4k-12ktl', name: 'EPH 4K~12KTL', ac_kw: null, bat_lade_kw: null, bat_entlade_kw: null },
      ],
    },

    /*
     * SolarEdge, aufgenommen 2026-08-14. Vier Familien, weil SolarEdge vier
     * verschiedene Batteriewelten baut und sie sich NICHT mischen lassen:
     *   Home Hub 3ph  -> 48-V-Batterie (SolarEdge Home Batterie 48V)
     *   StorEdge 3ph  -> 48-V-Batterien, auch die von BYD und LG
     *   Home Hub 1ph  -> 400-V-Batterie
     *   Nexis 3ph     -> Nexis Battery (Hochvolt, 750 V)
     * Die Zeile „Unterstuetzte Batterietypen" der Datenblaetter ist bei
     * SolarEdge selbst schon eine Whitelist — sie traegt die Freigaben mit.
     */
    {
      id: 'solaredge-home-hub-3ph',
      hersteller: 'SolarEdge',
      name: 'Home Hub Wechselrichter dreiphasig',
      typ: 'hybrid',
      /* 48-V-Batterieeingang (40–62 Vdc laut Datenblatt) — Niedervolt. */
      spannungsklasse: 'niedervolt',
      spec_quelle: 'solaredge-hub-3ph-db',
      strom_hinweis: 'Datenblattzeile „Maximaler Dauereingangs-/Dauerausgangsstrom 125 Adc" '
        + 'im Abschnitt „EINGANG/AUSGANG BATTERIE".',
      spec_hinweis: 'Batteriegrenze = Zeile „Maximale Lade-/Entladeleistung 5 000 W". Das Datenblatt '
        + 'nennt EINEN Wert für Laden und Entladen, er steht deshalb auf beiden Feldern. Gilt für '
        + 'alle drei Leistungsklassen gleich; die Entladung ins Hausnetz begrenzt zusätzlich die '
        + 'AC-Nennleistung des jeweiligen Geräts.',
      varianten: [
        { id: 'se5k-rwb48', name: 'SE5K-RWB48', ac_kw: 5.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0, bat_strom_a: 125 },
        { id: 'se8k-rwb48', name: 'SE8K-RWB48', ac_kw: 8.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0, bat_strom_a: 125 },
        { id: 'se10k-rwb48', name: 'SE10K-RWB48', ac_kw: 10.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0, bat_strom_a: 125 },
      ],
    },
    {
      id: 'solaredge-storedge-3ph',
      hersteller: 'SolarEdge',
      name: 'StorEdge Wechselrichter dreiphasig',
      typ: 'hybrid',
      /* 48-V-Batterieeingang (40–62 VDC laut Datenblatt) — Niedervolt. */
      spannungsklasse: 'niedervolt',
      spec_quelle: 'solaredge-storedge-3ph-db',
      strom_hinweis: 'Datenblattzeile „Maximaler Dauereingangsstrom 130 Adc" im Abschnitt '
        + '„EINGANG − BATTERIE".',
      spec_hinweis: 'Batteriegrenze = Zeile „Maximale DC-Leistung 5 000 W" (Abschnitt Batterie). Ein '
        + 'Wert für Laden und Entladen, deshalb auf beiden Feldern. Das Datenblatt lässt genau EINE '
        + 'Batterie je Wechselrichter zu und ist zugleich die Freigabeliste: Es nennt die zulässigen '
        + 'Batteriemodelle namentlich, auch die von BYD und LG.',
      varianten: [
        { id: 'se5k-rws', name: 'SE5K-RWS', ac_kw: 5.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0, bat_strom_a: 130 },
        { id: 'se7k-rws', name: 'SE7K-RWS', ac_kw: 7.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0, bat_strom_a: 130 },
        { id: 'se8k-rws', name: 'SE8K-RWS', ac_kw: 8.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0, bat_strom_a: 130 },
        { id: 'se10k-rws', name: 'SE10K-RWS', ac_kw: 10.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0, bat_strom_a: 130 },
      ],
    },
    {
      /*
       * Einphasige Home Hub. Aufgenommen sind die Geraete, die das Datenblatt
       * fuer Deutschland zulaesst: SE2500H fuehrt es nur fuer Polen, Frankreich
       * und Ungarn, SE8000H und SE10000H nur fuer Grossbritannien, Spanien und
       * Frankreich (Fussnoten 1 und 4). Sie stehen deshalb nicht im Katalog —
       * ein Geraet zu empfehlen, das hier niemand kaufen darf, waere kein
       * Beratungsergebnis. Der SE5000H traegt 4,6 kW statt 5,0: Fussnote 2 des
       * Datenblatts nennt „4 600 VA AC in Deutschland", und die Rechnung darf
       * nie zu hoch greifen.
       */
      id: 'solaredge-home-hub-1ph',
      hersteller: 'SolarEdge',
      name: 'Home Hub Wechselrichter einphasig',
      typ: 'hybrid',
      spec_quelle: 'solaredge-hub-1ph-db',
      spec_hinweis: 'Batteriegrenze = Zeile „Dauerleistung 5 000 W pro Batterie" im Abschnitt '
        + 'BATTERIESPEICHER; ein Wert für Laden und Entladen. Das Datenblatt hält zusätzlich fest, '
        + 'dass die Gesamt-Entladeleistung auf die AC-Nennleistung des Wechselrichters begrenzt ist, '
        + 'genau das rechnet der Berater ohnehin. AC-Wert des SE5000H: 4 600 VA (Datenblatt-Fußnote '
        + 'für Deutschland) statt der 5 000 VA der Haupttabelle.',
      varianten: [
        { id: 'se3000h', name: 'SE3000H', ac_kw: 3.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0 },
        { id: 'se3680h', name: 'SE3680H', ac_kw: 3.68, bat_lade_kw: 5.0, bat_entlade_kw: 5.0 },
        { id: 'se4000h', name: 'SE4000H', ac_kw: 4.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0 },
        { id: 'se5000h', name: 'SE5000H', ac_kw: 4.6, bat_lade_kw: 5.0, bat_entlade_kw: 5.0 },
        { id: 'se6000h', name: 'SE6000H', ac_kw: 6.0, bat_lade_kw: 5.0, bat_entlade_kw: 5.0 },
      ],
    },
    {
      /*
       * Nexis. Alle sechs Leistungsklassen teilen sich EINE Artikelnummer
       * (NX20K-RW000CYN4); welche Klasse ein Geraet wird, entscheidet die
       * Inbetriebnahme (Fussnote 1 des Datenblatts). Die Entladewerte sind die
       * Netzbetrieb-Werte der Zeile „Maximum Discharge Power Ongrid / Offgrid" —
       * der hoehere Offgrid-Wert (20 kW) gilt nur im Ersatzstrombetrieb und
       * gehoert nicht in eine Eigenverbrauchs-Rechnung.
       */
      id: 'solaredge-nexis-3ph',
      hersteller: 'SolarEdge',
      name: 'Nexis Wechselrichter dreiphasig',
      typ: 'hybrid',
      spec_quelle: 'solaredge-nexis-3ph-db',
      spec_hinweis: 'Ladegrenze = Zeile „Maximum Charge Power 28 000 W" (gilt für alle Klassen); '
        + 'Entladegrenze = Zeile „Maximum Discharge Power Ongrid / Offgrid", Netzbetrieb-Wert je '
        + 'Klasse. Der Ladewert ist eine Gerätegrenze. Was tatsächlich ankommt, begrenzt der '
        + 'Speicher (Nexis Battery: 3,5 kW je Block).',
      varianten: [
        { id: 'nx8k', name: 'NX8K', ac_kw: 8.0, bat_lade_kw: 28.0, bat_entlade_kw: 8.0 },
        { id: 'nx10k', name: 'NX10K', ac_kw: 10.0, bat_lade_kw: 28.0, bat_entlade_kw: 10.0 },
        { id: 'nx13k', name: 'NX13K', ac_kw: 12.99, bat_lade_kw: 28.0, bat_entlade_kw: 12.99 },
        { id: 'nx15k', name: 'NX15K', ac_kw: 15.0, bat_lade_kw: 28.0, bat_entlade_kw: 15.0 },
        { id: 'nx17k', name: 'NX17K', ac_kw: 17.0, bat_lade_kw: 28.0, bat_entlade_kw: 17.0 },
        { id: 'nx20k', name: 'NX20K', ac_kw: 20.0, bat_lade_kw: 28.0, bat_entlade_kw: 20.0 },
      ],
    },
  ];

  if (typeof module !== 'undefined' && module.exports) module.exports = WECHSELRICHTER;
  if (root) root.IVBeraterDatenWechselrichter = WECHSELRICHTER;
})(typeof window !== 'undefined' ? window : null);

/*
 * inselvolt Kompatibilitätsberater — Datenbasis, Teil SPEICHER.
 *
 * ÄNDERUNGEN NUR NACH v2/DATENPFLEGE.md (Rezept C). Teil der vierteiligen
 * Datenbasis — Zusammenbau und Schnittstelle: daten/berater-daten.js.
 */
(function (root) {
  'use strict';

  /*
   * Speicher-Familien. Modul-Spezifikationen aus der KOSTAL-Liste 04/2026 (dort je
   * Batterietyp dokumentiert). energie_kwh je Größe = Modulanzahl × Modulenergie
   * (Herleitung, im UI als solche gekennzeichnet). entlade_leistung_kw & garantie_zyklen:
   * Batterie-Datenblätter liegen noch nicht vor ⇒ null.
   */
  var SPEICHER = [
    {
      /*
       * ZYC SIMPO 5000 — die 48-V-Schwester der SIMPO HV. Aufgenommen sind die
       * DREI Konfigurationen, die der Flyer benennt: das Einzelmodul sowie die
       * beiden vorverdrahteten Schraenke. Zwischenstufen (2 bis 5 bzw. 7 bis 9
       * Module) sind zwar moeglich, aber im Blatt keine benannte Groesse — sie
       * hier zu erfinden waere geraten.
       */
      id: 'zyc-simpo5000',
      hersteller: 'ZYC',
      name: 'SIMPO 5000 (Niedervolt)',
      spannungsklasse: 'niedervolt',
      modul: {
        energie_kwh: 5.12,
        spannung_v: 51.2,
        chemie: 'LiFePO4 (LFP)',
        quelle: 'zyc-simpo5000-db'
      },
      spec_quelle: 'zyc-simpo5000-db',
      leistung_herleitung: 'Flyer: Modul 5,12 kWh nutzbar, 51,2 V, "Maximaler Dauerstrom" 100 A '
        + '⇒ 5,12 kW je Modul. Die Schrankwerte bestätigen das unabhängig: "Maximaler Dauerstrom '
        + '(busbar)" 600 A beim Cabinet 6 und 1000 A beim Cabinet 10, mal 51,2 V ergibt genau '
        + '30,72 bzw. 51,2 kW. Der Spitzenstrom (200 A, 5 s) bleibt außen vor.',
      groessen: [
        { groesse: '1 Modul', module: 1, nutzbar_kwh: 5.12, entlade_kw: 5.12, lade_kw: 5.12 },
        { groesse: 'Cabinet 6', module: 6, nutzbar_kwh: 30.72, entlade_kw: 30.72, lade_kw: 30.72 },
        { groesse: 'Cabinet 10', module: 10, nutzbar_kwh: 51.2, entlade_kw: 51.2, lade_kw: 51.2 },
      ],
      garantie_zyklen: null,
      garantie_jahre: 10
    },
    {
      /*
       * Dyness STACK100 — die Reihe stand als "Dyness Stack100 / Stack100 Pro"
       * in der KOSTAL-Komplettuebersicht und fehlte im Katalog. Liste und
       * Datenblatt kamen am 2026-08-09 vom Auftraggeber.
       *
       * LEISTUNG: Das Blatt nennt zwei Stroeme — "Recommended Charge/Discharge
       * Current 50A (0.5C)" und "Max.Charge/Discharge Current 100A (1C)". Wir
       * rechnen mit 50 A. Der 100-A-Wert traegt den Zusatz "continuous" NICHT,
       * und wo zwei Werte im Blatt stehen, nimmt diese Datenbasis den, der
       * sicher eine Dauerangabe ist. Die Rechnung untertreibt damit eher, als
       * dass sie zu viel verspricht. Mit 100 A waere jeder Wert doppelt so hoch.
       */
      /*
       * STACK100 Pro — angelegt 2026-09-07 (Rezept C/D), weil die
       * SMA-Freigabeliste zum Sunny Island X „Stack 100" und „Stack 100 Pro"
       * als ZWEI Zeilen fuehrt. Eine Freigabe fuer den einen ist keine fuer den
       * anderen (Invariante 1), also braucht der Pro einen eigenen Eintrag.
       *
       * Elektrisch ist er je Modul identisch mit dem STACK100 — dasselbe
       * Datenblatt-Bild: 5,12 kWh, 51,2 V, 100 Ah, 3-15 Module, empfohlen
       * 0,5C (50 A), DoD 95 Prozent, "System Energy Range 15,36-76,8 kWh".
       * Verschieden sind Gehaeuse und Aufstellung (IP66 statt IP20,
       * natuerliche statt erzwungener Kuehlung, bis 12 Cluster parallel) und
       * die Modulbezeichnung (S51100 pro). Die Werte sind deshalb dieselben,
       * abgeschrieben aus dem Pro-Datenblatt und nicht vom STACK100 kopiert.
       *
       * Wie beim STACK100 gilt: gerechnet wird mit den empfohlenen 50 A, nicht
       * mit dem Maximum von 100 A (1C) — der traegt keinen Dauer-Zusatz.
       */
      id: 'dyness-stack100-pro',
      hersteller: 'Dyness',
      name: 'STACK100 Pro',
      modul: {
        energie_kwh: 5.12,
        spannung_v: 51.2,
        chemie: 'LiFePO4 (LFP)',
        quelle: 'dyness-stack100-pro-db'
      },
      spec_quelle: 'dyness-stack100-pro-db',
      leistung_herleitung: 'Datenblatt nennt Modul 51,2 V / 100 Ah (5,12 kWh), nutzbar 4,864 kWh je '
        + 'Modul, 3-15 Module je Cluster und "Recommended Charge & Discharge C Rate 0,5C (50A)" mit '
        + '"Recommended Charge & Discharge Power 2,56 kW" je Modul. Nutzbare Energie = Modulanzahl x '
        + '4,864 kWh. Dauerleistung = 50 A x Turmspannung (Modulanzahl x 51,2 V) = Modulanzahl x '
        + '2,56 kW — beide Wege ergeben denselben Wert, der Hersteller nennt ihn je Modul selbst. '
        + 'Der Maximalwert 1C (100 A) traegt keinen Dauer-Zusatz und bleibt aussen vor.',
      verschaltung: 'serie',
      strom_a: 50,
      groessen: [
        { groesse: '3S', module: 3, nutzbar_kwh: 14.592, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: '4S', module: 4, nutzbar_kwh: 19.456, entlade_kw: 10.24, lade_kw: 10.24 },
        { groesse: '5S', module: 5, nutzbar_kwh: 24.32, entlade_kw: 12.8, lade_kw: 12.8 },
        { groesse: '6S', module: 6, nutzbar_kwh: 29.184, entlade_kw: 15.36, lade_kw: 15.36 },
        { groesse: '7S', module: 7, nutzbar_kwh: 34.048, entlade_kw: 17.92, lade_kw: 17.92 },
        { groesse: '8S', module: 8, nutzbar_kwh: 38.912, entlade_kw: 20.48, lade_kw: 20.48 },
        { groesse: '9S', module: 9, nutzbar_kwh: 43.776, entlade_kw: 23.04, lade_kw: 23.04 },
        { groesse: '10S', module: 10, nutzbar_kwh: 48.64, entlade_kw: 25.6, lade_kw: 25.6 },
        { groesse: '11S', module: 11, nutzbar_kwh: 53.504, entlade_kw: 28.16, lade_kw: 28.16 },
        { groesse: '12S', module: 12, nutzbar_kwh: 58.368, entlade_kw: 30.72, lade_kw: 30.72 },
        { groesse: '13S', module: 13, nutzbar_kwh: 63.232, entlade_kw: 33.28, lade_kw: 33.28 },
        { groesse: '14S', module: 14, nutzbar_kwh: 68.096, entlade_kw: 35.84, lade_kw: 35.84 },
        { groesse: '15S', module: 15, nutzbar_kwh: 72.96, entlade_kw: 38.4, lade_kw: 38.4 },
      ],
      garantie_zyklen: 8000,
      garantie_jahre: 10,
    },
    {
      id: 'dyness-stack100',
      hersteller: 'Dyness',
      name: 'STACK100',
      modul: {
        energie_kwh: 5.12,
        spannung_v: 51.2,
        chemie: 'LiFePO4 (LFP)',
        quelle: 'dyness-stack100-datenblatt'
      },
      spec_quelle: 'dyness-stack100-datenblatt',
      leistung_herleitung: 'Datenblatt nennt Modul 51,2 V / 100 Ah (5,12 kWh), "System Energy Range" '
        + '15,36-76,8 kWh (3-15 Module) und "Depth of Discharge" 95 Prozent. Nutzbare Energie = '
        + 'Modulanzahl x 5,12 kWh x 0,95. Dauerleistung = "Recommended Charge/Discharge Current" 50 A '
        + 'x Turmspannung (Modulanzahl x 51,2 V). Der ebenfalls genannte Wert "Max. 100 A (1C)" trägt '
        + 'keinen Dauer-Zusatz und bleibt außen vor. Mit ihm wäre jeder Leistungswert doppelt so hoch.',
      groessen: [
        { groesse: '3S', module: 3, nutzbar_kwh: 14.592, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: '4S', module: 4, nutzbar_kwh: 19.456, entlade_kw: 10.24, lade_kw: 10.24 },
        { groesse: '5S', module: 5, nutzbar_kwh: 24.32, entlade_kw: 12.8, lade_kw: 12.8 },
        { groesse: '6S', module: 6, nutzbar_kwh: 29.184, entlade_kw: 15.36, lade_kw: 15.36 },
        { groesse: '7S', module: 7, nutzbar_kwh: 34.048, entlade_kw: 17.92, lade_kw: 17.92 },
        { groesse: '8S', module: 8, nutzbar_kwh: 38.912, entlade_kw: 20.48, lade_kw: 20.48 },
        { groesse: '9S', module: 9, nutzbar_kwh: 43.776, entlade_kw: 23.04, lade_kw: 23.04 },
        { groesse: '10S', module: 10, nutzbar_kwh: 48.64, entlade_kw: 25.6, lade_kw: 25.6 },
        { groesse: '11S', module: 11, nutzbar_kwh: 53.504, entlade_kw: 28.16, lade_kw: 28.16 },
        { groesse: '12S', module: 12, nutzbar_kwh: 58.368, entlade_kw: 30.72, lade_kw: 30.72 },
        { groesse: '13S', module: 13, nutzbar_kwh: 63.232, entlade_kw: 33.28, lade_kw: 33.28 },
        { groesse: '14S', module: 14, nutzbar_kwh: 68.096, entlade_kw: 35.84, lade_kw: 35.84 },
        { groesse: '15S', module: 15, nutzbar_kwh: 72.96, entlade_kw: 38.4, lade_kw: 38.4 },
      ],
      garantie_zyklen: null,
      garantie_jahre: 10
    },
    {
      /*
       * ZYC SIMPO HV — die Marke stand als "ZYC SIMPO HV" in der
       * KOSTAL-Komplettuebersicht und fehlte im Katalog. Flyer und
       * Kompatibilitaetsliste kamen am 2026-08-09 vom Auftraggeber.
       *
       * Die Groessen der KOSTAL-Liste (6,4 bis 28,8) decken sich exakt mit der
       * Modultabelle des Flyers — deshalb ist die Zuordnung eindeutig, anders
       * als bei Pylontech Force H3 (siehe README, Bekannte Datenluecken).
       */
      id: 'zyc-simpo-hv',
      hersteller: 'ZYC',
      name: 'SIMPO HV',
      modul: {
        energie_kwh: 3.2,
        spannung_v: 64,
        chemie: 'LiFePO4 (LFP)',
        quelle: 'zyc-simpo-hv-db'
      },
      spec_quelle: 'zyc-simpo-hv-db',
      verschaltung: 'serie',
      strom_a: 50,
      strom_hinweis: 'Flyer 260408: „Maximaler Dauerstrom 50 A". Der Spitzenwert 65 A für 5 s bleibt bewusst außen vor. Nennspannung je Turmgröße steht im Flyer (128 bis 576 V).',
      leistung_herleitung: 'Flyer nennt je Turmgröße "Nutzbare Energie" und "Nennspannung" direkt, '
        + 'die Leistung aber nicht. Dauerleistung = "Maximaler Dauerstrom" 50 A x Nennspannung '
        + '(128/192/256/320/384/448/512/576 V). Beides Datenblattzeilen, die Multiplikation ist unsere. '
        + 'Der Spitzenstrom (65 A, 5 s) bleibt außen vor: Er ist keine Dauerleistung.',
      groessen: [
        { groesse: '6.4', module: 2, spannung_v: 128, nutzbar_kwh: 6.4, entlade_kw: 6.4, lade_kw: 6.4 },
        { groesse: '9.6', module: 3, spannung_v: 192, nutzbar_kwh: 9.6, entlade_kw: 9.6, lade_kw: 9.6 },
        { groesse: '12.8', module: 4, spannung_v: 256, nutzbar_kwh: 12.8, entlade_kw: 12.8, lade_kw: 12.8 },
        { groesse: '16', module: 5, spannung_v: 320, nutzbar_kwh: 16.0, entlade_kw: 16.0, lade_kw: 16.0 },
        { groesse: '19.2', module: 6, spannung_v: 384, nutzbar_kwh: 19.2, entlade_kw: 19.2, lade_kw: 19.2 },
        { groesse: '22.4', module: 7, spannung_v: 448, nutzbar_kwh: 22.4, entlade_kw: 22.4, lade_kw: 22.4 },
        { groesse: '25.6', module: 8, spannung_v: 512, nutzbar_kwh: 25.6, entlade_kw: 25.6, lade_kw: 25.6 },
        { groesse: '28.8', module: 9, spannung_v: 576, nutzbar_kwh: 28.8, entlade_kw: 28.8, lade_kw: 28.8 },
      ],
      garantie_zyklen: null,
      garantie_jahre: null
    },
    {
      /*
       * VARTA.wall — recherchiert 2026-08-09, nachdem der Listen-Abgleich zeigte,
       * dass KOSTAL und SMA die Reihe fuehren und unser Speicherkatalog sie gar
       * nicht kannte.
       *
       * Zwei Modulvarianten mit unterschiedlicher Chemie und unterschiedlicher
       * Leistung — deshalb zwei Familien, nicht eine mit Fussnote. Die Werte
       * stehen als eigene Spalte je Turmgroesse im Herstellerblatt; nichts
       * gerechnet.
       *
       * Beide Dokumente stammen von VARTA, wurden aber ueber Distributorenserver
       * geladen: varta-ag.com ist hinter einem CAPTCHA, das wir nicht umgehen.
       * Herausgeber und Dokumentnummer stehen im Dokument selbst.
       */
      id: 'varta-wall-bm1',
      hersteller: 'VARTA',
      name: 'VARTA.wall BM1',
      modul: {
        energie_kwh: 5.0,
        spannung_v: 100.8,
        chemie: 'Lithium-Ionen (NCA)',
        quelle: 'varta-wall-bm1-bm2-broschuere'
      },
      spec_quelle: 'varta-wall-bm1-db',
      verschaltung: 'serie',
      /*
       * Zwei Stroeme, nicht einer: Das Datenblatt fuehrt "Max. Lade-/Entladestrom
       * 22 A / 26 A" und dazu passend zwei Leistungen je Groesse. Bis 2026-08-16
       * stand hier EIN Wert fuer beide Richtungen (5 / 7,5 / 10 kW), abgelesen
       * aus der gemeinsamen Broschuere BROWALLBM12DE01 — beim Laden zu hoch, beim
       * Entladen zu niedrig. Das Einzeldatenblatt loest das auf.
       */
      strom_lade_a: 22,
      strom_entlade_a: 26,
      strom_hinweis: 'Datenblatt DBWALLBM1DE01: „Max. Lade-/Entladestrom 22 A / 26 A". '
        + 'Die Nennspannung steht je Turmgröße im Blatt (201,6 / 302,4 / 403,2 V) und gilt '
        + 'vor der Multiplikation.',
      leistung_herleitung: 'Datenblatt DBWALLBM1DE01: „Nominale Lade-/Entladeleistung" je '
        + 'Modulanzahl direkt abgelesen — zwei Werte je Größe, Laden vor Entladen '
        + '(4,4/5,2 · 6,7/7,9 · 8,9/10,5 kW). Die zuvor aus der Broschüre BROWALLBM12DE01 '
        + 'übernommenen 5 / 7,5 / 10 kW waren ein gemeinsamer Wert für beide Richtungen und '
        + 'trafen keine der beiden. Modulwert 5,0 kWh = nutzbare Kapazität geteilt durch '
        + 'Modulanzahl; Modulspannung = Nennspannung 201,6 V / 2.',
      groessen: [
        { groesse: '10', module: 2, nutzbar_kwh: 10.0, spannung_v: 201.6, entlade_kw: 5.2, lade_kw: 4.4 },
        { groesse: '15', module: 3, nutzbar_kwh: 15.0, spannung_v: 302.4, entlade_kw: 7.9, lade_kw: 6.7 },
        { groesse: '20', module: 4, nutzbar_kwh: 20.0, spannung_v: 403.2, entlade_kw: 10.5, lade_kw: 8.9 },
      ],
      garantie_zyklen: null,
      garantie_jahre: 10
    },
    {
      id: 'varta-wall-bm2',
      hersteller: 'VARTA',
      name: 'VARTA.wall BM2',
      modul: {
        energie_kwh: 4.5,
        spannung_v: 89.6,
        chemie: 'LiFePO4 (LFP)',
        quelle: 'varta-wall-bm2-db'
      },
      spec_quelle: 'varta-wall-bm2-db',
      verschaltung: 'serie',
      strom_a: 26,
      strom_hinweis: 'Datenblatt DBWALLBM2DE02: „Max. Lade-/Entladestrom 26 A". Die angegebenen kW-Werte sind gerundet (26 A × 179,2 V = 4,66 kW, angegeben 4,7 kW) — deshalb bis 1 % Abweichung zur Gegenrechnung.',
      leistung_herleitung: 'Datenblatt DBWALLBM2DE02: "Nutzbare Kapazität" und "Nominale Lade-/'
        + 'Entladeleistung" je Modulanzahl direkt abgelesen (2/3/4 Module). Ein Wert für Laden und '
        + 'Entladen, wie im Blatt. Modulwert 4,5 kWh = nutzbare Kapazität geteilt durch Modulanzahl.',
      groessen: [
        { groesse: '9', module: 2, spannung_v: 179.2, nutzbar_kwh: 9.0, entlade_kw: 4.7, lade_kw: 4.7 },
        { groesse: '13.5', module: 3, spannung_v: 268.8, nutzbar_kwh: 13.5, entlade_kw: 7.0, lade_kw: 7.0 },
        { groesse: '18', module: 4, spannung_v: 358.4, nutzbar_kwh: 18.0, entlade_kw: 9.3, lade_kw: 9.3 },
      ],
      garantie_zyklen: null,
      garantie_jahre: 10
    },
    {
      /*
       * GoodWe ESA Batteriemodul — das Gegenstueck zur ESA-Leistungseinheit.
       * Das Datenblatt fuehrt "ESA Series / Battery Module" als eigene Tabelle:
       * Modulenergie, nutzbare Energie und Lade-/Entladeleistung je Modul.
       *
       * Die Turmstufen sind Modulanzahl x Modulwert. Belegt ist die Spanne
       * "bis zu 12 Module / 108 kWh" aus demselben Blatt; die Zwischenstufen
       * sind die Vielfachen. Kein geschaetzter Wert — deshalb steht die
       * Rechnung in leistung_herleitung.
       */
      id: 'goodwe-esa-bat-d-g20',
      hersteller: 'GoodWe',
      name: 'ESA Batteriemodul GW5.1-BAT-D-G20',
      modul: {
        energie_kwh: 5.12,
        spannung_v: null,
        chemie: 'LiFePO4 (LFP)',
        quelle: 'goodwe-esa-5-30-db'
      },
      spec_quelle: 'goodwe-esa-5-30-db',
      leistung_herleitung: 'Datenblatt "ESA Series / Battery Module": je Modul 5,12 kWh Nennenergie, '
        + '5,0 kWh nutzbar, max. Ein- und Ausgangsleistung 5,0 kW. Turmstufen = Modulanzahl x Modulwert; '
        + 'die Obergrenze von 12 Modulen steht im selben Blatt.',
      groessen: [
        { groesse: '2 Module', module: 2, nutzbar_kwh: 10.0, entlade_kw: 10.0, lade_kw: 10.0 },
        { groesse: '3 Module', module: 3, nutzbar_kwh: 15.0, entlade_kw: 15.0, lade_kw: 15.0 },
        { groesse: '4 Module', module: 4, nutzbar_kwh: 20.0, entlade_kw: 20.0, lade_kw: 20.0 },
        { groesse: '5 Module', module: 5, nutzbar_kwh: 25.0, entlade_kw: 25.0, lade_kw: 25.0 },
        { groesse: '6 Module', module: 6, nutzbar_kwh: 30.0, entlade_kw: 30.0, lade_kw: 30.0 },
      ],
      garantie_zyklen: null,
      garantie_jahre: null
    },
    {
      id: 'goodwe-esa-bat-d-g20-8',
      hersteller: 'GoodWe',
      name: 'ESA Batteriemodul GW8.3-BAT-D-G20',
      modul: {
        energie_kwh: 8.32,
        spannung_v: null,
        chemie: 'LiFePO4 (LFP)',
        quelle: 'goodwe-esa-5-30-db'
      },
      spec_quelle: 'goodwe-esa-5-30-db',
      leistung_herleitung: 'Datenblatt "ESA Series / Battery Module": je Modul 8,32 kWh Nennenergie, '
        + '8,0 kWh nutzbar, max. Ein- und Ausgangsleistung 8,0 kW. Turmstufen = Modulanzahl x Modulwert; '
        + 'die Obergrenze von 12 Modulen steht im selben Blatt.',
      groessen: [
        { groesse: '2 Module', module: 2, nutzbar_kwh: 16.0, entlade_kw: 16.0, lade_kw: 16.0 },
        { groesse: '3 Module', module: 3, nutzbar_kwh: 24.0, entlade_kw: 24.0, lade_kw: 24.0 },
        { groesse: '4 Module', module: 4, nutzbar_kwh: 32.0, entlade_kw: 32.0, lade_kw: 32.0 },
        { groesse: '5 Module', module: 5, nutzbar_kwh: 40.0, entlade_kw: 40.0, lade_kw: 40.0 },
        { groesse: '6 Module', module: 6, nutzbar_kwh: 48.0, entlade_kw: 48.0, lade_kw: 48.0 },
      ],
      garantie_zyklen: null,
      garantie_jahre: null
    },
    {
      id: 'felicity-fla-eu',
      hersteller: 'Felicity',
      name: 'FLA-EU Serie',
      /*
       * Niedervolt-Speicher (51,2 V). Anders als ein Hochvolt-Hausspeicher wird
       * er nicht in einem Turm gestapelt, sondern parallel erweitert — bis zu
       * 15 Einheiten laut Datenblatt. Deshalb keine Modulanzahl je Groesse:
       * Jede Groesse ist ein eigenstaendiges Geraet.
       */
      spannungsklasse: 'niedervolt',
      modul: { energie_kwh: null, spannung_v: 51.2, chemie: 'LiFePO4 (LFP)', quelle: 'felicity-fla-eu-db' },
      spec_quelle: 'felicity-fla-eu-db',
      kapazitaet_herleitung: 'Datenblatt nennt die Nennenergie und eine Entladetiefe (DOD) von mindestens 95 Prozent. '
        + 'Ausgewiesen wird Nennenergie mal 95 Prozent. Eine eigene Angabe zur nutzbaren Energie macht Felicity nicht.',
      leistung_herleitung: 'Dauerleistung = max. dauerhafter Lade-/Entladestrom mal Nennspannung 51,2 V '
        + '(100 / 120 / 150 A laut Datenblatt). Der Strom ist laut Fußnote temperatur- und ladestandsabhängig.',
      groessen: [
        { groesse: 'FLA48100-EU', module: null, nutzbar_kwh: 4.86, entlade_kw: 5.12, lade_kw: 5.12 },
        { groesse: 'FLA48171-EU', module: null, nutzbar_kwh: 8.31, entlade_kw: 6.14, lade_kw: 6.14 },
        { groesse: 'FLA48230-EU', module: null, nutzbar_kwh: 11.21, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: 'FLA48250-EU', module: null, nutzbar_kwh: 11.88, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: 'FLA48280-EU', module: null, nutzbar_kwh: 13.59, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: 'FLA48300-EU', module: null, nutzbar_kwh: 14.25, entlade_kw: 7.68, lade_kw: 7.68 },
      ],
      entlade_leistung_kw: null, lade_leistung_kw: null,
      garantie_zyklen: 6000, garantie_jahre: 10,
    },
    /*
     * BYD-Leistungswerte: Die Datenblätter nennen Dauerstrom (A) und Nennspannung (V)
     * je Turmgröße; Dauerleistung = Strom × Nennspannung (dokumentierte Herleitung,
     * im Feld leistung_herleitung benannt). nutzbar_kwh direkt aus dem Datenblatt.
     * Premium HVS/HVM (V1.6) nennt nur den AUSGANGSstrom ⇒ Einzelwert-Regel:
     * Ladewert = Entladewert (als Herleitung gekennzeichnet). HVS+/HVM+ dokumentieren
     * Laden UND Entladen ausdrücklich („charge/discharge", „Lade- und Entladeleistung").
     */
    {
      id: 'byd-premium-hvs',
      hersteller: 'BYD',
      name: 'Battery-Box Premium HVS',
      modul: { energie_kwh: 2.56, spannung_v: 102.4, chemie: 'LiFePO4 (LFP)', quelle: 'kostal-0826' },
      spec_quelle: 'byd-hvs-db',
      verschaltung: 'serie',
      strom_a: 25,
      strom_hinweis: 'Datenblatt V1.6: max. Ausgangsstrom 25 A. Die Leistung je Turmgröße steht dokumentiert in groessen[]; strom_a dient der Gegenrechnung.',
      leistung_herleitung: 'Dauerleistung = max. Ausgangsstrom 25 A × Nennspannung; Datenblatt nennt nur den Ausgangsstrom, Ladewert = Entladewert gesetzt (Einzelwert-Regel). Drosselung zwischen −10 °C und +5 °C.',
      groessen: [
        { groesse: '5.1', module: 2, nutzbar_kwh: 5.12, entlade_kw: 5.12, lade_kw: 5.12 },
        { groesse: '7.7', module: 3, nutzbar_kwh: 7.68, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: '10.2', module: 4, nutzbar_kwh: 10.24, entlade_kw: 10.24, lade_kw: 10.24 },
        { groesse: '12.8', module: 5, nutzbar_kwh: 12.8, entlade_kw: 12.8, lade_kw: 12.8 },
      ],
      garantie_zyklen: null, garantie_jahre: 10,
    },
    {
      id: 'byd-hvs-plus',
      hersteller: 'BYD',
      name: 'Battery-Box HVS+',
      modul: { energie_kwh: 2.56, spannung_v: 102.4, chemie: 'LiFePO4 (LFP)', quelle: 'byd-hvs-plus-db' },
      spec_quelle: 'byd-hvs-plus-db',
      verschaltung: 'serie',
      strom_a: 25,
      strom_hinweis: 'Datenblatt: „Max. Output Current" 25 A. Die Leistung je Turmgröße steht dokumentiert in groessen[]; strom_a dient der Gegenrechnung.',
      leistung_herleitung: 'Dauerleistung = max. Ausgangsstrom 25 A × Nennspannung; Datenblatt: „Max. 12,8 kW Lade- und Entladeleistung pro Turm". Drosselung zwischen −10 °C und +5 °C.',
      groessen: [
        { groesse: '5.1', module: 2, nutzbar_kwh: 5.12, entlade_kw: 5.12, lade_kw: 5.12 },
        { groesse: '7.7', module: 3, nutzbar_kwh: 7.68, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: '10.2', module: 4, nutzbar_kwh: 10.24, entlade_kw: 10.24, lade_kw: 10.24 },
        { groesse: '12.8', module: 5, nutzbar_kwh: 12.8, entlade_kw: 12.8, lade_kw: 12.8 },
      ],
      garantie_zyklen: null, garantie_jahre: 10,
    },
    {
      id: 'byd-premium-hvm',
      hersteller: 'BYD',
      name: 'Battery-Box Premium HVM',
      modul: { energie_kwh: 2.76, spannung_v: 51.2, chemie: 'LiFePO4 (LFP)', quelle: 'kostal-0826' },
      spec_quelle: 'byd-hvm-db',
      leistung_herleitung: 'Dauerleistung = max. Ausgangsstrom 50 A × Nennspannung; Datenblatt nennt nur den Ausgangsstrom, Ladewert = Entladewert gesetzt (Einzelwert-Regel). Drosselung zwischen −10 °C und +5 °C.',
      groessen: [
        { groesse: '8.3', module: 3, nutzbar_kwh: 8.28, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: '11.0', module: 4, nutzbar_kwh: 11.04, entlade_kw: 10.24, lade_kw: 10.24 },
        { groesse: '13.8', module: 5, nutzbar_kwh: 13.8, entlade_kw: 12.8, lade_kw: 12.8 },
        { groesse: '16.6', module: 6, nutzbar_kwh: 16.56, entlade_kw: 15.36, lade_kw: 15.36 },
        { groesse: '19.3', module: 7, nutzbar_kwh: 19.32, entlade_kw: 17.92, lade_kw: 17.92 },
        { groesse: '22.1', module: 8, nutzbar_kwh: 22.08, entlade_kw: 20.48, lade_kw: 20.48 },
      ],
      garantie_zyklen: null, garantie_jahre: 10,
    },
    {
      id: 'byd-hvm-plus',
      hersteller: 'BYD',
      name: 'Battery-Box HVM+',
      modul: { energie_kwh: 2.76, spannung_v: 51.2, chemie: 'LiFePO4 (LFP)', quelle: 'byd-hvm-plus-db' },
      spec_quelle: 'byd-hvm-plus-db',
      leistung_herleitung: 'Dauerleistung = max. Lade-/Entladestrom 50 A × Nennspannung (Datenblatt: „Max. continuous charge/discharge current 50A"). Drosselung zwischen −10 °C und +5 °C.',
      groessen: [
        { groesse: '8.3', module: 3, nutzbar_kwh: 8.28, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: '11.0', module: 4, nutzbar_kwh: 11.04, entlade_kw: 10.24, lade_kw: 10.24 },
        { groesse: '13.8', module: 5, nutzbar_kwh: 13.8, entlade_kw: 12.8, lade_kw: 12.8 },
        { groesse: '16.6', module: 6, nutzbar_kwh: 16.56, entlade_kw: 15.36, lade_kw: 15.36 },
        { groesse: '19.3', module: 7, nutzbar_kwh: 19.32, entlade_kw: 17.92, lade_kw: 17.92 },
        { groesse: '22.1', module: 8, nutzbar_kwh: 22.08, entlade_kw: 20.48, lade_kw: 20.48 },
      ],
      garantie_zyklen: null, garantie_jahre: 10,
    },
    {
      id: 'byd-hvb',
      hersteller: 'BYD',
      name: 'Battery-Box HVB',
      modul: { energie_kwh: 2.97, spannung_v: 51.2, chemie: 'Lithiumeisenphosphat (LFP, kobaltfrei)', quelle: 'byd-hvb-db' },
      spec_quelle: 'byd-hvb-db',
      verschaltung: 'serie',
      strom_a: 50,
      strom_hinweis: 'Datenblatt: max. Ausgangsstrom 50 A. Die Leistung je Turmgröße steht dokumentiert in groessen[]; strom_a dient der Gegenrechnung.',
      /*
       * Entladeleistung = max. Ausgangsstrom 50 A × Nennspannung der Turmgröße
       * (102,4 bis 512 V laut Datenblatt).
       *
       * lade_kw bleibt BEWUSST offen: Das Datenblatt nennt nur einen
       * „Maximalen Ausgangsstrom" — also die Entladung. Anders als beim HVS+,
       * wo ausdrücklich „Lade- und Entladeleistung" steht, gibt es hier keinen
       * belegten Ladewert. Die UI zeigt deshalb beim Laden weiterhin die Grenze
       * des Wechselrichters als Obergrenze („bis x kW").
       *
       * Die HVB-Baureihe beginnt laut Datenblatt bei HVB 5.9 (2 Module); diese
       * Größe führt keine der vorliegenden Freigabelisten und steht deshalb
       * nicht hier.
       */
      leistung_herleitung: 'Entladeleistung = max. Ausgangsstrom 50 A × Nennspannung der Turmgröße '
        + '(Datenblatt: 102,4 / 153,6 / 204,8 / 256 / 307,2 / 358,4 / 409,6 / 460,8 / 512 V). '
        + 'Leistungsreduzierung zwischen −20 °C und 0 °C. Zum Laden nennt das Datenblatt keinen '
        + 'eigenen Wert. Der Ladewert bleibt deshalb offen.',
      groessen: [
        { groesse: '8.9', module: 3, nutzbar_kwh: 8.91, entlade_kw: 7.68 },
        { groesse: '11.8', module: 4, nutzbar_kwh: 11.88, entlade_kw: 10.24 },
        { groesse: '14.8', module: 5, nutzbar_kwh: 14.85, entlade_kw: 12.8 },
        { groesse: '17.8', module: 6, nutzbar_kwh: 17.82, entlade_kw: 15.36 },
        { groesse: '20.7', module: 7, nutzbar_kwh: 20.79, entlade_kw: 17.92 },
        { groesse: '23.7', module: 8, nutzbar_kwh: 23.76, entlade_kw: 20.48 },
        { groesse: '26.7', module: 9, nutzbar_kwh: 26.72, entlade_kw: 23.04 },
        { groesse: '29.6', module: 10, nutzbar_kwh: 29.69, entlade_kw: 25.6 },
      ],
      entlade_leistung_kw: null, lade_leistung_kw: null,
      garantie_zyklen: null, garantie_jahre: 15,
    },
    {
      id: 'fronius-reserva',
      hersteller: 'Fronius',
      name: 'Reserva',
      modul: { energie_kwh: 3.15, spannung_v: 102.4, chemie: 'LiFePO4 (LFP)', quelle: 'fronius-reserva-db' },
      spec_quelle: 'fronius-reserva-db',
      verschaltung: 'serie',
      strom_a: 32,
      strom_hinweis: 'Datenblatt 01/2026: „Maximaler Ausgangsstrom" 32 A, ein Wert für alle Turmgrößen. Fußnote: „Der Lade- und Entladestrom kann vom Wechselrichter limitiert werden." Die Nennspannung steht je Größe im Blatt und gilt vor der Multiplikation.',
      leistung_herleitung: 'Max. Lade-/Entladeleistung direkt aus dem Datenblatt (kann je nach Temperatur, SOC und Wechselrichter variieren). Ausgangsstrom je Turm auf 32 A begrenzt.',
      groessen: [
        { groesse: '6.3', module: 2, spannung_v: 204.8, nutzbar_kwh: 6.31, entlade_kw: 6.55, lade_kw: 6.55 },
        { groesse: '9.5', module: 3, spannung_v: 307.2, nutzbar_kwh: 9.47, entlade_kw: 9.83, lade_kw: 9.83 },
        { groesse: '12.6', module: 4, spannung_v: 409.6, nutzbar_kwh: 12.63, entlade_kw: 13.10, lade_kw: 13.10 },
        { groesse: '15.8', module: 5, spannung_v: 512, nutzbar_kwh: 15.79, entlade_kw: 16.38, lade_kw: 16.38 },
      ],
      garantie_zyklen: 6000, garantie_jahre: 10, // Datenblatt: erwartete Lebensdauer 6000 Zyklen (60 % SOH)
    },
    {
      id: 'fronius-reserva-pro',
      hersteller: 'Fronius',
      name: 'Reserva Pro',
      modul: { energie_kwh: 3.98, spannung_v: 70.84, chemie: 'LiFePO4 (LFP)', quelle: 'fronius-reserva-pro-db' },
      spec_quelle: 'fronius-reserva-pro-db',
      verschaltung: 'serie',
      strom_a: 50,
      strom_hinweis: 'Datenblatt: max. Ausgangsstrom 50 A. Die Leistung je Turmgröße steht dokumentiert in groessen[]; strom_a dient der Gegenrechnung.',
      leistung_herleitung: 'Dauerleistung = max. Ausgangsstrom 50 A × Nominalspannung des Datenblatts (Lade-/Entladeleistung kann durch Wechselrichter und Temperatur begrenzt sein).',
      groessen: [
        { groesse: '12.0', module: 3, nutzbar_kwh: 11.9, entlade_kw: 10.63, lade_kw: 10.63 },
        { groesse: '16.0', module: 4, nutzbar_kwh: 15.9, entlade_kw: 14.17, lade_kw: 14.17 },
        { groesse: '20.0', module: 5, nutzbar_kwh: 19.9, entlade_kw: 17.71, lade_kw: 17.71 },
        { groesse: '24.0', module: 6, nutzbar_kwh: 23.9, entlade_kw: 21.25, lade_kw: 21.25 },
        { groesse: '28.0', module: 7, nutzbar_kwh: 27.9, entlade_kw: 24.79, lade_kw: 24.79 },
        { groesse: '32.0', module: 8, nutzbar_kwh: 31.9, entlade_kw: 28.34, lade_kw: 28.34 },
      ],
      garantie_zyklen: null, garantie_jahre: 10, // Datenblatt nennt nur 10 Jahre / 80 % SOH, keine Zyklenzahl
    },
    {
      id: 'kostal-helivor',
      hersteller: 'KOSTAL',
      name: 'HELIVOR HV',
      modul: { energie_kwh: 3.2, spannung_v: 64, chemie: 'Li-Ion LFP', quelle: 'kostal-helivor-db' },
      spec_quelle: 'kostal-helivor-db',
      verschaltung: 'serie',
      strom_a: 50,
      strom_hinweis: 'Datenblatt: max. Lade-/Entladestrom 50 A. Die Leistung je Turmgröße steht dokumentiert in groessen[]; strom_a dient der Gegenrechnung.',
      leistung_herleitung: 'Dauerleistung = max. Lade-/Entladestrom 50 A × Nennspannung des Datenblatts (entspricht je Turmgröße der nutzbaren kWh).',
      groessen: [
        { groesse: '6.4', module: 2, nutzbar_kwh: 6.4, entlade_kw: 6.4, lade_kw: 6.4 },
        { groesse: '9.6', module: 3, nutzbar_kwh: 9.6, entlade_kw: 9.6, lade_kw: 9.6 },
        { groesse: '12.8', module: 4, nutzbar_kwh: 12.8, entlade_kw: 12.8, lade_kw: 12.8 },
        { groesse: '16.0', module: 5, nutzbar_kwh: 16.0, entlade_kw: 16.0, lade_kw: 16.0 },
        { groesse: '19.2', module: 6, nutzbar_kwh: 19.2, entlade_kw: 19.2, lade_kw: 19.2 },
        { groesse: '22.4', module: 7, nutzbar_kwh: 22.4, entlade_kw: 22.4, lade_kw: 22.4 },
        { groesse: '25.6', module: 8, nutzbar_kwh: 25.6, entlade_kw: 25.6, lade_kw: 25.6 },
        { groesse: '28.8', module: 9, nutzbar_kwh: 28.8, entlade_kw: 28.8, lade_kw: 28.8 },
      ],
      garantie_zyklen: null, garantie_jahre: 10,
    },
    {
      id: 'axitec-sv2',
      hersteller: 'AXITEC',
      name: 'AXIstorage Li SV2',
      /*
       * Seit 2026-07-29 vollständig aus dem AXITEC-Datenblatt (axitec-sv-db).
       * Die Energypacks fassen 3,37 kWh nutzbar — die zuvor aus der KOSTAL-Liste
       * übernommenen 3,552 kWh waren nicht die Modulenergie, sondern zufällig
       * gleich dem Produkt 18,5 A × 192 V. Der Herstellerwert gilt.
       */
      modul: { energie_kwh: 3.37, spannung_v: 96, chemie: 'Lithium-Eisenphosphat (LFP)', quelle: 'axitec-sv-db' },
      spec_quelle: 'axitec-sv-db',
      verschaltung: 'serie',
      strom_a: 18.5,
      strom_hinweis: 'Datenblatt: max. dauerhafter Lade-/Entladestrom 18,5 A. Die Leistung je Turmgröße steht dokumentiert in groessen[]; strom_a dient der Gegenrechnung.',
      leistung_herleitung: 'Dauerleistung = max. dauerhafter Lade-/Entladestrom 18,5 A × Nennspannung '
        + 'der jeweiligen Turmgröße (Datenblatt: 192 / 288 / 384 / 480 V bei 2 / 3 / 4 / 5 Energypacks). '
        + 'Nutzbarer Energieinhalt direkt aus dem Datenblatt.',
      groessen: [
        { groesse: '6.7', module: 2, nutzbar_kwh: 6.7, entlade_kw: 3.55, lade_kw: 3.55 },
        { groesse: '10.1', module: 3, nutzbar_kwh: 10.1, entlade_kw: 5.33, lade_kw: 5.33 },
        { groesse: '13.5', module: 4, nutzbar_kwh: 13.5, entlade_kw: 7.10, lade_kw: 7.10 },
        { groesse: '16.9', module: 5, nutzbar_kwh: 16.9, entlade_kw: 8.88, lade_kw: 8.88 },
      ],
      // Datenblatt nennt „10 Jahre Zeitwertersatzgarantie", keine Zyklenzahl.
      entlade_leistung_kw: null, lade_leistung_kw: null, garantie_zyklen: null, garantie_jahre: 10,
    },
    {
      id: 'sungrow-sbr',
      hersteller: 'Sungrow',
      name: 'SBR Hochvolt-Batterie',
      modul: { energie_kwh: 3.2, spannung_v: 64, chemie: 'LiFePO4 (LFP), prismatische Zelle', quelle: 'sungrow-sbr-db' },
      spec_quelle: 'sungrow-sbr-db',
      verschaltung: 'serie',
      strom_a: 30,
      strom_hinweis: 'Datenblatt: „Max. Lade-/Entladestrom 30 A". Die Leistung je Turmgröße steht dokumentiert in groessen[]; strom_a dient der Gegenrechnung.',
      leistung_herleitung: 'Dauerleistung = max. Lade-/Entladestrom 30 A × Nennspannung der Größe '
        + '(Datenblatt: „Max. Lade-/Entladestrom 30 A", Nennspannung je Turmgröße 128–512 V). '
        + 'Das Datenblatt nennt keine kW-Werte; Fußnote: am SH-RT ist SBR064 auf 20 A begrenzt '
        + '(dort 2,56 kW statt 3,84 kW).',
      groessen: [
        { groesse: 'SBR064', module: 2, nutzbar_kwh: 6.4, entlade_kw: 3.84, lade_kw: 3.84 },
        { groesse: 'SBR096', module: 3, nutzbar_kwh: 9.6, entlade_kw: 5.76, lade_kw: 5.76 },
        { groesse: 'SBR128', module: 4, nutzbar_kwh: 12.8, entlade_kw: 7.68, lade_kw: 7.68 },
        { groesse: 'SBR160', module: 5, nutzbar_kwh: 16.0, entlade_kw: 9.6, lade_kw: 9.6 },
        { groesse: 'SBR192', module: 6, nutzbar_kwh: 19.2, entlade_kw: 11.52, lade_kw: 11.52 },
        { groesse: 'SBR224', module: 7, nutzbar_kwh: 22.4, entlade_kw: 13.44, lade_kw: 13.44 },
        { groesse: 'SBR256', module: 8, nutzbar_kwh: 25.6, entlade_kw: 15.36, lade_kw: 15.36 },
      ],
      garantie_zyklen: null, garantie_jahre: null, // DE-Datenblatt V4 nennt keine Garantie; Garantiebrief liegt nicht vor
    },
    {
      id: 'sungrow-sbh',
      hersteller: 'Sungrow',
      name: 'SBH Hochvolt-Batterie',
      modul: { energie_kwh: 5.0, spannung_v: 70.4, chemie: 'LiFePO4 (LFP), prismatische Zelle', quelle: 'sungrow-sbh-db' },
      spec_quelle: 'sungrow-sbh-db',
      verschaltung: 'serie',
      strom_a: 50,
      strom_hinweis: 'Datenblatt V3.1: „Max. charging/discharging current: 50 A continuous". Die Nennspannung steht je Größe im Blatt (140,8 bis 563,2 V) und gilt vor der Multiplikation.',
      // Kein gerechneter Wert: „Rated DC power" steht je Größe direkt im Datenblatt.
      // Lade- und Entladestrom sind identisch angegeben (50 A Dauer) ⇒ lade_kw = entlade_kw.
      leistung_herleitung: null,
      groessen: [
        { groesse: 'SBH100', module: 2, spannung_v: 140.8, nutzbar_kwh: 10.0, entlade_kw: 7.04, lade_kw: 7.04 },
        { groesse: 'SBH150', module: 3, spannung_v: 211.2, nutzbar_kwh: 15.0, entlade_kw: 10.56, lade_kw: 10.56 },
        { groesse: 'SBH200', module: 4, spannung_v: 281.6, nutzbar_kwh: 20.0, entlade_kw: 14.08, lade_kw: 14.08 },
        { groesse: 'SBH250', module: 5, spannung_v: 352, nutzbar_kwh: 25.0, entlade_kw: 17.6, lade_kw: 17.6 },
        { groesse: 'SBH300', module: 6, spannung_v: 422.4, nutzbar_kwh: 30.0, entlade_kw: 21.12, lade_kw: 21.12 },
        { groesse: 'SBH350', module: 7, spannung_v: 492.8, nutzbar_kwh: 35.0, entlade_kw: 24.64, lade_kw: 24.64 },
        { groesse: 'SBH400', module: 8, spannung_v: 563.2, nutzbar_kwh: 40.0, entlade_kw: 28.16, lade_kw: 28.16 },
      ],
      garantie_zyklen: null, garantie_jahre: 10,
    },
    /*
     * Growatt ARK HV (2.5H-A2): Datenblatt liegt vor (Quelle growatt-ark-2.5h-a2-datasheet),
     * aber KEIN Dokument nennt die freigegebenen Wechselrichter — weder das Datenblatt noch
     * die A1/A2-Declaration; die Growatt-Kompatibilitätsliste im Repo deckt nur 48-V-Fremd-
     * batterien ab. Ohne Freigabe-Beleg bleibt die Familie draußen (Integritätstest verbietet
     * verwaiste Familien). Sobald die Growatt-HV-Liste vorliegt: Rezept D; die extrahierten
     * Werte stehen im Git-Verlauf dieses Branches und in README „Bekannte Datenlücken".
     */
    {
      id: 'growatt-apx',
      hersteller: 'Growatt',
      name: 'APX HV Battery',
      modul: { energie_kwh: 5.0, spannung_v: 385, chemie: 'LiFePO4 (LFP), kobaltfrei', quelle: 'growatt-apx-db' },
      spec_quelle: 'growatt-apx-db',
      leistung_herleitung: 'Angesetzt ist „Max. output power" mit Leistungsmodul APX 98034-P2 '
        + '(2,5–15 kW je Größe). Mit dem kleineren Leistungsmodul APX 98020-P1 sind höchstens '
        + '7,5 kW möglich. Und nur die P2-Konfiguration ist laut Datenblatt für die MID-XH-Serie '
        + 'vorgesehen. Nutzbare Energie = „Energy capacity" × 90 % DoD.',
      kapazitaet_herleitung: 'Datenblatt nennt „Energy capacity" (brutto) und DOD 90 %. '
        + 'Ausgewiesen wird brutto × 90 %.',
      groessen: [
        { groesse: 'APX 5.0P', module: 1, nutzbar_kwh: 4.5, entlade_kw: 2.5, lade_kw: 2.5 },
        { groesse: 'APX 10.0P', module: 2, nutzbar_kwh: 9.0, entlade_kw: 5.0, lade_kw: 5.0 },
        { groesse: 'APX 15.0P', module: 3, nutzbar_kwh: 13.5, entlade_kw: 7.5, lade_kw: 7.5 },
        { groesse: 'APX 20.0P', module: 4, nutzbar_kwh: 18.0, entlade_kw: 10.0, lade_kw: 10.0 },
        { groesse: 'APX 25.0P', module: 5, nutzbar_kwh: 22.5, entlade_kw: 12.5, lade_kw: 12.5 },
        { groesse: 'APX 30.0P', module: 6, nutzbar_kwh: 27.0, entlade_kw: 15.0, lade_kw: 15.0 },
      ],
      garantie_zyklen: null, garantie_jahre: 10,
    },
    {
      id: 'solax-x3-ies-batterie',
      hersteller: 'SolaX',
      name: 'X3-IES Batteriemodule',
      modul: { energie_kwh: 5.1, spannung_v: null, chemie: 'LiFePO4 (LFP)', quelle: 'solax-x3-ies-db-v18' },
      spec_quelle: 'solax-x3-ies-db-v18',
      leistung_herleitung: 'Angesetzt ist die Systemzeile „Max. charge / discharge power" '
        + '(10,2 kW bei 2 Modulen, ab 3 Modulen 15 kW). Ein gemeinsamer Wert für Laden und '
        + 'Entladen (Einzelwert-Regel). Laut Fußnote darf sie die WR-Nennleistung nicht '
        + 'überschreiten; diese Grenze bildet die min()-Rechnung des Beraters ab.',
      groessen: [
        // Ab Datenblatt V1.8 gibt es das System auch mit einem einzelnen Modul.
        { groesse: '5.1', module: 1, nutzbar_kwh: 4.6, entlade_kw: 5.1, lade_kw: 5.1 },
        { groesse: '10.2', module: 2, nutzbar_kwh: 9.2, entlade_kw: 10.2, lade_kw: 10.2 },
        { groesse: '15.3', module: 3, nutzbar_kwh: 13.8, entlade_kw: 15.0, lade_kw: 15.0 },
        { groesse: '20.4', module: 4, nutzbar_kwh: 18.4, entlade_kw: 15.0, lade_kw: 15.0 },
        { groesse: '25.6', module: 5, nutzbar_kwh: 23.0, entlade_kw: 15.0, lade_kw: 15.0 },
        { groesse: '30.7', module: 6, nutzbar_kwh: 27.6, entlade_kw: 15.0, lade_kw: 15.0 },
      ],
      // „Cycle life > 6000" ist eine Lebensdauer-Angabe, keine Garantiezusage —
      // garantie_zyklen bleibt deshalb leer. Die 10 Jahre stehen als „Warranty" im Blatt.
      garantie_zyklen: null, garantie_jahre: 10,
    },
    {
      id: 'growatt-axe',
      hersteller: 'Growatt',
      name: 'AXE 5.0L (Niedervolt)',
      spannungsklasse: 'niedervolt',
      modul: { energie_kwh: 5.0, spannung_v: 51.2, chemie: 'LiFePO4 (LFP), kobaltfrei', quelle: 'growatt-axe-db' },
      spec_quelle: 'growatt-axe-db',
      leistung_herleitung: 'Angesetzt ist die „Nominal charge / discharge power" des Datenblatts, '
        + 'Laden und Entladen sind dort getrennt ausgewiesen (z. B. 2,5 / 3,1 kW je Modul) und ab '
        + '4 Modulen durch die 160-A-Cluster-Grenze auf 8,1 kW gedeckelt. Die höhere „Maximum"-Zeile '
        + '(bis 9,2 kW, 180 A) bleibt außen vor: Sie hängt laut Fußnote vom Wechselrichter ab und '
        + 'derated mit Temperatur und Ladezustand. Nutzbare Energie = „Energy capacity" × 92 % DoD.',
      kapazitaet_herleitung: 'Datenblatt nennt „Energy capacity" (brutto) und DoD 92 %. '
        + 'Ausgewiesen wird brutto × 92 %.',
      groessen: [
        { groesse: 'AXE 5.0L', module: 1, nutzbar_kwh: 4.6, entlade_kw: 3.1, lade_kw: 2.5 },
        { groesse: 'AXE 10.0L', module: 2, nutzbar_kwh: 9.2, entlade_kw: 6.1, lade_kw: 5.1 },
        { groesse: 'AXE 15.0L', module: 3, nutzbar_kwh: 13.8, entlade_kw: 8.1, lade_kw: 7.6 },
        { groesse: 'AXE 20.0L', module: 4, nutzbar_kwh: 18.4, entlade_kw: 8.1, lade_kw: 8.1 },
        { groesse: 'AXE 25.0L', module: 5, nutzbar_kwh: 23.0, entlade_kw: 8.1, lade_kw: 8.1 },
        { groesse: 'AXE 30.0L', module: 6, nutzbar_kwh: 27.6, entlade_kw: 8.1, lade_kw: 8.1 },
        { groesse: 'AXE 35.0L', module: 7, nutzbar_kwh: 32.2, entlade_kw: 8.1, lade_kw: 8.1 },
        { groesse: 'AXE 40.0L', module: 8, nutzbar_kwh: 36.8, entlade_kw: 8.1, lade_kw: 8.1 },
        { groesse: 'AXE 45.0L', module: 9, nutzbar_kwh: 41.4, entlade_kw: 8.1, lade_kw: 8.1 },
        { groesse: 'AXE 50.0L', module: 10, nutzbar_kwh: 46.0, entlade_kw: 8.1, lade_kw: 8.1 },
      ],
      // Datenblatt: „Warranty (5/10 years) Yes/Opt" — belegt sind 5 Jahre Standard,
      // die 10 Jahre sind eine optionale Erweiterung und werden nicht ausgewiesen.
      garantie_zyklen: null, garantie_jahre: 5,
    },
    {
      id: 'pylontech-force-h3',
      hersteller: 'Pylontech',
      name: 'Force H3',
      /*
       * Das Größen-Rätsel aus README ist gelöst: Die Bezeichnungen der
       * KOSTAL-Liste (9.69, 14.73, …) sind exakt die NUTZBAREN Energien des
       * Pylontech-Datenblatts (System 10,24–35,84 kWh brutto, DoD 95 %).
       */
      modul: { energie_kwh: 5.12, spannung_v: 102.4, chemie: null, quelle: 'pylontech-force-h3-db' },
      spec_quelle: 'pylontech-force-h3-db',
      verschaltung: 'serie',
      strom_a: 50,
      strom_hinweis: 'Datenblatt FH10050: „Charge/Discharge (A) Normal 50". Der Spitzenwert 55 A für 15 Minuten bleibt bewusst außen vor. Die Leistung je Turmgröße steht dokumentiert in groessen[]; strom_a dient der Gegenrechnung.',
      leistung_herleitung: 'Dauerleistung = Normal-Lade-/Entladestrom 50 A × Nennspannung der '
        + 'Größe (Datenblatt FH10050: „Charge/Discharge (A) Normal 50"). Der Spitzenwert '
        + '55 A für 15 Minuten bleibt bewusst außen vor.',
      groessen: [
        { groesse: '9.69', module: 2, nutzbar_kwh: 9.69, entlade_kw: 10.24, lade_kw: 10.24 },
        { groesse: '14.73', module: 3, nutzbar_kwh: 14.73, entlade_kw: 15.36, lade_kw: 15.36 },
        { groesse: '19.48', module: 4, nutzbar_kwh: 19.48, entlade_kw: 20.48, lade_kw: 20.48 },
        { groesse: '24.32', module: 5, nutzbar_kwh: 24.32, entlade_kw: 25.6, lade_kw: 25.6 },
        { groesse: '29.17', module: 6, nutzbar_kwh: 29.17, entlade_kw: 30.72, lade_kw: 30.72 },
        { groesse: '34.01', module: 7, nutzbar_kwh: 34.01, entlade_kw: 35.84, lade_kw: 35.84 },
      ],
      garantie_zyklen: null, garantie_jahre: null, // „Cycle life >8000" und „Design life 15+" sind keine Garantiezusagen
    },
    {
      id: 'lg-flex',
      hersteller: 'LG',
      name: 'RESU FLEX',
      modul: null, // das Datenblatt weist keine Modulstruktur je Größe aus
      spec_quelle: 'lg-resu-flex-db',
      leistung_herleitung: 'Das Datenblatt nennt „Max. Charge/Discharge Power" als einzigen '
        + 'Leistungswert (22 A je Größe). Ein Wert für Laden und Entladen (Einzelwert-Regel). '
        + 'Nutzbare Energie laut Blatt bei 100 % Entladetiefe.',
      groessen: [
        { groesse: '8.6', module: null, nutzbar_kwh: 8.6, entlade_kw: 4.3, lade_kw: 4.3 },
        { groesse: '12.9', module: null, nutzbar_kwh: 12.9, entlade_kw: 6.5, lade_kw: 6.5 },
        { groesse: '17.2', module: null, nutzbar_kwh: 17.2, entlade_kw: 8.5, lade_kw: 8.5 },
      ],
      garantie_zyklen: null, garantie_jahre: null, // das Spezifikationsblatt nennt keine Garantie
    },
    // ---------- Neue Hersteller-Speicher (2026-07-05) ----------
    {
      id: "alphaess-smile-g3-bat-3.8s",
      hersteller: "AlphaESS",
      name: "SMILE-G3-BAT-3.8S",
      modul: {
        energie_kwh: 3.8,
        spannung_v: 96,
        chemie: "LiFePO4 (LFP)",
        quelle: "alphaess-bat-3.8s"
      },
      spec_quelle: "alphaess-bat-3.8s",
      verschaltung: "serie",
      strom_a: 40,
      strom_hinweis: "Datenblatt, Operating Parameters: „Max. Charging Current\" = "
        + "„Max. Discharging Current\" 40 A. Einzelwert-Regel: Laden = Entladen. "
        + "„Modules Connection: 1 ~ 6 in series connection\".",
      /* Derselbe Fehler wie bei der 9.3S — siehe dort. */
      leistung_herleitung: "Das Datenblatt nennt keinen kW-Wert, sondern 40 A und 96 V "
        + "Modulnennspannung. Die Leistung je Turmgröße errechnet die Engine daraus "
        + "(Strom × Modulanzahl × Modulnennspannung) und weist sie als errechnet aus.",
      groessen: [
        {
          groesse: "3.6",
          module: 1,
          nutzbar_kwh: 3.6
        },
        {
          groesse: "7.3",
          module: 2,
          nutzbar_kwh: 7.3
        },
        {
          groesse: "10.9",
          module: 3,
          nutzbar_kwh: 10.9
        },
        {
          groesse: "14.6",
          module: 4,
          nutzbar_kwh: 14.6
        },
        {
          groesse: "18.2",
          module: 5,
          nutzbar_kwh: 18.2
        },
        {
          groesse: "21.9",
          module: 6,
          nutzbar_kwh: 21.9
        }
      ],
      garantie_zyklen: 8000,
      garantie_jahre: 10
    },
    {
      id: "alphaess-smile-g3-bat-9.3s",
      hersteller: "AlphaESS",
      name: "SMILE-G3-BAT-9.3S",
      modul: {
        energie_kwh: 9.3,
        spannung_v: 96,
        chemie: "LiFePO4 (LFP)",
        quelle: "alphaess-bat-9.3s"
      },
      spec_quelle: "alphaess-bat-9.3s",
      verschaltung: "serie",
      strom_a: 52.5,
      strom_hinweis: "Datenblatt V09.04292025, Operating Parameters: „Max. Charging Current\" "
        + "= „Max. Discharging Current\" 52,5 A. Einzelwert-Regel: Laden = Entladen. "
        + "Module Connection laut Datenblatt „1~12 in series\".",
      /*
       * Bis 2026-08-16 stand hier für JEDE Turmgröße 5,04 kW — das ist die
       * Leistung eines einzelnen Moduls (52,5 A × 96 V). Bei Serienschaltung
       * wächst die Spannung aber mit der Modulzahl: Ein 6er-Turm hat 576 V und
       * damit rund 30 kW. Der Fehler ließ eine 9.3S am SMILE-G3-T20 wie ein
       * 5-kW-System aussehen. Jetzt steht hier nur noch die Zutat, die Engine
       * rechnet je Größe und kennzeichnet das Ergebnis als „errechnet".
       */
      leistung_herleitung: "Das Datenblatt nennt keinen kW-Wert, sondern 52,5 A und 96 V "
        + "Modulnennspannung. Die Leistung je Turmgröße errechnet die Engine daraus "
        + "(Strom × Modulanzahl × Modulnennspannung) und weist sie als errechnet aus.",
      groessen: [
        {
          groesse: "9.3",
          module: 1,
          nutzbar_kwh: 9.3
        },
        {
          groesse: "18.6",
          module: 2,
          nutzbar_kwh: 18.6
        },
        {
          groesse: "27.9",
          module: 3,
          nutzbar_kwh: 27.9
        },
        {
          groesse: "37.2",
          module: 4,
          nutzbar_kwh: 37.2
        },
        {
          groesse: "46.5",
          module: 5,
          nutzbar_kwh: 46.5
        },
        {
          groesse: "55.8",
          module: 6,
          nutzbar_kwh: 55.8
        },
        {
          groesse: "77.4",
          module: 8,
          nutzbar_kwh: 77.4
        },
        {
          groesse: "93.0",
          module: 10,
          nutzbar_kwh: 93
        },
        {
          groesse: "111.6",
          module: 12,
          nutzbar_kwh: 111.6
        }
      ],
      garantie_zyklen: null,
      garantie_jahre: 10
    },
    {
      id: "alphaess-smile-g3-bat-10.1p",
      hersteller: "AlphaESS",
      name: "SMILE-G3-BAT-10.1P",
      modul: {
        energie_kwh: null,
        spannung_v: 96,
        chemie: "Lithium-Ionen (Rechargeable Lithium-ion Battery)",
        quelle: "alphaess-bat-10.1p-statement"
      },
      spec_quelle: "alphaess-bat-10.1p-statement",
      /* Parallel gestapelt: Die Systemspannung bleibt die Modulspannung,
       * es waechst nur der Strom. Ohne diesen Vermerk wuerde die Turmspannung
       * multipliziert und die Grenze um ein Vielfaches ueberschaetzt. */
      verschaltung: "parallel",
      leistung_herleitung: "Hergeleitet: Max. Charge/Discharge Current 52,5 A × Nominal Voltage 96 V = 5,04 kW (Statement nennt keinen kW-Wert und keine kWh).",
      groessen: [
        {
          groesse: "10.1P",
          module: null,
          nutzbar_kwh: null,
          entlade_kw: 5.04,
          lade_kw: 5.04
        }
      ],
      garantie_zyklen: null,
      garantie_jahre: null
    },
    {
      id: "alphaess-smile-g3-bat-8.2p",
      hersteller: "AlphaESS",
      name: "SMILE-G3-BAT-8.2P",
      modul: {
        energie_kwh: null,
        spannung_v: 256,
        chemie: "LiFePO4 (LFP)",
        quelle: "alphaess-smile-g3-t12-t20"
      },
      spec_quelle: "alphaess-smile-g3-t12-t20",
      /* Parallel gestapelt: Die Systemspannung bleibt die Modulspannung,
       * es waechst nur der Strom. Ohne diesen Vermerk wuerde die Turmspannung
       * multipliziert und die Grenze um ein Vielfaches ueberschaetzt. */
      verschaltung: "parallel",
      leistung_herleitung: "Dokumentiert (Fußnote SMILE-G3-T12/15/20): max. Lade-/Entladeleistung 8,2 kW bei einer Batterie. (Strom×Spannung 40 A × 256 V ergäbe 10,24 kW; konservativ der dokumentierte 8,2-kW-Wert.)",
      groessen: [
        {
          groesse: "7.8",
          module: null,
          nutzbar_kwh: 7.8,
          entlade_kw: 8.2,
          lade_kw: 8.2
        }
      ],
      garantie_zyklen: 10000,
      garantie_jahre: 10
    },
    {
      id: "alphaess-smile-hi-bat-7.8",
      hersteller: "AlphaESS",
      name: "SMILE-Hi5/10-BAT-7.8",
      modul: {
        energie_kwh: null,
        spannung_v: 256,
        chemie: "LiFePO4 (LFP)",
        quelle: "alphaess-smile-hi10"
      },
      spec_quelle: "alphaess-smile-hi10",
      /* Parallel gestapelt: Die Systemspannung bleibt die Modulspannung,
       * es waechst nur der Strom. Ohne diesen Vermerk wuerde die Turmspannung
       * multipliziert und die Grenze um ein Vielfaches ueberschaetzt. */
      verschaltung: "parallel",
      leistung_herleitung: "Dokumentiert (Fußnote SMILE-Hi10): max. Lade-/Entladeleistung 7,8 kW bei einer Batterie. (Strom×Spannung 32 A × 256 V ≈ 8,19 kW; konservativ der dokumentierte 7,8-kW-Wert.)",
      groessen: [
        {
          groesse: "7.8",
          module: null,
          nutzbar_kwh: 7.8,
          entlade_kw: 7.8,
          lade_kw: 7.8
        }
      ],
      garantie_zyklen: null,
      garantie_jahre: 10
    },
    {
      id: "alphaess-smile-hi5-bat-4.8",
      hersteller: "AlphaESS",
      name: "SMILE-Hi5-BAT-4.8",
      modul: {
        energie_kwh: null,
        spannung_v: 153.6,
        chemie: "LiFePO4 (LFP)",
        quelle: "alphaess-smile-hi5"
      },
      spec_quelle: "alphaess-smile-hi5",
      /* Parallel gestapelt: Die Systemspannung bleibt die Modulspannung,
       * es waechst nur der Strom. Ohne diesen Vermerk wuerde die Turmspannung
       * multipliziert und die Grenze um ein Vielfaches ueberschaetzt. */
      verschaltung: "parallel",
      leistung_herleitung: "Hergeleitet: Max. Lade-/Entladestrom 32 A (1C) × Nennspannung 153,6 V = 4,92 kW (Datenblatt nennt keinen batteriespezifischen kW-Wert).",
      groessen: [
        {
          groesse: "4.8",
          module: null,
          nutzbar_kwh: 4.8,
          entlade_kw: 4.92,
          lade_kw: 4.92
        }
      ],
      garantie_zyklen: null,
      garantie_jahre: 10
    },
    {
      id: "huawei-luna2000-s1",
      hersteller: "Huawei",
      name: "LUNA2000-S1",
      modul: {
        energie_kwh: 6.9,
        spannung_v: null,
        chemie: "LiFePO4",
        quelle: "huawei-luna2000-s1"
      },
      spec_quelle: "huawei-luna2000-s1",
      leistung_herleitung: "Datenblatt nennt kombinierten Wert \"Max. charging & discharging power\" direkt in kW je Turmgröße (3,5 / 7 / 10,5 kW). Ein Wert für Laden UND Entladen ⇒ lade_kw = entlade_kw (Einzelwert-Regel).",
      groessen: [
        {
          groesse: "7",
          bezeichnung: "LUNA2000-7-S1",
          module: 1,
          nutzbar_kwh: 6.9,
          entlade_kw: 3.5,
          lade_kw: 3.5
        },
        {
          groesse: "14",
          bezeichnung: "LUNA2000-14-S1",
          module: 2,
          nutzbar_kwh: 13.8,
          entlade_kw: 7,
          lade_kw: 7
        },
        {
          groesse: "21",
          bezeichnung: "LUNA2000-21-S1",
          module: 3,
          nutzbar_kwh: 20.7,
          entlade_kw: 10.5,
          lade_kw: 10.5
        }
      ],
      garantie_zyklen: null,
      garantie_jahre: null
    },
    {
      id: "huawei-luna2000-s0",
      hersteller: "Huawei",
      name: "LUNA2000-S0",
      modul: {
        energie_kwh: 5,
        spannung_v: null,
        chemie: "LiFePO4",
        quelle: "huawei-luna2000-s0"
      },
      spec_quelle: "huawei-luna2000-s0",
      leistung_herleitung: "Datenblatt nennt \"Max. output power\" direkt in kW je Turmgröße (2,5 / 5 / 5 kW) — das ist die Entladeleistung. Eine Ladeleistung nennt das Blatt nicht ⇒ lade_kw bleibt offen (null), nicht gleichgesetzt. \"Peak output power\" (3,5 bzw. 7 kW für 10 s) ist keine Dauerleistung und bleibt außen vor.",
      groessen: [
        {
          groesse: "5",
          bezeichnung: "LUNA2000-5-S0",
          module: 1,
          nutzbar_kwh: 5,
          entlade_kw: 2.5,
          lade_kw: null
        },
        {
          groesse: "10",
          bezeichnung: "LUNA2000-10-S0",
          module: 2,
          nutzbar_kwh: 10,
          entlade_kw: 5,
          lade_kw: null
        },
        {
          groesse: "15",
          bezeichnung: "LUNA2000-15-S0",
          module: 3,
          nutzbar_kwh: 15,
          entlade_kw: 5,
          lade_kw: null
        }
      ],
      garantie_zyklen: null,
      garantie_jahre: null
    },
    {
      id: "dyness-tower-pro",
      hersteller: "Dyness",
      name: "Tower Pro",
      modul: {
        energie_kwh: 3.84,
        spannung_v: null,
        chemie: "LiFePO4 (LFP)",
        quelle: "dyness-tower-pro-datenblatt"
      },
      spec_quelle: "dyness-tower-pro-datenblatt",
      leistung_herleitung: "Datenblatt nennt \"Max. Kontinuierliche Lade-/Entladeleistung\" je Größe direkt in kW (1 Wert, Laden=Entladen, 1C).",
      groessen: [
        {
          groesse: "TP7",
          module: 2,
          nutzbar_kwh: 7.296,
          entlade_kw: 7.68,
          lade_kw: 7.68
        },
        {
          groesse: "TP11",
          module: 3,
          nutzbar_kwh: 10.944,
          entlade_kw: 11.52,
          lade_kw: 11.52
        },
        {
          groesse: "TP15",
          module: 4,
          nutzbar_kwh: 14.592,
          entlade_kw: 15.36,
          lade_kw: 15.36
        },
        {
          groesse: "TP19",
          module: 5,
          nutzbar_kwh: 18.24,
          entlade_kw: 19.2,
          lade_kw: 19.2
        },
        {
          groesse: "TP23",
          module: 6,
          nutzbar_kwh: 21.888,
          entlade_kw: 23.04,
          lade_kw: 23.04
        }
      ],
      garantie_zyklen: 8000,
      garantie_jahre: 10
    },
    {
      id: "dyness-tower-s2",
      hersteller: "Dyness",
      name: "Tower",
      modul: {
        energie_kwh: 3.55,
        spannung_v: null,
        chemie: "LiFePO4 (LFP)",
        quelle: "dyness-tower-s2-datenblatt"
      },
      spec_quelle: "dyness-tower-s2-datenblatt",
      leistung_herleitung: "Datenblatt nennt \"Max. Kontinuierliche Lade-/Entladeleistung\" je Größe direkt in kW (1 Wert, Laden=Entladen, 0,6C mit WR).",
      groessen: [
        {
          groesse: "T7",
          module: 2,
          nutzbar_kwh: 6.745,
          entlade_kw: 4.26,
          lade_kw: 4.26
        },
        {
          groesse: "T10",
          module: 3,
          nutzbar_kwh: 10.127,
          entlade_kw: 6.39,
          lade_kw: 6.39
        },
        {
          groesse: "T14",
          module: 4,
          nutzbar_kwh: 13.499,
          entlade_kw: 8.52,
          lade_kw: 8.52
        },
        {
          groesse: "T17",
          module: 5,
          nutzbar_kwh: 16.872,
          entlade_kw: 10.65,
          lade_kw: 10.65
        },
        {
          groesse: "T21",
          module: 6,
          nutzbar_kwh: 20.245,
          entlade_kw: 12.78,
          lade_kw: 12.78
        }
      ],
      garantie_zyklen: 6000,
      garantie_jahre: null
    },
    {
      id: "dyness-tower-s3",
      hersteller: "Dyness",
      name: "Tower S3",
      modul: {
        energie_kwh: 3.55,
        spannung_v: null,
        chemie: "LiFePO4 (LFP)",
        quelle: "dyness-tower-s3-datenblatt"
      },
      spec_quelle: "dyness-tower-s3-datenblatt",
      leistung_herleitung: "Datenblatt nennt \"Max. Continuous Charge/Discharge Power\" je Größe direkt in kW (1 Wert, Laden=Entladen, 0,6C mit WR).",
      groessen: [
        {
          groesse: "TS7",
          module: 2,
          nutzbar_kwh: 6.745,
          entlade_kw: 4.26,
          lade_kw: 4.26
        },
        {
          groesse: "TS10",
          module: 3,
          nutzbar_kwh: 10.127,
          entlade_kw: 6.39,
          lade_kw: 6.39
        },
        {
          groesse: "TS14",
          module: 4,
          nutzbar_kwh: 13.499,
          entlade_kw: 8.52,
          lade_kw: 8.52
        },
        {
          groesse: "TS17",
          module: 5,
          nutzbar_kwh: 16.872,
          entlade_kw: 10.65,
          lade_kw: 10.65
        },
        {
          groesse: "TS21",
          module: 6,
          nutzbar_kwh: 20.245,
          entlade_kw: 12.78,
          lade_kw: 12.78
        }
      ],
      garantie_zyklen: 6000,
      garantie_jahre: null
    },

    /*
     * SolarEdge-Speicher und BYD Premium LVS, aufgenommen 2026-08-14.
     * Garantiezyklen nennt keines der vier Datenblaetter — deshalb ueberall
     * null, und der Preis je kWh Lebensdauer bleibt bei diesen Familien aus.
     */
    {
      /*
       * Home Batterie 48V. Die Leistung haengt hier an der ANZAHL der Module,
       * nicht nur an der Kapazitaet: Das Datenblatt weist fuer ein einzelnes
       * Modul 2 825 W Laden und 4 096 W Entladen aus, ab zwei Modulen 5 000 W
       * in beide Richtungen. Beide Zeilen stehen im Blatt; nichts gerechnet.
       * Die nutzbare Energie nennt es mit 4 600 Wh je Modul und daneben mit
       * 4 850 Wh — letzteres nur fuer Neuinstallationen ab dem 01.01.2025 mit
       * dreiphasigem Home Hub. Angesetzt ist der niedrigere Wert, damit die
       * Kapazitaet nie zu gross ausgewiesen wird.
       */
      id: 'solaredge-home-batterie-48v',
      hersteller: 'SolarEdge',
      name: 'Home Batterie 48V',
      spannungsklasse: 'niedervolt',
      modul: { energie_kwh: 4.6, spannung_v: null, chemie: 'Li-Ion – LFP', quelle: 'solaredge-bat-48v-db' },
      spec_quelle: 'solaredge-bat-48v-db',
      leistung_herleitung: 'Datenblattzeilen „Maximale Ausgangsleistung (Laden / Entladen) − für ein '
        + 'einzelnes Modul 2 825 / 4 096 W" und „… für mehrere Module 5 000 / 5 000 W". Die '
        + 'Modulnennspannung nennt das Blatt nicht, nur den Spannungsbereich 44,8–56,5 Vdc. Deshalb '
        + 'bleibt sie leer und der Berater rechnet für diese Familie keine Paarungsgrenze aus Strom '
        + 'und Turmspannung.',
      kapazitaet_herleitung: 'Nutzbare Energie je Modul 4 600 Wh (100 % Entladetiefe) × Modulanzahl.',
      groessen: [
        { groesse: '4.6', module: 1, nutzbar_kwh: 4.6, entlade_kw: 4.096, lade_kw: 2.825 },
        { groesse: '9.2', module: 2, nutzbar_kwh: 9.2, entlade_kw: 5.0, lade_kw: 5.0 },
        { groesse: '13.8', module: 3, nutzbar_kwh: 13.8, entlade_kw: 5.0, lade_kw: 5.0 },
        { groesse: '18.4', module: 4, nutzbar_kwh: 18.4, entlade_kw: 5.0, lade_kw: 5.0 },
        { groesse: '23.0', module: 5, nutzbar_kwh: 23.0, entlade_kw: 5.0, lade_kw: 5.0 },
      ],
      garantie_zyklen: null,
      garantie_jahre: 10,
    },
    {
      /*
       * Home Batterie 400V. Ein Geraet, kein Turm — deshalb genau eine Groesse.
       * Dass bis zu drei davon an einen Wechselrichter duerfen, ist eine Aussage
       * ueber die Anlage und steht als Einschraenkung an der Freigabe.
       */
      id: 'solaredge-home-batterie-400v',
      hersteller: 'SolarEdge',
      name: 'Home Batterie 400V',
      modul: { energie_kwh: 9.7, spannung_v: null, chemie: null, quelle: 'solaredge-bat-400v-db' },
      spec_quelle: 'solaredge-bat-400v-db',
      leistung_herleitung: 'Datenblattzeile „Kontinuierliche Ausgangsleistung 5 000 W". Ein Wert, der '
        + 'laut Fußnote 1 für Laden und Entladen gilt und temperaturabhängig sinken kann. Die '
        + 'Spitzenleistung von 7 500 W gilt nur 10 Sekunden im Ersatzstrombetrieb und bleibt außen '
        + 'vor. Zellchemie und Nennspannung nennt das Blatt nicht (nur 350–450 Vdc Bereich).',
      groessen: [
        { groesse: '9.7', module: 1, nutzbar_kwh: 9.7, entlade_kw: 5.0, lade_kw: 5.0 },
      ],
      garantie_zyklen: null,
      garantie_jahre: 10,
    },
    {
      /*
       * Nexis Battery. Gefuehrt ist EIN Stack mit 1 bis 4 Bloecken — das ist die
       * Spalteneinteilung des Datenblatts. Dass bis zu vier Stacks an einen
       * Nexis-Wechselrichter duerfen (16 Bloecke), steht als Einschraenkung an
       * der Freigabe. Angesetzt sind die Dreiphasen-Werte (715–950 V), weil der
       * Katalog bisher nur den dreiphasigen Nexis fuehrt; die einphasige Spalte
       * weicht beim vierten Block ab (13 statt 14 kW).
       */
      id: 'solaredge-nexis-battery',
      hersteller: 'SolarEdge',
      name: 'Nexis Battery',
      modul: { energie_kwh: 4.65, spannung_v: null, chemie: 'LiFePo4', quelle: 'solaredge-nexis-bat-db' },
      spec_quelle: 'solaredge-nexis-bat-db',
      leistung_herleitung: 'Datenblattzeile „Maximum Continuous Charge / Discharge Power", Spalte '
        + '715V–950V (Dreiphasen-System): 3,5 / 7 / 10,5 / 14 kW je nach Blockzahl. Ein Wert für '
        + 'Laden und Entladen. Die Spitzenentladeleistung (10 Sekunden) bleibt außen vor. '
        + 'Nennspannung je Block nennt das Blatt nicht, nur die Systemspannung 450 V einphasig / '
        + '750 V dreiphasig.',
      kapazitaet_herleitung: 'Datenblattzeile „Usable Energy" je Blockzahl (4,65 / 9,3 / 13,95 / '
        + '18,6 kWh). Nicht die daneben stehende „Nominal Energy".',
      groessen: [
        { groesse: '4.65', module: 1, nutzbar_kwh: 4.65, entlade_kw: 3.5, lade_kw: 3.5 },
        { groesse: '9.3', module: 2, nutzbar_kwh: 9.3, entlade_kw: 7.0, lade_kw: 7.0 },
        { groesse: '13.95', module: 3, nutzbar_kwh: 13.95, entlade_kw: 10.5, lade_kw: 10.5 },
        { groesse: '18.6', module: 4, nutzbar_kwh: 18.6, entlade_kw: 14.0, lade_kw: 14.0 },
      ],
      garantie_zyklen: null,
      garantie_jahre: null,
    },
    {
      /*
       * BYD Battery-Box Premium LVS. Ein 48-V-System: Die Module liegen parallel,
       * die Nennspannung bleibt bei jeder Groesse 51,2 V — das Datenblatt fuehrt
       * sie einmal fuer die ganze Reihe. Genau deshalb traegt die Familie
       * spannungsklasse „niedervolt": Die Turmspannung waechst hier NICHT mit der
       * Modulzahl, anders als bei den Hochvolt-Tuermen.
       */
      id: 'byd-premium-lvs',
      hersteller: 'BYD',
      name: 'Battery-Box Premium LVS',
      spannungsklasse: 'niedervolt',
      modul: { energie_kwh: 4.0, spannung_v: 51.2, chemie: 'Lithium-Eisen-Phosphat (LiFePO4)', quelle: 'byd-lvs-db' },
      spec_quelle: 'byd-lvs-db',
      leistung_herleitung: 'Das Datenblatt nennt Strom statt Leistung: „Max Konst. Ausgangsstrom" '
        + '65 / 130 / 195 / 250 / 250 / 250 A. Dauerleistung = dieser Strom × Nennspannung 51,2 V '
        + '(beides Datenblattangaben, die Multiplikation ist unsere). Es weist nur EINEN Stromwert '
        + 'aus, deshalb steht er auf Laden und Entladen; die Fußnote nennt für das Laden zusätzlich '
        + 'eine Leistungsminderung zwischen -10 und 5 °C. Der Ausgangsspitzenstrom (5 Sekunden) '
        + 'bleibt außen vor.',
      groessen: [
        { groesse: '4.0', module: 1, nutzbar_kwh: 4, entlade_kw: 3.33, lade_kw: 3.33 },
        { groesse: '8.0', module: 2, nutzbar_kwh: 8, entlade_kw: 6.66, lade_kw: 6.66 },
        { groesse: '12.0', module: 3, nutzbar_kwh: 12, entlade_kw: 9.98, lade_kw: 9.98 },
        { groesse: '16.0', module: 4, nutzbar_kwh: 16, entlade_kw: 12.8, lade_kw: 12.8 },
        { groesse: '20.0', module: 5, nutzbar_kwh: 20, entlade_kw: 12.8, lade_kw: 12.8 },
        { groesse: '24.0', module: 6, nutzbar_kwh: 24, entlade_kw: 12.8, lade_kw: 12.8 },
      ],
      garantie_zyklen: null,
      garantie_jahre: 10,
    },
  ];

  if (typeof module !== 'undefined' && module.exports) module.exports = SPEICHER;
  if (root) root.IVBeraterDatenSpeicher = SPEICHER;
})(typeof window !== 'undefined' ? window : null);

/*
 * inselvolt Kompatibilitätsberater — Datenbasis, Teil FREIGABEN (Whitelist).
 *
 * ÄNDERUNGEN NUR NACH v2/DATENPFLEGE.md (Rezept A). Teil der vierteiligen
 * Datenbasis — Zusammenbau und Schnittstelle: daten/berater-daten.js.
 * Freigaben NUR aus Herstellerlisten — nie hergeleitet.
 */
(function (root) {
  'use strict';

  /*
   * FREIGABEN (Whitelist). Jede Zeile = eine dokumentierte Freigabe-Aussage einer Quelle
   * für (WR-Familie × Speicher-Familie × Größenliste). Optional wr_varianten, wenn die
   * Quelle nur bestimmte WR-Größen freigibt. „einschraenkung" = wörtliche Einschränkung
   * der Quelle. Die Engine vereinigt Quellen je Kombination; Hersteller-Quellen tragen
   * die Freigabe, Distributor-Quellen gelten als Bestätigung.
   *
   * Optional „dc_grenzen": Wo eine Liste die zulässige DC-Leistung nicht je Gerät, sondern
   * je Paarung aus WR-Variante und Speichergröße ausweist, steht sie hier — Struktur
   * { '<wr_varianten_id>': { '<groesse>': kW } }, ein Wert für Laden und Entladen.
   * Sie gehört an die Freigabe und nicht ans Gerät, weil sie erst aus der Paarung entsteht.
   */
  var DC_HINWEIS = 'Tabelle „Maximale DC-Lade-/Entladeleistung mit GEN24 Plus [kW]" (Liste S. 2): ein Wert je Paarung, gültig für Laden und Entladen. Es sind DC-Werte. Beim Entladen kommt haushaltsseitig noch der Wirkungsgrad des Wechselrichters dazu (Fußnote 1 der Liste).';

  /*
   * Alle drei Dyness-Turmlisten (Pro, S2, S3) führen dieselben zwei Deye-Zeilen mit
   * identischer Freigabe über alle fünf Turmgrößen. Beide Angaben stehen deshalb einmal
   * hier statt dreimal wortgleich in FREIGABEN — die Aussage ist eine, die Zeilen sind drei.
   *
   * Nicht enthalten: die SG02HP3-Baureihen (EU-EM6 60–80 kW, EU-AM3). Die Dyness-Listen
   * führen sie nicht; „nicht geführt" heißt „noch nicht bestätigt", nicht „passt nicht".
   */
  var DEYE_SG01HP3_DYNESS = [
    'deye-sun-5k-sg01hp3', 'deye-sun-6k-sg01hp3', 'deye-sun-8k-sg01hp3',
    'deye-sun-10k-sg01hp3', 'deye-sun-12k-sg01hp3', 'deye-sun-15k-sg01hp3',
    'deye-sun-20k-sg01hp3', 'deye-sun-25k-sg01hp3',
    'sun-sg01hp3-eu-bm3', 'sun-sg01hp3-eu-bm4',
  ];
  var DEYE_DYNESS_AUFLAGE = 'Liste führt zwei Zeilen: "SUN-5K~25K-SG01HP3-EU-AM2" und '
    + '"SUN-29.9~50K-SG01HP3-EU-BM3/4", beide für alle fünf Turmgrößen angehakt. Die '
    + 'SG02HP3-Baureihen (EU-EM6, EU-AM3) führt sie nicht.';

  var FREIGABEN = [
    { wr: 'felicity-ivem', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'deye-sun-lp', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'luxpower-lxp', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'growatt-spf', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'voltronic-axpert', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'sunsynk-sg', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'megarevo-r', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Felicity und der Wechselrichter-Hersteller haben die Kombination gemeinsam geprüft.' },
    { wr: 'victron-cerbo', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Kommunikation nur über eine Victron Cerbo GX als Brücke. Ohne sie tauschen Speicher und Wechselrichter keine Daten aus.' },
    { wr: 'srne-hf-hes', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Felicity und der Wechselrichter-Hersteller haben die Kombination gemeinsam geprüft.' },
    { wr: 'solis-eh', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Felicity und der Wechselrichter-Hersteller haben die Kombination gemeinsam geprüft.' },
    { wr: 'mppsolar-pip', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'afore-sl', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'sofar-hyd-ep', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'chisage-mars-jup', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Felicity und der Wechselrichter-Hersteller haben die Kombination gemeinsam geprüft.' },
    { wr: 'solax-x1-lv', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'solark', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    { wr: 'hoymiles-hys-lv', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Felicity und der Wechselrichter-Hersteller haben die Kombination gemeinsam geprüft.' },
    { wr: 'invt-imars', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Felicity und der Wechselrichter-Hersteller haben die Kombination gemeinsam geprüft.' },
    { wr: 'aohai-ksl', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Felicity und der Wechselrichter-Hersteller haben die Kombination gemeinsam geprüft.' },
    /*
     * ENTFALLEN am 2026-09-07 (Quellen-Monitor #92): SAJ, Solplanet, GoodWe und
     * Shinemann standen in der Felicity-Liste V3.0 (2025.9) und stehen in der
     * Ausgabe vom 10.02.2026 nicht mehr — vier Marken weniger, keine neue dazu
     * (20 statt 24 Zeilen; beide Fassungen liegen unter `Datenblätter/Speicher/`
     * und wurden Marke für Marke verglichen).
     *
     * Die vier Zeilen sind gelöscht, nicht auf „inkompatibel" gesetzt: Felicity
     * sagt nicht, dass es nicht geht, Felicity sagt es nicht mehr. Damit ist die
     * Kombination „noch nicht bestätigt" und läuft über den Kontaktpfad
     * (Invariante 1). Ein anderer Beleg existiert für keine der vier — geprüft.
     *
     * Wer sie zurückholen will, braucht eine Fundstelle, keine Erinnerung.
     */
    { wr: 'amensolar-n3h', speicher: 'felicity-fla-eu', groessen: ['FLA48100-EU', 'FLA48171-EU', 'FLA48230-EU', 'FLA48250-EU', 'FLA48280-EU', 'FLA48300-EU'],
      quelle: 'felicity-lv-liste', einschraenkung: 'Von Felicity geprüft (keine gemeinsame Prüfung mit dem Wechselrichter-Hersteller).' },
    // ---------- SMA Sunny Island X (Hersteller) ----------
    /*
     * Eingetragen 2026-09-07 aus der SMA-Liste "Zugelassene Batterien"
     * (SIxx-20-Batteries-TI-de-14, Version 1.4). Vier Zeilen, weil die Liste
     * zwei Geraete und zwei Baureihen getrennt fuehrt — und weil sich die
     * Mindestkonfiguration je Geraet unterscheidet:
     *
     *      SI30-20  ab  7 Modulen        SI50-20  ab 12 Modulen
     *
     * Das ist eine MINDESTzahl. Der SI50-20 laeuft also nicht "besser" mit
     * wenigen Modulen, er ist mit weniger als zwoelf gar nicht zugelassen —
     * seine 51 kW brauchen die Turmspannung. Nach oben endet es bei 15 Modulen,
     * und diese Grenze kommt von der Batterie, nicht von SMA.
     *
     * `wr_varianten` traegt die Unterscheidung, damit sie im Ergebnis ankommt
     * und nicht bloss im Text steht.
     */
    { wr: 'sma-sunny-island-x', wr_varianten: ['si30-20'], speicher: 'dyness-stack100',
      groessen: ['7S', '8S', '9S', '10S', '11S', '12S', '13S', '14S', '15S'],
      quelle: 'sma-si-x-batterien',
      einschraenkung: 'SMA-Liste SIxx-20-Batteries-TI-de-14: SI30-20 ab 7 Modulen (Mindestkonfiguration), Kommunikation CAN, On-Grid und Off-Grid. Voraussetzung ist Firmware — Batterie ab 00.00.121.R, Wechselrichter ab 3.07.09.R. Nach oben begrenzt die Batterie mit 15 Modulen, nicht SMA.' },
    { wr: 'sma-sunny-island-x', wr_varianten: ['si50-20'], speicher: 'dyness-stack100',
      groessen: ['12S', '13S', '14S', '15S'],
      quelle: 'sma-si-x-batterien',
      einschraenkung: 'SMA-Liste SIxx-20-Batteries-TI-de-14: SI50-20 ab 12 Modulen (Mindestkonfiguration), Kommunikation CAN, On-Grid und Off-Grid. Voraussetzung ist Firmware — Batterie ab 00.00.121.R, Wechselrichter ab 3.07.09.R. Nach oben begrenzt die Batterie mit 15 Modulen, nicht SMA.' },
    { wr: 'sma-sunny-island-x', wr_varianten: ['si30-20'], speicher: 'dyness-stack100-pro',
      groessen: ['7S', '8S', '9S', '10S', '11S', '12S', '13S', '14S', '15S'],
      quelle: 'sma-si-x-batterien',
      einschraenkung: 'SMA-Liste SIxx-20-Batteries-TI-de-14: SI30-20 ab 7 Modulen (Mindestkonfiguration), Kommunikation CAN, On-Grid und Off-Grid. Voraussetzung ist Firmware — Batterie ab 00.00.121.R, Wechselrichter ab 3.07.09.R. Nach oben begrenzt die Batterie mit 15 Modulen, nicht SMA.' },
    { wr: 'sma-sunny-island-x', wr_varianten: ['si50-20'], speicher: 'dyness-stack100-pro',
      groessen: ['12S', '13S', '14S', '15S'],
      quelle: 'sma-si-x-batterien',
      einschraenkung: 'SMA-Liste SIxx-20-Batteries-TI-de-14: SI50-20 ab 12 Modulen (Mindestkonfiguration), Kommunikation CAN, On-Grid und Off-Grid. Voraussetzung ist Firmware — Batterie ab 00.00.121.R, Wechselrichter ab 3.07.09.R. Nach oben begrenzt die Batterie mit 15 Modulen, nicht SMA.' },

    // ---------- Fronius-Website (Hersteller) ----------
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7'], quelle: 'fronius-web' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7'], quelle: 'fronius-web' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-premium-hvm', groessen: ['11.0', '13.8', '16.6', '19.3'], quelle: 'fronius-web' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3'], quelle: 'fronius-web' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'fronius-reserva', groessen: ['6.3', '9.5'], quelle: 'fronius-web' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'fronius-reserva-pro', groessen: ['12.0', '16.0', '20.0'], quelle: 'fronius-web' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'lg-flex', groessen: ['8.6', '12.9'], quelle: 'fronius-web' },

    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'fronius-web' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'fronius-web' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-premium-hvm', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'fronius-web' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'fronius-web' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'fronius-reserva', groessen: ['6.3', '9.5', '12.6', '15.8'], quelle: 'fronius-web' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'fronius-reserva-pro', groessen: ['12.0', '16.0', '20.0', '24.0', '28.0', '32.0'], quelle: 'fronius-web' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'lg-flex', groessen: ['8.6', '12.9', '17.2'], quelle: 'fronius-web' },

    { wr: 'fronius-verto-plus', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'fronius-web' },
    { wr: 'fronius-verto-plus', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'fronius-web' },
    { wr: 'fronius-verto-plus', speicher: 'byd-premium-hvm', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'fronius-web', einschraenkung: 'HVM 8.3 laut Verto-Datenblatt ausgenommen; bei mehreren BYD-Türmen max. zulässige Ströme beachten.', ausgeschlossen: ['8.3'], ausschluss_wortlaut: 'HVM 8.3 laut Verto-Datenblatt ausgenommen' },
    { wr: 'fronius-verto-plus', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'fronius-web' },
    { wr: 'fronius-verto-plus', speicher: 'byd-hvb', groessen: ['11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'fronius-web' },
    { wr: 'fronius-verto-plus', speicher: 'fronius-reserva', groessen: ['6.3', '9.5', '12.6', '15.8'], quelle: 'fronius-web' },
    { wr: 'fronius-verto-plus', speicher: 'fronius-reserva-pro', groessen: ['12.0', '16.0', '20.0', '24.0', '28.0', '32.0'], quelle: 'fronius-web' },

    /* ---------- Fronius GEN24 Plus — Speicherlösung DE v11 Nov 2022 (Hersteller) ----------
     *
     * Zweitbeleg neben `fronius-web` und die erste Fronius-Quelle, die die Legacy-Reihen
     * BYD Battery-Box Premium HVS/HVM ausdrücklich mit Größenliste führt.
     *
     * Lesart der Tabelle S. 2 (streng nach Invariante 1):
     *  - Zelle mit Leistungswert ⇒ freigegeben.
     *  - Zelle mit „-" ⇒ vom Hersteller ausgenommen (wird als Einschränkung benannt).
     *  - Größe ohne Spalte (HVS 12.8, HVM 8.3) ⇒ NICHT gelistet, also weder freigegeben
     *    noch ausgenommen — bleibt „auf Anfrage prüfen". Nicht aus dem Fehlen schließen.
     *
     * Die Leistungswerte der Tabelle sind kombinationsabhängig (WR-Variante × Speichergröße)
     * und stehen deshalb als `dc_grenzen` an der Freigabe, nicht am Gerät: Die Turmspannung
     * wächst mit der Modulzahl, kleine Türme erreichen den Gerätewert nicht (HVM-Modul
     * 51,2 V ⇒ HVM 11.0 mit 4 Modulen bleibt bei 4,51 kW, unabhängig vom Wechselrichter).
     * Die Engine nimmt den Wert als weiteres Glied in die min()-Rechnung.
     */
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7'], quelle: 'fronius-gen24-byd-lg',
      einschraenkung: 'HVS 10.2 laut Liste für Primo GEN24 Plus ausgenommen; HVS 12.8 in dieser Liste nicht geführt. Parallelbetrieb mit 2 oder 3 Türmen freigegeben (bis ca. 23,04 kWh). Die Lade-/Entladeleistung bleibt dabei die eines einzelnen Turms.',
      dc_grenzen_hinweis: DC_HINWEIS,
      dc_grenzen: {
        'primo-3.0': { '5.1': 3.11, '7.7': 3.11 },
        'primo-3.6': { '5.1': 3.81, '7.7': 3.81 },
        'primo-4.0': { '5.1': 4.14, '7.7': 4.14 },
        'primo-4.6': { '5.1': 4.51, '7.7': 4.75 },
        'primo-5.0': { '5.1': 4.51, '7.7': 5.17 },
        'primo-6.0': { '5.1': 4.51, '7.7': 6.20 },
      },
      ausgeschlossen: ['10.2'],
      ausschluss_wortlaut: 'HVS 10.2 laut Liste für Primo GEN24 Plus ausgenommen'
    },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-premium-hvm', groessen: ['11.0', '13.8', '16.6', '19.3'], quelle: 'fronius-gen24-byd-lg',
      einschraenkung: 'HVM 22.1 laut Liste für Primo GEN24 Plus ausgenommen; HVM 8.3 in dieser Liste nicht geführt. Parallelbetrieb mit 2 oder 3 Türmen freigegeben (bis ca. 57,96 kWh). Die Lade-/Entladeleistung bleibt dabei die eines einzelnen Turms.',
      dc_grenzen_hinweis: DC_HINWEIS,
      dc_grenzen: {
        'primo-3.0': { '11.0': 3.11, '13.8': 3.11, '16.6': 3.11, '19.3': 3.11 },
        'primo-3.6': { '11.0': 3.81, '13.8': 3.81, '16.6': 3.81, '19.3': 3.81 },
        'primo-4.0': { '11.0': 4.14, '13.8': 4.14, '16.6': 4.14, '19.3': 4.14 },
        'primo-4.6': { '11.0': 4.51, '13.8': 4.75, '16.6': 4.75, '19.3': 4.75 },
        'primo-5.0': { '11.0': 4.51, '13.8': 5.17, '16.6': 5.17, '19.3': 5.17 },
        'primo-6.0': { '11.0': 4.51, '13.8': 5.63, '16.6': 6.20, '19.3': 6.20 },
      },
      ausgeschlossen: ['22.1'],
      ausschluss_wortlaut: 'HVM 22.1 laut Liste für Primo GEN24 Plus ausgenommen'
    },
    { wr: 'fronius-primo-gen24-plus', speicher: 'lg-flex', groessen: ['8.6', '12.9'], quelle: 'fronius-gen24-byd-lg',
      einschraenkung: 'RESU FLEX 17.2 laut Liste für Primo GEN24 Plus ausgenommen.',
      dc_grenzen_hinweis: DC_HINWEIS,
      dc_grenzen: {
        'primo-3.0': { '8.6': 3.11, '12.9': 3.11 },
        'primo-3.6': { '8.6': 3.81, '12.9': 3.81 },
        'primo-4.0': { '8.6': 4.14, '12.9': 4.14 },
        'primo-4.6': { '8.6': 4.30, '12.9': 4.75 },
        'primo-5.0': { '8.6': 4.30, '12.9': 5.17 },
        'primo-6.0': { '8.6': 4.30, '12.9': 6.20 },
      },
      ausgeschlossen: ['17.2'],
      ausschluss_wortlaut: 'RESU FLEX 17.2 laut Liste für Primo GEN24 Plus ausgenommen'
    },

    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2'], quelle: 'fronius-gen24-byd-lg',
      einschraenkung: 'HVS 12.8 in dieser Liste nicht geführt. Parallelbetrieb mit 2 oder 3 Türmen freigegeben (bis ca. 30,72 kWh). Die Lade-/Entladeleistung bleibt dabei die eines einzelnen Turms.',
      dc_grenzen_hinweis: DC_HINWEIS,
      dc_grenzen: {
        'symo-3.0': { '5.1': 2.56, '7.7': 3.15, '10.2': 3.15 },
        'symo-4.0': { '5.1': 2.56, '7.7': 3.84, '10.2': 4.18 },
        'symo-5.0': { '5.1': 2.56, '7.7': 3.84, '10.2': 5.20 },
        'symo-6.0': { '5.1': 4.51, '7.7': 6.22, '10.2': 6.22 },
        'symo-8.0': { '5.1': 4.51, '7.7': 6.76, '10.2': 8.26 },
        'symo-10.0': { '5.1': 4.51, '7.7': 6.76, '10.2': 9.01 },
      } },
    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-premium-hvm', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'fronius-gen24-byd-lg',
      einschraenkung: 'HVM 8.3 in dieser Liste nicht geführt. Parallelbetrieb mit 2 oder 3 Türmen freigegeben (bis ca. 57,96 kWh), bei HVM 22.1 nur mit 2 Türmen. Die Lade-/Entladeleistung bleibt dabei die eines einzelnen Turms.',
      dc_grenzen_hinweis: DC_HINWEIS,
      dc_grenzen: {
        'symo-3.0': { '11.0': 2.56, '13.8': 3.15, '16.6': 3.15, '19.3': 3.15, '22.1': 3.15 },
        'symo-4.0': { '11.0': 2.56, '13.8': 3.20, '16.6': 3.84, '19.3': 4.18, '22.1': 4.18 },
        'symo-5.0': { '11.0': 2.56, '13.8': 3.20, '16.6': 3.84, '19.3': 4.48, '22.1': 5.20 },
        'symo-6.0': { '11.0': 4.51, '13.8': 5.63, '16.6': 6.22, '19.3': 6.22, '22.1': 6.22 },
        'symo-8.0': { '11.0': 4.51, '13.8': 5.63, '16.6': 6.76, '19.3': 7.88, '22.1': 8.26 },
        'symo-10.0': { '11.0': 4.51, '13.8': 5.63, '16.6': 6.76, '19.3': 7.88, '22.1': 9.01 },
      } },
    { wr: 'fronius-symo-gen24-plus', speicher: 'lg-flex', groessen: ['8.6', '12.9', '17.2'], quelle: 'fronius-gen24-byd-lg',
      dc_grenzen_hinweis: DC_HINWEIS,
      dc_grenzen: {
        'symo-3.0': { '8.6': 2.86, '12.9': 3.15, '17.2': 3.15 },
        'symo-4.0': { '8.6': 2.86, '12.9': 4.18, '17.2': 4.18 },
        'symo-5.0': { '8.6': 2.86, '12.9': 4.29, '17.2': 5.20 },
        'symo-6.0': { '8.6': 4.30, '12.9': 6.22, '17.2': 6.22 },
        'symo-8.0': { '8.6': 4.30, '12.9': 6.50, '17.2': 8.26 },
        'symo-10.0': { '8.6': 4.30, '12.9': 6.50, '17.2': 8.50 },
      } },

    // ---------- BYD-Liste V1.5 (Hersteller; Modulbereiche → Größen) ----------
    { wr: 'kostal-plenticore-g3', speicher: 'byd-hvb', groessen: ['8.9', '11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'byd-v15', einschraenkung: 'ab WR-Firmware 3.04, Batterie-Firmware 1.28.0 (3–10 Module)' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-hvm-plus', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'byd-v15', einschraenkung: 'ab WR-Firmware 3.04, Batterie-Firmware 1.28.0 (3–8 Module)' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'byd-v15', einschraenkung: 'ab WR-Firmware 3.04, Batterie-Firmware 1.28.0 (2–5 Module)' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-hvb', groessen: ['8.9', '11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'byd-v15', einschraenkung: 'ab WR-Firmware 2.15 (3–10 Module)' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-hvm-plus', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'byd-v15' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'byd-v15' },
    { wr: 'goodwe-et', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'byd-v15', einschraenkung: '4–8 Module; Parallelbetrieb: BYD Combiner Box CBH-40A nicht zulässig (Verkabelung durch Installateur); BYD-Liste führt die Baureihen als „ET G2" und „ET (15–30 kW)"' },
    { wr: 'goodwe-et', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'byd-v15', einschraenkung: 'BYD-Liste führt die Baureihen als „ET G2" und „ET (15–30 kW)"' },
    { wr: 'fronius-verto-plus', speicher: 'byd-hvb', groessen: ['11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'byd-v15', einschraenkung: '4–10 Module, ab WR-Firmware 1.39.5-1' },
    { wr: 'fronius-verto-plus', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'byd-v15', einschraenkung: '4–8 Module' },
    { wr: 'fronius-verto-plus', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'byd-v15', einschraenkung: '2–5 Module' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'byd-v15', einschraenkung: '4–8 Module, ab WR-Firmware 1.39.5-1' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'byd-v15', einschraenkung: '2–5 Module' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3'], quelle: 'byd-v15', einschraenkung: '4–7 Module' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7'], quelle: 'byd-v15', einschraenkung: '2–3 Module' },

    /* ---------- KOSTAL-Liste 07/2026 (Hersteller) ----------
     * Vier Geraetereihen aus dieser Liste fuehrt der Berater: PLENTICORE G3,
     * PLENTICORE plus G2, PLENTICORE plus (G1) und PLENTICORE BI 25 G3. Die
     * uebrigen Namen der Liste — MP G3, BI 5.5/13, BI xx/26, BI xx/26 G2 —
     * haben bei uns keine Familie und stehen deshalb weiterhin als Wortlaut in
     * `einschraenkung`. Das ist keine Aussage gegen sie: "nicht gefuehrt"
     * heisst hier wie ueberall "noch nicht bestaetigt".
     *
     * Die Zuordnung Groessenzeile → Geraetezelle ist geometrisch aus den
     * Wortkoordinaten des PDF geprueft, nicht nach Augenmass abgelesen. Die
     * Zellen der Liste ueberspannen unterschiedlich viele Zeilen, und genau da
     * ist beim letzten Einlesen ein Fehler passiert (Stack100 12s, siehe dort).
     */
    { wr: 'kostal-plenticore-g3', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'kostal-0826', einschraenkung: 'BYD-Batterie kompatibel ab Firmware BMU 1.13 / BMS 3.19 (KOSTAL-Fußnote)' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-premium-hvm', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'kostal-0826', einschraenkung: 'BYD-Batterie kompatibel ab Firmware BMU 1.13 / BMS 3.19 (KOSTAL-Fußnote); HVM 8.3 in der KOSTAL-Liste nur für PLENTICORE G3 / MP G3 / BI 25 G3' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'kostal-0826' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-hvm-plus', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'kostal-0826' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-hvb', groessen: ['8.9', '11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'kostal-0826', einschraenkung: 'KOSTAL-Liste bezeichnet die HVB-Größen als 8.9/11.9/14.9/17.8/20.8/23.8/26.7/29.7. Gleiche Turmgrößen (3–10 Module), andere Rundung der Modellnamen' },
    { wr: 'kostal-plenticore-g3', speicher: 'kostal-helivor', groessen: ['6.4', '9.6', '12.8', '16.0', '19.2', '22.4', '25.6', '28.8'], quelle: 'kostal-0826', einschraenkung: 'ab G3-Software 3.06.03; Parallelbetrieb nur mit ZYC Combiner Box' },
    { wr: 'kostal-plenticore-g3', speicher: 'axitec-sv2', groessen: ['6.7', '10.1', '13.5', '16.9'], quelle: 'kostal-0826' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'kostal-0826' },
    /*
     * KOSTAL nennt die Paarungsgrenze als Formel statt als Tabelle (Fußnote 1 der Liste):
     * „Eine Verwendung der BYD Battery-Box Premium HVM 11.0 oder 13.8 ist technisch möglich.
     *  Aufgrund der relativ niedrigen Batteriespannung dieser Varianten ist auf eine
     *  Einschränkung der Lade- und Endladeleistung (UBat x 13 A max. Eingangsstrom des WR)
     *  und der Systemeffizienz hinzuweisen (gilt nur für PLENTICORE plus und PLENTICORE BI)."
     * Derselbe Effekt wie bei Fronius, nur anders aufgeschrieben. Ausgerechnet mit der
     * Nennspannung aus der BYD-Datenbasis: 4 Module × 51,2 V = 204,8 V, 5 × 51,2 V = 256,0 V.
     * Gilt ausdrücklich NUR für PLENTICORE plus — für G3 nennt die Liste 17/30 A.
     */
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-premium-hvm', groessen: ['11.0'], quelle: 'kostal-0826',
      dc_grenzen_hinweis: 'Fußnote 1 der KOSTAL-Liste: „Einschränkung der Lade- und Endladeleistung (UBat x 13 A max. Eingangsstrom des WR)" für HVM 11.0 und 13.8 an PLENTICORE plus. Leistung = 13 A × Nennspannung des Turms (204,8 V bzw. 256,0 V, aus BYD-Modulspannung 51,2 V).',
      dc_grenzen: {
        'g2-3.0': { '11.0': 2.66 },
        'g2-4.2': { '11.0': 2.66 },
        'g2-5.5': { '11.0': 2.66 },
        'g2-7.0': { '11.0': 2.66 },
        'g2-8.5': { '11.0': 2.66 },
        'g2-10.0': { '11.0': 2.66 },
      } },
    /*
     * HVM 13.8 bis 22.1: Die Liste schreibt hier NICHT "PLENTICORE plus",
     * sondern "PLENTICORE plus 4.2-10" und "PLENTICORE plus 4.2-10 G2" — die
     * kleinste Leistungsklasse (3.0) ist in beiden Generationen ausgenommen.
     * Bis 2026-08-16 stand das nur als Prosa in `einschraenkung`, waehrend die
     * Freigabe selbst alle sechs Varianten umfasste. Jetzt traegt es
     * `wr_varianten` und wirkt damit auch im Ergebnis.
     */
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-premium-hvm', groessen: ['13.8', '16.6', '19.3', '22.1'], quelle: 'kostal-0826',
      wr_varianten: ['g2-4.2', 'g2-5.5', 'g2-7.0', 'g2-8.5', 'g2-10.0'],
      einschraenkung: 'Liste nennt für HVM 13.8–22.1 ausdrücklich „PLENTICORE plus 4.2-10 G2" — die Klasse 3.0 führt sie nicht',
      dc_grenzen_hinweis: 'Fußnote 1 der KOSTAL-Liste: „Einschränkung der Lade- und Endladeleistung (UBat x 13 A max. Eingangsstrom des WR)" für HVM 13.8 an PLENTICORE plus. Leistung = 13 A × Nennspannung des Turms (256,0 V, aus BYD-Modulspannung 51,2 V).',
      dc_grenzen: {
        'g2-4.2': { '13.8': 3.33 },
        'g2-5.5': { '13.8': 3.33 },
        'g2-7.0': { '13.8': 3.33 },
        'g2-8.5': { '13.8': 3.33 },
        'g2-10.0': { '13.8': 3.33 },
      } },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'kostal-0826' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-hvm-plus', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'kostal-0826' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-hvb', groessen: ['8.9', '11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'kostal-0826', einschraenkung: 'KOSTAL-Liste bezeichnet die HVB-Größen als 8.9/11.9/14.9/17.8/20.8/23.8/26.7/29.7. Gleiche Turmgrößen (3–10 Module), andere Rundung der Modellnamen' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'kostal-helivor', groessen: ['9.6', '12.8', '16.0', '19.2', '22.4', '25.6'], quelle: 'kostal-0826', einschraenkung: 'HELIVOR 6.4 und 28.8 nur für PLENTICORE G3 / MP G3 / BI 25 G3' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'axitec-sv2', groessen: ['6.7', '10.1', '13.5', '16.9'], quelle: 'kostal-0826' },

    /* ---- PLENTICORE plus (G1) — dieselbe Liste, erste Generation ----
     * Nachgetragen 2026-08-16, zusammen mit der Baureihe selbst. Jede Zeile
     * unten steht so in der Liste 07/2026 (und stand schon in 04/2026): Die
     * Geraetezelle nennt "PLENTICORE plus" ohne Zusatz neben "PLENTICORE plus
     * G2". Nicht dabei ist die erste Generation bei KOSTAL HELIVOR, Dyness
     * Stack100, VARTA.wall und ZYC SIMPO HV — dort fuehrt die Liste nur G2 und
     * neuer.
     */
    { wr: 'kostal-plenticore-plus-g1', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus (sowie plus G2, BI 5.5/13, BI xx/26 und BI xx/26 G2)' },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'byd-premium-hvm', groessen: ['11.0'], quelle: 'kostal-0826',
      dc_grenzen_hinweis: 'Fußnote 1 der KOSTAL-Liste: „Einschränkung der Lade- und Endladeleistung (UBat x 13 A max. Eingangsstrom des WR)" für HVM 11.0 an PLENTICORE plus. Leistung = 13 A × Nennspannung des Turms (204,8 V, aus BYD-Modulspannung 51,2 V). Die 13 A stehen auch im Gerätedatenblatt.',
      dc_grenzen: {
        'g1-3.0': { '11.0': 2.66 },
        'g1-4.2': { '11.0': 2.66 },
        'g1-5.5': { '11.0': 2.66 },
        'g1-7.0': { '11.0': 2.66 },
        'g1-8.5': { '11.0': 2.66 },
        'g1-10.0': { '11.0': 2.66 },
      } },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'byd-premium-hvm', groessen: ['13.8', '16.6', '19.3', '22.1'], quelle: 'kostal-0826',
      wr_varianten: ['g1-4.2', 'g1-5.5', 'g1-7.0', 'g1-8.5', 'g1-10.0'],
      einschraenkung: 'Liste nennt für HVM 13.8–22.1 ausdrücklich „PLENTICORE plus 4.2-10" — die Klasse 3.0 führt sie nicht',
      dc_grenzen_hinweis: 'Fußnote 1 der KOSTAL-Liste: „Einschränkung der Lade- und Endladeleistung (UBat x 13 A max. Eingangsstrom des WR)" für HVM 13.8 an PLENTICORE plus. Leistung = 13 A × Nennspannung des Turms (256,0 V, aus BYD-Modulspannung 51,2 V). Die 13 A stehen auch im Gerätedatenblatt.',
      dc_grenzen: {
        'g1-4.2': { '13.8': 3.33 },
        'g1-5.5': { '13.8': 3.33 },
        'g1-7.0': { '13.8': 3.33 },
        'g1-8.5': { '13.8': 3.33 },
        'g1-10.0': { '13.8': 3.33 },
      } },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus (sowie plus G2 und BI xx/26 G2)' },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'byd-hvm-plus', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus (sowie plus G2 und BI xx/26 G2)' },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'byd-hvb', groessen: ['8.9', '11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus (sowie plus G2 und BI xx/26 G2). Sie bezeichnet die HVB-Größen als 8.9/11.9/14.9/17.8/20.8/23.8/26.7/29.7 — gleiche Turmgrößen (3–10 Module), andere Rundung der Modellnamen' },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'axitec-sv2', groessen: ['6.7', '10.1', '13.5', '16.9'], quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus (sowie plus G2, BI xx/26, BI xx/26 G2, G3 und MP G3)' },

    /* ---- PLENTICORE BI 25 G3 — neu in der Fassung 07/2026 ----
     * Fussnote 12 der Liste haengt an jeder dieser Zeilen und ist keine
     * Nebensache: An diesem Geraet darf nur EINE Batterie dieses Typs haengen,
     * Parallelschaltung ist nicht freigegeben. Nicht gefuehrt wird er bei
     * AXITEC AXIstorage Li SVx, LG RESU FLEX und VARTA.wall.
     */
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: Am PLENTICORE BI 25 G3 darf nur eine Batterie dieses Typs angeschlossen werden, Parallelschaltung mehrerer Batterien ist nicht freigegeben. BYD-Batterie kompatibel ab Firmware BMU 1.13 / BMS 3.19' },
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'byd-premium-hvm', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: nur eine Batterie dieses Typs, keine Parallelschaltung. BYD-Batterie kompatibel ab Firmware BMU 1.13 / BMS 3.19' },
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: nur eine Batterie dieses Typs, keine Parallelschaltung' },
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'byd-hvm-plus', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: nur eine Batterie dieses Typs, keine Parallelschaltung' },
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'byd-hvb', groessen: ['8.9', '11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: nur eine Batterie dieses Typs, keine Parallelschaltung. KOSTAL-Liste bezeichnet die HVB-Größen als 8.9/11.9/14.9/17.8/20.8/23.8/26.7/29.7 — gleiche Turmgrößen (3–10 Module), andere Rundung' },
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'kostal-helivor', groessen: ['6.4', '9.6', '12.8', '16.0', '19.2', '22.4', '25.6', '28.8'], quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: nur eine Batterie dieses Typs, keine Parallelschaltung. Parallelbetrieb mehrerer Türme laut Liste ohnehin nur mit ZYC Combiner Box' },

    // ---------- BayWa r.e. 02/2026 (Distributor — Bestätigung) ----------
    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'baywa-0226', wr_varianten: ['symo-3.0', 'symo-4.0', 'symo-5.0'] },
    { wr: 'fronius-symo-gen24-plus', speicher: 'byd-premium-hvm', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'baywa-0226', wr_varianten: ['symo-3.0', 'symo-4.0', 'symo-5.0'] },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7'], quelle: 'baywa-0226' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-premium-hvm', groessen: ['11.0', '13.8', '16.6', '19.3'], quelle: 'baywa-0226' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7'], quelle: 'baywa-0226' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3'], quelle: 'baywa-0226' },
    { wr: 'fronius-verto-plus', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'baywa-0226' },
    { wr: 'fronius-verto-plus', speicher: 'byd-premium-hvm', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'baywa-0226' },
    { wr: 'fronius-verto-plus', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'baywa-0226' },
    { wr: 'fronius-verto-plus', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'baywa-0226' },
    { wr: 'fronius-verto-plus', speicher: 'byd-hvb', groessen: ['11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'baywa-0226' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'fronius-reserva', groessen: ['6.3', '9.5', '12.6', '15.8'], quelle: 'baywa-0226' },
    { wr: 'fronius-symo-gen24-plus', speicher: 'fronius-reserva-pro', groessen: ['12.0', '16.0', '20.0', '24.0', '28.0', '32.0'], quelle: 'baywa-0226' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'fronius-reserva', groessen: ['6.3', '9.5'], quelle: 'baywa-0226' },
    { wr: 'fronius-primo-gen24-plus', speicher: 'fronius-reserva-pro', groessen: ['12.0', '16.0', '20.0'], quelle: 'baywa-0226' },
    { wr: 'fronius-verto-plus', speicher: 'fronius-reserva', groessen: ['6.3', '9.5', '12.6', '15.8'], quelle: 'baywa-0226' },
    { wr: 'fronius-verto-plus', speicher: 'fronius-reserva-pro', groessen: ['12.0', '16.0', '20.0', '24.0', '28.0', '32.0'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-premium-hvm', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-hvm-plus', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-g3', speicher: 'byd-hvb', groessen: ['8.9', '11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-g3', speicher: 'pylontech-force-h3', groessen: ['9.69', '14.73', '19.48', '24.32'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-g3', speicher: 'kostal-helivor', groessen: ['6.4', '9.6', '12.8', '16.0', '19.2', '22.4', '25.6', '28.8'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-premium-hvm', groessen: ['16.6', '19.3', '22.1'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-hvm-plus', groessen: ['8.3', '11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'byd-hvb', groessen: ['8.9', '11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'], quelle: 'baywa-0226' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'pylontech-force-h3', groessen: ['9.69', '14.73', '19.48', '24.32'], quelle: 'baywa-0226' },
    { wr: 'goodwe-et', speicher: 'byd-premium-hvs', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'baywa-0226' },
    { wr: 'goodwe-et', speicher: 'byd-premium-hvm', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'baywa-0226' },
    { wr: 'goodwe-et', speicher: 'byd-hvs-plus', groessen: ['5.1', '7.7', '10.2', '12.8'], quelle: 'baywa-0226' },
    { wr: 'goodwe-et', speicher: 'byd-hvm-plus', groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'], quelle: 'baywa-0226' },
    { wr: 'goodwe-et', speicher: 'pylontech-force-h3', groessen: ['9.69', '14.73', '19.48', '24.32', '29.17'], quelle: 'baywa-0226' },

    // ---------- Sungrow-Kompatibilitätsliste V4.2 (Hersteller) ----------
    /*
     * Die Kompaliste begrenzt genau eine Paarung: „SBR064 current limited to max 20A"
     * an SH5.0/10RT. Der Speicher selbst darf 30 A (SBR-Datenblatt) — am SH-RT sind es
     * für den kleinsten Turm nur 20 A. Stand bisher als Prosa in `einschraenkung` und
     * `leistung_herleitung`, floss aber nicht in die Rechnung: 20 A × 128 V = 2,56 kW
     * statt der 3,84 kW, die der Berater aus den Einzelwerten errechnete.
     */
    { wr: 'sungrow-sh-rt', speicher: 'sungrow-sbr', groessen: ['SBR064', 'SBR096', 'SBR128', 'SBR160', 'SBR192', 'SBR224', 'SBR256'], quelle: 'sungrow-a05428-v43', einschraenkung: 'max. 1 Batterieturm; SBR064 strombegrenzt auf 20 A',
      dc_grenzen_hinweis: 'Sungrow-Kompatibilitätsliste A05428 V4.3, Abschnitt „Inverter Compatibility": „SBR064 current limited to max 20A, max. 1 battery tower". Leistung = 20 A × Nennspannung 128,0 V (2 Module × 64 V laut SBR-Datenblatt).',
      dc_grenzen: {
        'sh-5.0rt': { SBR064: 2.56 },
        'sh-6.0rt': { SBR064: 2.56 },
        'sh-8.0rt': { SBR064: 2.56 },
        'sh-10rt': { SBR064: 2.56 },
      } },
    // ---------- Neue Hersteller (Datenblätter 2026-07-05) ----------
    {
      wr: "alphaess-smile-g3-s5",
      speicher: "alphaess-smile-g3-bat-10.1p",
      groessen: ["10.1P"],
      quelle: "alphaess-bat-10.1p-statement"
    },
    {
      wr: "alphaess-smile-g3-s5",
      speicher: "alphaess-smile-g3-bat-3.8s",
      groessen: ["3.6", "7.3", "10.9", "14.6"],
      quelle: "alphaess-smile-g3-s5",
      einschraenkung: "Modulanzahl 1–4 in Serie (Datenblatt SMILE-G3-S5)."
    },
    {
      wr: "alphaess-smile-g3-s5",
      speicher: "alphaess-smile-g3-bat-9.3s",
      groessen: ["9.3", "18.6", "27.9", "37.2"],
      quelle: "alphaess-bat-9.3s",
      einschraenkung: "Module 1~4 in Serie (Modulkompatibilität SMILE-G3-BAT-9.3S)."
    },
    {
      wr: "alphaess-smile-g3-t4-t10",
      speicher: "alphaess-smile-g3-bat-3.8s",
      groessen: ["3.6", "7.3", "10.9", "14.6", "18.2", "21.9"],
      quelle: "alphaess-smile-g3-t4-t10",
      einschraenkung: "Batterie 2–6 Module in Serie (Datenblatt T4-T10)."
    },
    {
      wr: "alphaess-smile-g3-t4-t10",
      speicher: "alphaess-smile-g3-bat-8.2p",
      groessen: ["7.8"],
      quelle: "alphaess-smile-g3-t4-t10",
      einschraenkung: "SMILE-G3-BAT-8.2P-C, 1–6 in Parallel (Datenblatt T4-T10)."
    },
    {
      wr: "alphaess-smile-g3-t4-t10",
      speicher: "alphaess-smile-g3-bat-9.3s",
      groessen: ["9.3", "18.6", "27.9", "37.2", "46.5", "55.8", "77.4", "93.0", "111.6"],
      quelle: "alphaess-bat-9.3s",
      einschraenkung: "Module 1~6, 8, 10, 12 in Serie (Modulkompatibilität SMILE-G3-BAT-9.3S; gilt für G3-T4/5/6/8/10)."
    },
    {
      wr: "alphaess-smile-g3-t12-t20",
      speicher: "alphaess-smile-g3-bat-3.8s",
      groessen: ["3.6", "7.3", "10.9", "14.6", "18.2", "21.9"],
      quelle: "alphaess-smile-g3-t12-t20",
      einschraenkung: "Batterie 2–6 Module in Serie (Datenblatt T12/T15/T20)."
    },
    {
      wr: "alphaess-smile-g3-t12-t20",
      speicher: "alphaess-smile-g3-bat-8.2p",
      groessen: ["7.8"],
      quelle: "alphaess-smile-g3-t12-t20",
      einschraenkung: "1–6 in Parallel; eine Batterie max. 8,2 kW, ab zwei Batterien max. 15 kW (Datenblatt T12/T15/T20)."
    },
    {
      wr: "alphaess-smile-g3-t12-t20",
      speicher: "alphaess-smile-g3-bat-9.3s",
      groessen: ["18.6", "27.9", "37.2", "46.5", "55.8", "77.4", "93.0", "111.6"],
      quelle: "alphaess-bat-9.3s",
      einschraenkung: "Module 2~6, 8, 10, 12 in Serie (Modulkompatibilität SMILE-G3-BAT-9.3S; gilt für G3-T12/15/20)."
    },
    {
      wr: "alphaess-smile-g3-t12-t20",
      speicher: "alphaess-smile-g3-bat-3.8s",
      groessen: ["3.6", "7.3", "10.9", "14.6", "18.2", "21.9"],
      wr_varianten: ["g3-t15", "g3-t20"],
      quelle: "alphaess-smile-g3-t15-t20",
      einschraenkung: "Batterie 2–12 Module in Serie (Datenblatt SMILE-G3-T15/T20)."
    },
    {
      wr: "alphaess-smile-hi10",
      speicher: "alphaess-smile-hi-bat-7.8",
      groessen: ["7.8"],
      quelle: "alphaess-smile-hi10",
      einschraenkung: "max. 6 parallel; eine Batterie max. 7,8 kW (Datenblatt SMILE-Hi10)."
    },
    {
      wr: "alphaess-smile-hi5",
      speicher: "alphaess-smile-hi5-bat-4.8",
      groessen: ["4.8"],
      quelle: "alphaess-smile-hi5",
      einschraenkung: "max. 6 parallel (Datenblatt SMILE-Hi5)."
    },
    {
      wr: "alphaess-smile-hi5",
      speicher: "alphaess-smile-hi-bat-7.8",
      groessen: ["7.8"],
      quelle: "alphaess-smile-hi5",
      einschraenkung: "max. 6 parallel (Datenblatt SMILE-Hi5)."
    },
    {
      wr: "huawei-sun2000-mb0",
      speicher: "huawei-luna2000-s1",
      groessen: ["7", "14", "21"],
      quelle: "huawei-sun2000-mb0",
      einschraenkung: "Batterie-Betriebsspannung 600–980 V; max. 3 parallele Batterie-Einheiten mit Smart String ESS. Umgekehrt nennt das LUNA-Datenblatt SUN2000-12/15/17/20/25K-MB0 als kompatible WR; nur diese Reihe unterstützt 4 Speicher parallel."
    },
    {
      wr: "sma-sunny-tripower-smart-energy",
      speicher: "byd-premium-hvs",
      groessen: ["5.1", "7.7", "10.2", "12.8"],
      quelle: "sma-stpse-batteries",
      einschraenkung: "Batterie-FW BMU=3.16 / BMS=3.24, WR-FW ≥1.00.00.R. Nutzbare Leistung (nur STP10.0-3SE-40 vermessen): HVS 5.1 2,4–6 kW / 7.7 6–9 kW / 10.2 8–10,6 kW / 12.8 10–10,6 kW. Parallelbetrieb bis 3 Einheiten (WR-FW ≥3.04.16.R)."
    },
    {
      wr: "sma-sunny-tripower-smart-energy",
      speicher: "byd-premium-hvm",
      groessen: ["11.0", "13.8", "16.6", "19.3", "22.1"],
      quelle: "sma-stpse-batteries",
      einschraenkung: "HVM 8.3 laut TI NICHT kompatibel (ausgenommen). Batterie-FW BMU=3.16 / BMS=3.24, WR-FW ≥1.00.00.R. Nutzbare Leistung (nur STP10.0-3SE-40): HVM 11.0 1,9–7,1 kW / 13.8 5,9–8,9 kW / 16.6 7,2–10,6 kW / 19.3 8,4–10,6 kW / 22.1 9,6–10,6 kW. Parallelbetrieb bis 3.",
      ausgeschlossen: ['8.3'],
      ausschluss_wortlaut: 'HVM 8.3 laut TI NICHT kompatibel (ausgenommen)'
    },
    {
      wr: "sma-sunny-tripower-smart-energy",
      speicher: "lg-flex",
      groessen: ["8.6", "12.9", "17.2"],
      quelle: "sma-stpse-batteries",
      einschraenkung: "LG RESU FLEX, Batterie-FW 1.0.0.R, WR-FW ≥3.04.16.R. Nutzbare Leistung (nur STP10.0-3SE-40): 8.6 4,3 kW / 12.9 6,5 kW / 17.2 8,5 kW. Modellname im TI \"LG RESU FLEX 8.6/12.9/17.2\" (entspricht LG-FLEX-Größen)."
    },
    {
      wr: "sma-sunny-tripower-hybrid-x",
      speicher: "byd-hvs-plus",
      groessen: ["5.1", "7.7", "10.2", "12.8"],
      quelle: "sma-stp-hybrid-x-klein",
      einschraenkung: "Sammelnennung \"BYD Battery-Box HVB/HVS+/HVM+\" im Datenblatt (kleine & große Serie); keine einzelnen Größen/Leistungen je Speicher beziffert. Batterie-Spannungsbereich WR: 80–600 V (5–15) bzw. 120–800 V (20–30)."
    },
    {
      wr: "sma-sunny-tripower-hybrid-x",
      speicher: "byd-hvm-plus",
      groessen: ["8.3", "11.0", "13.8", "16.6", "19.3", "22.1"],
      quelle: "sma-stp-hybrid-x-klein",
      einschraenkung: "Sammelnennung \"BYD Battery-Box HVB/HVS+/HVM+\" im Datenblatt; keine einzelnen Größen/Leistungen beziffert."
    },
    {
      wr: "sma-sunny-tripower-hybrid-x",
      speicher: "byd-hvb",
      groessen: ["8.9", "11.8", "14.8", "17.8", "20.7", "23.7", "26.7", "29.6"],
      quelle: "sma-stp-hybrid-x-klein",
      einschraenkung: "Sammelnennung \"BYD Battery-Box HVB/HVS+/HVM+\" im Datenblatt; keine einzelnen Größen/Leistungen beziffert."
    },
    {
      wr: "kostal-plenticore-g3",
      speicher: "dyness-tower-pro",
      groessen: ["TP7", "TP11", "TP15", "TP19", "TP23"],
      quelle: "dyness-tower-pro-compat",
      einschraenkung: "Liste nennt PLENTICORE G3 / PLENTICORE MP G3."
    },
    {
      wr: "kostal-plenticore-plus-g2",
      speicher: "dyness-tower-pro",
      groessen: ["TP7", "TP11", "TP15", "TP19", "TP23"],
      quelle: "dyness-tower-pro-compat",
      einschraenkung: "Liste nennt PLENTICORE plus G2 (sowie PLENTICORE BI 5.5/10-26 G2)."
    },
    {
      wr: "goodwe-et",
      speicher: "dyness-tower-pro",
      groessen: ["TP7", "TP11", "TP15", "TP19", "TP23"],
      quelle: "dyness-tower-pro-compat",
      einschraenkung: "Liste führt diese Baureihe als \"GW6-15K-ET-20\", freigegeben für alle fünf Turmgrößen. Die daneben geführte Zeile \"GW5K-10K-ET (inkl. ET PLUS+, ET PLUS+ 16A)\" ist eine andere Baureihe und dort nur für TP-11/TP-15/TP-19 angehakt."
    },
    /*
     * Deye stand in keiner der drei Dyness-Freigaben, obwohl alle drei Listen die
     * Baureihe führen. Ursache war die Reihenfolge beim Einlesen: Die Dyness-Listen
     * wurden für die damals vorhandenen Marken transkribiert (KOSTAL, GoodWe); Deye
     * kam in derselben Sitzung neu in den Katalog und wurde nicht gegen die bereits
     * eingelesenen Speicherlisten zurückgeprüft. Nachgetragen 2026-08-09 nach
     * visueller Kontrolle aller drei gerenderten Tabellen.
     */
    {
      wr: "deye-sun-sg-hybrid",
      speicher: "dyness-tower-pro",
      groessen: ["TP7", "TP11", "TP15", "TP19", "TP23"],
      quelle: "dyness-tower-pro-compat",
      wr_varianten: DEYE_SG01HP3_DYNESS,
      einschraenkung: DEYE_DYNESS_AUFLAGE
    },
    {
      wr: "kostal-plenticore-g3",
      speicher: "dyness-tower-s2",
      groessen: ["T7", "T10", "T14", "T17", "T21"],
      quelle: "dyness-tower-s2-compat",
      einschraenkung: "Liste nennt PLENTICORE G3 / PLENTICORE MP G3."
    },
    {
      wr: "kostal-plenticore-plus-g2",
      speicher: "dyness-tower-s2",
      groessen: ["T7", "T10", "T14", "T17", "T21"],
      quelle: "dyness-tower-s2-compat",
      einschraenkung: "Liste nennt PLENTICORE plus G2 (sowie PLENTICORE BI 5.5/10-26 G2)."
    },
    {
      wr: "goodwe-et",
      speicher: "dyness-tower-s2",
      groessen: ["T7", "T10", "T14", "T17", "T21"],
      quelle: "dyness-tower-s2-compat",
      einschraenkung: "Liste führt diese Baureihe als \"GW6-15K-ET-20\", freigegeben für alle fünf Turmgrößen. Die daneben geführte Zeile \"GW5K-10K-ET (inkl. ET PLUS+, ET PLUS+ 16A)\" ist eine andere Baureihe und dort nur für T-10/T-14/T-17 angehakt."
    },
    {
      wr: "deye-sun-sg-hybrid",
      speicher: "dyness-tower-s2",
      groessen: ["T7", "T10", "T14", "T17", "T21"],
      quelle: "dyness-tower-s2-compat",
      wr_varianten: DEYE_SG01HP3_DYNESS,
      einschraenkung: DEYE_DYNESS_AUFLAGE
    },
    {
      wr: "goodwe-et",
      speicher: "dyness-tower-s3",
      groessen: ["TS7", "TS10", "TS14", "TS17", "TS21"],
      quelle: "dyness-tower-s3-compat",
      einschraenkung: "Liste führt diese Baureihe als \"GW6-15K-ET-20\", freigegeben für alle fünf Turmgrößen. Die daneben geführte Zeile \"GW5K-10K-ET (inkl. ET PLUS+, ET PLUS+ 16A)\" ist eine andere Baureihe und dort nur für TS-10/TS-14/TS-17 angehakt."
    },
    {
      wr: "deye-sun-sg-hybrid",
      speicher: "dyness-tower-s3",
      groessen: ["TS7", "TS10", "TS14", "TS17", "TS21"],
      quelle: "dyness-tower-s3-compat",
      wr_varianten: DEYE_SG01HP3_DYNESS,
      einschraenkung: DEYE_DYNESS_AUFLAGE
    },
    {
      wr: "deye-sun-sg-hybrid",
      speicher: "byd-premium-hvs",
      groessen: ["5.1", "7.7", "10.2", "12.8"],
      quelle: "deye-approved-036",
      einschraenkung: "Liste nennt generisch BYD \"HVS Series\" (nicht premium/plus getrennt) über CAN. Modulanzahl-Bereich laut Liste (OCR); primär freigegeben für SUN-5/6/8/10/12/15/20(/25)K-SG01HP3-EU-AM2. Vor Bestellung Deye-Setup-Nr. bestätigen."
    },
    {
      wr: "deye-sun-sg-hybrid",
      speicher: "byd-hvs-plus",
      groessen: ["5.1", "7.7", "10.2", "12.8"],
      quelle: "deye-approved-036",
      einschraenkung: "Liste nennt generisch BYD \"HVS Series\" (nicht premium/plus getrennt) über CAN; primär SUN-...-SG01HP3-EU-AM2. Vor Bestellung Deye-Setup-Nr. bestätigen."
    },
    {
      wr: "deye-sun-sg-hybrid",
      speicher: "byd-premium-hvm",
      groessen: ["8.3", "11.0", "13.8", "16.6", "19.3", "22.1"],
      quelle: "deye-approved-036",
      einschraenkung: "Liste nennt generisch BYD \"HVM Series\" (nicht premium/plus getrennt) über CAN; SUN-SG-Serie (u. a. SG01HP3-EU-AM2/BM3/BM4). Vor Bestellung Deye-Setup-Nr. bestätigen."
    },
    {
      wr: "deye-sun-sg-hybrid",
      speicher: "byd-hvm-plus",
      groessen: ["8.3", "11.0", "13.8", "16.6", "19.3", "22.1"],
      quelle: "deye-approved-036",
      einschraenkung: "Liste nennt generisch BYD \"HVM Series\" (nicht premium/plus getrennt) über CAN; SUN-SG-Serie. Vor Bestellung Deye-Setup-Nr. bestätigen."
    },

    /* ---- Sungrow SH-T (SH15/20/25T) — Kompatibilitätsliste A05428 V4.3, S. 10 + 13 ---- */
    { wr: 'sungrow-sh-t', speicher: 'sungrow-sbh',
      groessen: ['SBH100', 'SBH150', 'SBH200', 'SBH250', 'SBH300', 'SBH350', 'SBH400'],
      quelle: 'sungrow-a05428-v43',
      einschraenkung: '2–8 Module je Turm; Sungrow empfiehlt mind. 3 Module; SBH100 batterieseitig '
        + 'leistungsbegrenzt; max. 2 Türme parallel (Y-Connector)' },
    { wr: 'sungrow-sh-t', speicher: 'sungrow-sbr',
      groessen: ['SBR096', 'SBR128', 'SBR160', 'SBR192', 'SBR224', 'SBR256'],
      quelle: 'sungrow-a05428-v43',
      einschraenkung: 'SBR064 ist für die SH-T-Serie nicht gelistet; 3–8 Module, Sungrow empfiehlt '
        + 'mind. 4 Module; SBR096 batterieseitig leistungsbegrenzt; max. 2 Türme per Y-Connector '
        + '(Parallelbetrieb laut Liste nicht für die DACH-Region)' },

    /*
     * NEU in V4.3 (01.06.2026): SBH an der SH-RT-Serie. Die V4.2 sagte hier
     * noch ausdrücklich NEIN — der in README dokumentierte Widerspruch zum
     * australischen Cross-Chart ist damit vom Hersteller aufgelöst worden.
     */
    { wr: 'sungrow-sh-rt', speicher: 'sungrow-sbh',
      groessen: ['SBH150', 'SBH200', 'SBH250', 'SBH300', 'SBH350', 'SBH400'],
      quelle: 'sungrow-a05428-v43',
      einschraenkung: 'SBH100 nicht gelistet; 3–8 Module, max. 1 Turm; gilt für die '
        + 'WR-Versionen V112 und -20 (die Familie der Datenbasis ist die -20-Serie)' },
    /*
     * Drittanbieter-Seite der V4.3 (S. 14): BYD Premium an der SH-RT-Serie.
     * Für die SH-T-Serie nennt dieselbe Seite ausdrücklich KEINE Drittanbieter.
     */
    { wr: 'sungrow-sh-rt', speicher: 'byd-premium-hvs',
      groessen: ['5.1', '7.7', '10.2', '12.8'],
      quelle: 'sungrow-a05428-v43',
      einschraenkung: 'BMS-Version ab 3.16' },
    { wr: 'sungrow-sh-rt', speicher: 'byd-premium-hvm',
      groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'],
      quelle: 'sungrow-a05428-v43',
      einschraenkung: 'Liste nennt HVM 11.0–22.1 (8.3 nicht enthalten); BMS-Version ab 3.7' },

    /*
     * SH5-12T: Die Kompaliste fasst die ganze T-Reihe als „SH5.0-25T (all
     * versions)" — dieselben Aussagen wie für 15–25 kW gelten auch hier.
     */
    { wr: 'sungrow-sh5-12t', speicher: 'sungrow-sbh',
      groessen: ['SBH100', 'SBH150', 'SBH200', 'SBH250', 'SBH300', 'SBH350', 'SBH400'],
      quelle: 'sungrow-a05428-v43',
      einschraenkung: '2–8 Module je Turm; Sungrow empfiehlt mind. 3 Module; SBH100 batterieseitig '
        + 'leistungsbegrenzt; max. 2 Türme parallel (Y-Connector)' },
    { wr: 'sungrow-sh5-12t', speicher: 'sungrow-sbr',
      groessen: ['SBR096', 'SBR128', 'SBR160', 'SBR192', 'SBR224', 'SBR256'],
      quelle: 'sungrow-a05428-v43',
      einschraenkung: 'SBR064 ist für die SH-T-Serie nicht gelistet; 3–8 Module, Sungrow empfiehlt '
        + 'mind. 4 Module; SBR096 batterieseitig leistungsbegrenzt; max. 2 Türme per Y-Connector '
        + '(Parallelbetrieb laut Liste nicht für die DACH-Region)' },
    /*
     * Zweitbeleg Cross-Chart V2.2 für die kleine T-Reihe: Das Chart führt dort
     * nur SH5T und SH10T — deshalb wr_varianten statt Familien-Freigabe.
     */
    { wr: 'sungrow-sh5-12t', speicher: 'sungrow-sbh',
      groessen: ['SBH150', 'SBH200', 'SBH250', 'SBH300', 'SBH350', 'SBH400'],
      quelle: 'sungrow-cross-v24',
      wr_varianten: ['sh5t', 'sh10t'],
      einschraenkung: 'Chart nennt aus der kleinen T-Reihe nur SH5T und SH10T; führt SBH100 nicht '
        + 'mehr; „Max"-Werte der Liste = Batterie-Entladeleistung, die volle Backup-Leistung des WR '
        + 'braucht zusätzlich PV-Leistung' },
    { wr: 'sungrow-sh5-12t', speicher: 'sungrow-sbr',
      groessen: ['SBR096', 'SBR128', 'SBR160', 'SBR192', 'SBR224', 'SBR256'],
      quelle: 'sungrow-cross-v24',
      wr_varianten: ['sh5t', 'sh10t'],
      einschraenkung: 'Chart nennt aus der kleinen T-Reihe nur SH5T und SH10T; SBR064 nicht '
        + 'freigegeben (erreicht die Startspannung des WR nicht); „Max"-Werte der Liste = '
        + 'Batterie-Entladeleistung, die volle Backup-Leistung des WR braucht zusätzlich PV-Leistung',
      ausgeschlossen: ['SBR064'],
      ausschluss_wortlaut: 'SBR064 nicht freigegeben (erreicht die Startspannung des WR nicht)'
    },

    /*
     * Zweitbeleg aus dem Cross-Reference-Chart V2.2 (Sungrow Australia, GD_202506).
     * Nur die Aussagen, in denen Chart und Kompaliste A05428 V4.2 übereinstimmen —
     * bei den Widersprüchen (SH-RT↔SBH, SH-RT↔SBR064) bleibt die offizielle,
     * neuere Kompaliste maßgeblich; dokumentiert in README „Bekannte Datenlücken".
     * Die „Max"-Angaben des Charts sind reine Batterie-Entladewerte und decken
     * sich mit unserer min()-Rechnung — sie erzeugen keine neuen Datenfelder.
     */
    { wr: 'sungrow-sh-t', speicher: 'sungrow-sbr',
      groessen: ['SBR096', 'SBR128', 'SBR160', 'SBR192', 'SBR224', 'SBR256'],
      quelle: 'sungrow-cross-v24',
      einschraenkung: 'SBR064 nicht freigegeben (erreicht die Startspannung des WR nicht); '
        + '„Max"-Werte der Liste = Batterie-Entladeleistung, die volle Backup-Leistung des WR '
        + 'braucht zusätzlich PV-Leistung',
      ausgeschlossen: ['SBR064'],
      ausschluss_wortlaut: 'SBR064 nicht freigegeben (erreicht die Startspannung des WR nicht)'
    },
    { wr: 'sungrow-sh-t', speicher: 'sungrow-sbh',
      groessen: ['SBH150', 'SBH200', 'SBH250', 'SBH300', 'SBH350', 'SBH400'],
      quelle: 'sungrow-cross-v24',
      einschraenkung: 'Chart führt SBH100 nicht mehr (Spalten ab SBH150); „Max"-Werte der Liste '
        + '= Batterie-Entladeleistung, die volle Backup-Leistung des WR braucht zusätzlich '
        + 'PV-Leistung' },

    /* ---- Growatt MID XH ↔ APX — doppelt belegt: APX-Datenblatt und MID-Datenblatt ---- */
    { wr: 'growatt-mid-xh', speicher: 'growatt-apx',
      groessen: ['APX 5.0P', 'APX 10.0P', 'APX 15.0P', 'APX 20.0P', 'APX 25.0P', 'APX 30.0P'],
      quelle: 'growatt-apx-db',
      einschraenkung: 'nur mit Leistungsmodul APX 98034-P2 („Compatible inverters: MID 11-30KTL3-XH"); '
        + 'für Europa nur EU-Modell der APX-Batterie' },
    { wr: 'growatt-mid-xh', speicher: 'growatt-apx',
      groessen: ['APX 5.0P', 'APX 10.0P', 'APX 15.0P', 'APX 20.0P', 'APX 25.0P', 'APX 30.0P'],
      quelle: 'growatt-mid-xh-db',
      einschraenkung: 'MID-Datenblatt: „Kompatible Batterien: APX HV Battery System (5 kWh–60 kWh)"; '
        + '30 kW Batterieleistung nur mit zwei Türmen an beiden Anschlüssen' },

    /*
     * SMA „Approved Batteries" (Status 2026/02) für die Sunny Tripower Smart
     * Energy: bestätigt die drei Kombinationen der älteren TI (Zweitbeleg) und
     * gibt HVM+/HVS+/HVB neu frei. Größenbereiche exakt wie gelistet — HVM/HVM+
     * ohne 8.3, HVB ohne 8.9. AXIstorage „Li SH" ist nicht die SV2-Baureihe
     * der Datenbasis und wird bewusst nicht übernommen.
     */
    { wr: 'sma-sunny-tripower-smart-energy', speicher: 'byd-premium-hvm',
      groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'],
      quelle: 'sma-approved-2026-02',
      einschraenkung: 'Liste nennt HVM 11.0–22.1 (8.3 nicht enthalten); Batterie-Firmware BMU 3.16 / '
        + 'BMS 3.24, WR-Firmware ab 1.00.00.R' },
    { wr: 'sma-sunny-tripower-smart-energy', speicher: 'byd-premium-hvs',
      groessen: ['5.1', '7.7', '10.2', '12.8'],
      quelle: 'sma-approved-2026-02',
      einschraenkung: 'Batterie-Firmware BMU 3.16 / BMS 3.24, WR-Firmware ab 1.00.00.R' },
    { wr: 'sma-sunny-tripower-smart-energy', speicher: 'byd-hvm-plus',
      groessen: ['11.0', '13.8', '16.6', '19.3', '22.1'],
      quelle: 'sma-approved-2026-02',
      einschraenkung: 'Liste nennt HVM+ 11.0–22.1 (8.3 nicht enthalten); Batterie-Firmware 1.36.0, '
        + 'WR-Firmware ab 4.08.29.R; von SMA nicht für den Ersatzstrombetrieb empfohlen' },
    { wr: 'sma-sunny-tripower-smart-energy', speicher: 'byd-hvs-plus',
      groessen: ['5.1', '7.7', '10.2', '12.8'],
      quelle: 'sma-approved-2026-02',
      einschraenkung: 'Batterie-Firmware 1.36.0, WR-Firmware ab 4.08.29.R; von SMA nicht für den '
        + 'Ersatzstrombetrieb empfohlen' },
    { wr: 'sma-sunny-tripower-smart-energy', speicher: 'byd-hvb',
      groessen: ['11.8', '14.8', '17.8', '20.7', '23.7', '26.7', '29.6'],
      quelle: 'sma-approved-2026-02',
      einschraenkung: 'Liste nennt HVB 11.8–29.6 (8.9 nicht enthalten); Batterie-Firmware 1.36.0, '
        + 'WR-Firmware ab 4.08.29.R' },
    { wr: 'sma-sunny-tripower-smart-energy', speicher: 'lg-flex',
      groessen: ['8.6', '12.9', '17.2'],
      quelle: 'sma-approved-2026-02',
      einschraenkung: 'Batterie-Firmware 1.0.0.R, WR-Firmware ab 3.04.16.R' },

    /*
     * SolaX X3-IES: WR und Batteriemodule sind EIN Produkt — das System-
     * datenblatt selbst ist die Freigabe-Aussage der Kombination.
     */
    { wr: 'solax-x3-ies', speicher: 'solax-x3-ies-batterie',
      groessen: ['5.1', '10.2', '15.3', '20.4', '25.6', '30.7'],
      quelle: 'solax-x3-ies-db-v18',
      einschraenkung: 'Integriertes Komplettsystem (Module TP-HS50E, 2–6 je System); '
        + 'Batterieleistung laut Datenblatt auf die WR-Nennleistung begrenzt' },

    /*
     * Growatt AXE 5.0L ↔ SPF: Die LV48-Liste führt das Batteriemodul
     * „AXE 5.0L - C1" für die SPF-Gruppe (CAN, Inverter Setup L51). Die
     * Freigabe gilt je Batteriemodell — alle Turmgrößen bestehen aus
     * demselben Modul. WIT/SPH/SPE aus derselben Liste sind (noch) keine
     * Familien der Datenbasis.
     */
    { wr: 'growatt-spf', speicher: 'growatt-axe',
      groessen: ['AXE 5.0L', 'AXE 10.0L', 'AXE 15.0L', 'AXE 20.0L', 'AXE 25.0L',
        'AXE 30.0L', 'AXE 35.0L', 'AXE 40.0L', 'AXE 45.0L', 'AXE 50.0L'],
      quelle: 'growatt-compatibility-list-lv48',
      einschraenkung: 'Liste nennt das Batteriemodul AXE 5.0L-C1 (CAN, Inverter Setup L51); '
        + 'für Europa nur EU-Modell der AXE-Batterie; Batteriemodus „Lithium" einstellen' },

    /* ---- Huawei LUNA2000-S1 — Freigaben aus dem LUNA-S1- bzw. MAP0-Datenblatt ---- */
    { wr: 'huawei-sun2000-m1', speicher: 'huawei-luna2000-s1',
      groessen: ['7', '14', '21'],
      quelle: 'huawei-luna2000-s1',
      einschraenkung: 'LUNA-S1-Datenblatt „Compatible inverters": SUN2000-3/4/5/6/8/10KTL-M1' },
    { wr: 'huawei-sun2000-map0', speicher: 'huawei-luna2000-s1',
      groessen: ['7', '14', '21'],
      quelle: 'huawei-sun2000-map0',
      einschraenkung: 'MAP0-Datenblatt „Compatible battery": LUNA2000-7/14/21-S1' },
    { wr: 'huawei-sun2000-map0', speicher: 'huawei-luna2000-s1',
      groessen: ['7', '14', '21'],
      quelle: 'huawei-luna2000-s1',
      einschraenkung: 'LUNA-S1-Datenblatt: MAP0-Kompatibilität laut Fußnote ab 2024 Q3' },

    /* ---- Huawei LUNA2000-S0 — Freigaben aus dem LUNA-S0-, MB0- und MAP0-Datenblatt (2026-09-14) ---- */
    { wr: 'huawei-sun2000-m1', speicher: 'huawei-luna2000-s0',
      groessen: ['5', '10', '15'],
      quelle: 'huawei-luna2000-s0',
      einschraenkung: 'LUNA-S0-Datenblatt „Compatible inverters": SUN2000-3/4/5/6/8/10KTL-M1; Fußnote: Kompatibilität mit Huawei-Techniker abstimmen' },
    { wr: 'huawei-sun2000-mb0', speicher: 'huawei-luna2000-s0',
      groessen: ['5', '10', '15'],
      quelle: 'huawei-luna2000-s0',
      einschraenkung: 'LUNA-S0-Datenblatt „Compatible inverters": SUN2000-12/15/17/20/25K-MB0; Fußnote: Kompatibilität mit Huawei-Techniker abstimmen' },
    { wr: 'huawei-sun2000-mb0', speicher: 'huawei-luna2000-s0',
      groessen: ['5', '10', '15'],
      quelle: 'huawei-sun2000-mb0',
      einschraenkung: 'MB0-Datenblatt „Compatible Smart String ESS": LUNA2000-5/10/15-S0' },
    { wr: 'huawei-sun2000-map0', speicher: 'huawei-luna2000-s0',
      groessen: ['5', '10', '15'],
      quelle: 'huawei-luna2000-s0',
      einschraenkung: 'LUNA-S0-Datenblatt „Compatible inverters": SUN2000-5/6/8/10/12K-MAP0; Fußnote: Kompatibilität mit Huawei-Techniker abstimmen' },
    { wr: 'huawei-sun2000-map0', speicher: 'huawei-luna2000-s0',
      groessen: ['5', '10', '15'],
      quelle: 'huawei-sun2000-map0',
      einschraenkung: 'MAP0-Datenblatt „Compatible battery": LUNA2000-5/10/15-S0' },

    /* ---- Dyness STACK100: alle Zeilen der Liste vom 28.09.2025 ----
     * Die Haekchen liegen wie in allen Dyness-Listen nicht positionstreu in der
     * Textebene. Transkribiert wurde deshalb aus dem gerenderten Raster, an den
     * Spalten- und Zeilenpositionen des PDF abgetastet — und gegengerechnet:
     * 394 Haken im Dokument, 394 verbucht.
     */
    { wr: 'atess-hps', speicher: 'dyness-stack100',
      groessen: ['7S', '8S', '9S', '10S', '11S', '12S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['hps-5000-10000tls'] },
    { wr: 'atess-hps', speicher: 'dyness-stack100',
      groessen: ['6S', '7S', '8S', '9S', '10S', '11S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['hps-30000-50000tl'] },
    { wr: 'atess-hps', speicher: 'dyness-stack100',
      groessen: ['8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['hps-30-150'] },
    { wr: 'deye-sun-sg-hybrid', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['deye-sun-5k-sg01hp3', 'deye-sun-6k-sg01hp3', 'deye-sun-8k-sg01hp3', 'deye-sun-10k-sg01hp3', 'deye-sun-12k-sg01hp3', 'deye-sun-15k-sg01hp3', 'deye-sun-20k-sg01hp3', 'deye-sun-25k-sg01hp3'] },
    { wr: 'deye-sun-sg-hybrid', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['sun-sg01hp3-eu-bm3', 'sun-sg01hp3-eu-bm4'] },
    { wr: 'deye-sun-sg-hybrid', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S', '14S', '15S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['deye-sun-60k-sg02hp3-em6', 'deye-sun-70k-sg02hp3-em6', 'deye-sun-75k-sg02hp3-em6', 'deye-sun-80k-sg02hp3-em6'] },
    { wr: 'dunext-hybrid', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['ni-hv3-6'] },
    { wr: 'dunext-hybrid', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['dn3h-6-10ktl'] },
    { wr: 'goodwe-et-40-50', speicher: 'dyness-stack100',
      groessen: ['5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['gw40k-et-10', 'gw50k-et-10'] },
    { wr: 'goodwe-et', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['gw6000-et-20', 'gw8000-et-20', 'gw10k-et-20', 'gw12k-et-20', 'gw15k-et-20'] },
    { wr: 'goodwe-et-15-30', speicher: 'dyness-stack100',
      groessen: ['5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['gw15k-et', 'gw20k-et', 'gw25k-et', 'gw29-9k-et'] },
    { wr: 'growatt-wit', speicher: 'dyness-stack100',
      groessen: ['14S', '15S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['wit-50-100k'] },
    { wr: 'growatt-wit', speicher: 'dyness-stack100',
      groessen: ['5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S', '14S', '15S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['wit-29-9-50k-xhu'] },
    { wr: 'hoymiles-hv', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['hy3-5k-10k-hv'] },
    { wr: 'hoymiles-hv', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['hyt-5-12-hveug1', 'hat-5-10-hveug1'] },
    { wr: 'ingeteam-sun-storage', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['ingecon-3tl-6tlm'] },
    { wr: 'ingeteam-sun-storage', speicher: 'dyness-stack100',
      groessen: ['4S', '13S', '14S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['ingecon-100tl'] },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S'],
      quelle: 'dyness-stack100-compat' },
    { wr: 'kostal-plenticore-g3', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S', '14S'],
      quelle: 'dyness-stack100-compat' },
    { wr: 'koyoe-ky-est', speicher: 'dyness-stack100',
      groessen: ['5S', '6S', '7S', '8S', '9S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['ky-est-6k-10kh'] },
    { wr: 'koyoe-ky-est', speicher: 'dyness-stack100',
      groessen: ['5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['ky-est-12-20kh'] },
    { wr: 'magarevo-hv', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['r5k-11k4-h1'] },
    { wr: 'magarevo-hv', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['r6k-12k-h3'] },
    { wr: 'magarevo-hv', speicher: 'dyness-stack100',
      groessen: ['10S', '11S', '12S', '13S', '14S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['mega0100ts'] },
    { wr: 'saj-h2', speicher: 'dyness-stack100',
      groessen: ['5S', '6S', '7S', '8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['h2-5k-10k-t2'] },
    { wr: 'saj-h2', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['h2-3k-6k-s2'] },
    { wr: 'senergy-se-khb', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['se-5-10khb-d3'] },
    { wr: 'sermatec-smt', speicher: 'dyness-stack100',
      groessen: ['5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['smt-10k-tl-th'] },
    { wr: 'sineng-sn', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['sn-3-6-0hs'] },
    { wr: 'sineng-sn', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['sn5-15ht'] },
    { wr: 'sinexcel-pw', speicher: 'dyness-stack100',
      groessen: ['6S', '7S', '8S', '9S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['pwg2-50k-100k-cn'] },
    { wr: 'sinexcel-pw', speicher: 'dyness-stack100',
      groessen: ['12S', '13S', '14S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['pws1-150-250k'] },
    { wr: 'solinteg-mh', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['mht-25-50k-100', 'mht-4k-12k-25', 'mht-10k-20k-40'] },
    { wr: 'solinteg-mh', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['mhs-3k-8k-30'] },
    { wr: 'solis-rhi-hves', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['rhi-3p-5-10k-hves-5g'] },
    { wr: 'solis-rhi-hves', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['rhi-1p7-6k-hves-5g'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['s6-eh3p-3-10k-h-pro', 's6-eh3p-5-10k2-h-eu'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['s6-eh1p-3-8-11-4k-h-us'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['s6-eh3p-12-20k-h'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['s6-eh3p-29-9-50k-h'] },
    { wr: 'solplanet-asw-kh', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['asw08-12kh-t1'] },
    { wr: 'solplanet-asw-kh', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['asw08-12kh-t3'] },
    { wr: 'sosen-sse-hh', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['sse-hh8-12k-p3eu'] },
    { wr: 'sosen-sse-hh', speicher: 'dyness-stack100',
      groessen: ['4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['sse-hh30-60k-p3'] },
    { wr: 'sunways-sth', speicher: 'dyness-stack100',
      groessen: ['5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['sth-4-12-ktl-ht-p-cn'] },
    { wr: 'sunways-sth', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['sth-3-8k-tl-hs'] },
    { wr: 'tbb-qoma', speicher: 'dyness-stack100',
      groessen: ['9S', '10S', '11S', '12S', '13S', '14S'],
      quelle: 'dyness-stack100-compat',
      wr_varianten: ['qoma33h-h-r'] },

    /* Zweiter Beleg fuer STACK100 aus der KOSTAL-Komplettuebersicht 07/2026.
     *
     * KORREKTUR 2026-08-16: Hier stand bisher "plus G2 fuer 3s bis 12s". Das
     * war falsch abgelesen — die Geraetezelle der Liste endet nach 11s. Der
     * Fehler ist typisch fuer diese Tabelle: Ihre Zellen ueberspannen
     * unterschiedlich viele Zeilen, und die Trennlinie liegt zwischen zwei
     * Zeilen, nicht neben einem Text. Nachgeprueft ist es jetzt geometrisch
     * aus den Wortkoordinaten des PDF (Zellmitte gegen Zeilenraster), in
     * beiden Fassungen mit demselben Ergebnis: 3s–11s plus G2, 12s–14s nur
     * G3-Reihe. Die Dyness-eigene Liste bleibt daneben stehen; sie reicht bei
     * plus G2 bis 11s und deckt sich damit.
     *
     * Neu in 07/2026: 15s — und zwar ausschliesslich fuer den BI 25 G3.
     */
    { wr: 'kostal-plenticore-plus-g2', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus G2 und PLENTICORE BI xx/26 G2 für 3s bis 11s; '
        + '12s bis 14s stehen dort nur bei G3 / MP G3 / BI 25 G3, 15s nur bei BI 25 G3.' },
    { wr: 'kostal-plenticore-g3', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S', '14S'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE G3 / PLENTICORE MP G3 für 3s bis 14s; 15s steht dort nur bei BI 25 G3.' },
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'dyness-stack100',
      groessen: ['3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S', '11S', '12S', '13S', '14S', '15S'],
      quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: nur eine Batterie dieses Typs, keine Parallelschaltung. '
        + 'Einziges Gerät der Liste, für das 15s freigegeben ist.' },

    /* ---- Pylontech Force H3 an der HV-Liste V2.43 (01.05.2026) ----
     * Schliesst die in README.md als Luecke 5 dokumentierte Stelle: Die
     * KOSTAL-Liste bezeichnet die Force-H3-Groessen nominal, BayWa nutzbar,
     * und aus der KOSTAL-Matrix war die Zuordnung Zelle -> Geraet maschinell
     * nicht zu holen. Pylontech loest das von der anderen Seite: Die eigene
     * Liste nennt je Wechselrichter die zulaessige MODULANZAHL — genau die
     * Groesse, nach der unsere Datenbasis ohnehin schluesselt. Damit tragen
     * die Force-H3-Paarungen erstmals eine HERSTELLERQUELLE statt nur BayWa
     * (typ 'distributor'), und der Status wechselt von 'auf Anfrage' auf
     * belegt.
     *
     * Uebernommen ist nur die FH3-Spalte: FH1, FH2 und RM sind eigene
     * Batteriereihen, die unser Katalog nicht fuehrt.
     */
    { wr: 'kostal-plenticore-g3', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      einschraenkung: 'Liste: PLENTICORE G3, FH3 2-5 Module. Fußnote c: "Only Force-H1-V2 and Force-H2-V2, Force-H3 are compatible with Kostal PLENTICORE series inverter."' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      einschraenkung: 'Liste: PLENTICORE plus G2 und PLENTICORE BI xx/26 G2, FH3 je 2-5 Module. Fußnote c wie bei G3.' },

    /* ---- Force H3 zusaetzlich aus der KOSTAL-Liste 07/2026 ----
     * Bis 2026-08-16 stand die KOSTAL-Liste hier aussen vor, weil sie die
     * Groessen nominal bezeichnet (10,24 / 15,36 / … kWh) und unsere Datenbasis
     * nutzbar (9,69 / 14,73 / …). Die Zuordnung ist aber aus dem Dokument
     * selbst zu haben, nicht aus Markenwissen: Dieselbe Zeile nennt das Modul
     * mit "5,12 kWh, 102,4 V" — 10,24 kWh sind also zwei Module, 35,84 kWh
     * sieben. Modulanzahl ist genau der Schluessel unserer Groessen. Die
     * Rechnung steht in `einschraenkung`, damit sie nachprüfbar bleibt.
     *
     * Die KOSTAL-Liste reicht dabei weiter als die Pylontech-eigene: Sie fuehrt
     * fuer die G3-Reihe auch 6 und 7 Module.
     */
    { wr: 'kostal-plenticore-g3', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt die Größen nominal (H3 10,24 / 15,36 / 20,48 / 25,6 / 30,72 / 35,84 kWh) '
        + 'bei einem Modul von 5,12 kWh — das sind 2 bis 7 Module. 30,72 und 35,84 stehen dort nur bei '
        + 'G3 / MP G3 / BI 25 G3.' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus G2 (sowie plus, BI xx/26, BI xx/26 G2) für H3 10,24 bis 25,6 kWh '
        + '= 2 bis 5 Module (Modul 5,12 kWh laut derselben Zeile); 30,72 und 35,84 nur bei der G3-Reihe.' },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus (sowie plus G2, BI xx/26, BI xx/26 G2, G3, MP G3, BI 25 G3) '
        + 'für H3 10,24 bis 25,6 kWh = 2 bis 5 Module (Modul 5,12 kWh laut derselben Zeile).' },
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: nur eine Batterie dieses Typs, keine Parallelschaltung. Größen nominal '
        + '(10,24 bis 35,84 kWh) = 2 bis 7 Module bei 5,12 kWh je Modul.' },
    { wr: 'sungrow-sh-rt', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      einschraenkung: 'Liste: SH5.0/6.0/8.0/10.0RT, FH3 2-5 Module, CAN.' },
    { wr: 'kaco-blueplanet-hybrid', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      einschraenkung: 'Liste: NH3 Series, FH3 2-5 Module.' },
    { wr: 'goodwe-eh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      einschraenkung: 'Liste: EH/BH series, FH3 2-4 Module.' },
    { wr: 'goodwe-bh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      einschraenkung: 'Liste: EH/BH series, FH3 2-4 Module.' },
    { wr: 'goodwe-et-5-10', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      einschraenkung: 'Liste: ET 5-10, FH3 2-5 Module.' },
    { wr: 'goodwe-et-15-30', speicher: 'pylontech-force-h3',
      groessen: ['14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'pylontech-hv-v243',
      einschraenkung: 'Liste: ET 15-30, FH3 3-7 Module. Fußnote e: "Only Force-H3 and Powercube-M1C are compatible with Goodwe ET 15~30KW/40KW/50KW."' },
    { wr: 'goodwe-et-40-50', speicher: 'pylontech-force-h3',
      groessen: ['14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'pylontech-hv-v243',
      einschraenkung: 'Liste: ET 40~50, FH3 3-7 Module. Fußnote e wie bei ET 15-30.' },
    { wr: 'deye-sun-sg-hybrid', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['deye-sun-5k-sg01hp3', 'deye-sun-6k-sg01hp3', 'deye-sun-8k-sg01hp3', 'deye-sun-10k-sg01hp3', 'deye-sun-12k-sg01hp3', 'deye-sun-15k-sg01hp3', 'deye-sun-20k-sg01hp3', 'deye-sun-25k-sg01hp3'],
      einschraenkung: 'Liste: Deye(Sunsynk) SUN-5~25K-SG01HP3-EU/AU, FH3 2-6 Module. Fußnote a verlangt eine Mindest-Firmware des Batterie-Controllers (Force-H3: Powercube-X/H V5.7).' },
    { wr: 'deye-sun-sg-hybrid', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['sun-sg01hp3-eu-bm3', 'sun-sg01hp3-eu-bm4'],
      einschraenkung: 'Liste: Deye(Sunsynk) SUN-29.9~50K-SG01HP3-EU/AU, FH3 2-7 Module. Fußnote a wie oben.' },
    { wr: 'solis-rhi-hves', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['rhi-3p-5-10k-hves-5g'],
      einschraenkung: 'Liste: RHI-3P-HVES-5G series, FH3 2-5 Module.' },
    { wr: 'solis-s6-eh-hv', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['s6-eh1p-3-8-11-4k-h-us'],
      einschraenkung: 'Liste: S6-EH1P(3.8-11.4)K-H-US, FH3 2-4 Module.' },
    { wr: 'solis-s6-eh-hv', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['s6-eh3p-12-20k-h'],
      einschraenkung: 'Liste: S6-EH3P(12-20)K-H, FH3 2-7 Module.' },
    { wr: 'solis-s6-eh-hv', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['s6-eh3p-29-9-50k-h'],
      einschraenkung: 'Liste: S6-EH3P(29.9-50)K-H, FH3 2-7 Module.' },
    { wr: 'solinteg-mh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['mht-4k-12k-25', 'mht-10k-20k-40'],
      einschraenkung: 'Liste: MHT-4~20K Series, FH3 2-6 Module.' },
    { wr: 'solinteg-mh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['mht-25-50k-100'],
      einschraenkung: 'Liste: MHT-25~50K Series, FH3 2-7 Module.' },
    { wr: 'solinteg-mh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['mhs-3k-8k-30'],
      einschraenkung: 'Liste: MHS-3~8K Series, FH3 1-4 Module; unsere kleinste geführte Turmstufe hat 2 Module.' },
    { wr: 'hoymiles-hv', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['hyt-5-12-hveug1', 'hat-5-10-hveug1'],
      einschraenkung: 'Liste: HYT-HV und HAT-HV Series, FH3 je 2-5 Module.' },
    { wr: 'koyoe-ky-est', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['ky-est-6k-10kh'],
      einschraenkung: 'Liste: KY-EST06KH~KY-EST20KH, FH3-Spalte differenziert: 6-10K = 2-4 Module.' },
    { wr: 'koyoe-ky-est', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['ky-est-12-20kh'],
      einschraenkung: 'Liste: KY-EST06KH~KY-EST20KH, FH3-Spalte differenziert: 12-20K = 2-6 Module.' },
    { wr: 'solplanet-asw-kh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['asw08-12kh-t1'],
      einschraenkung: 'Liste: AISWEI(Solplanet) ASW06H/08H/10H/12H/15H-T1, FH3 2-5 Module.' },
    { wr: 'solplanet-asw-kh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['asw08-12kh-t3'],
      einschraenkung: 'Liste: AISWEI(Solplanet) ASW08kH/10kH/12kH-T3(-DG), FH3 2-5 Module.' },
    { wr: 'afore-af-hv', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['af3k-9-6k-dh'],
      einschraenkung: 'Liste: AF3~9.6K-DH Series, FH3 2-4 Module.' },
    { wr: 'afore-af-hv', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['af3k-30k-th'],
      einschraenkung: 'Liste: AF3~30K-TH Series, FH3 2-7 Module.' },
    { wr: 'hypontech-hh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['hhs-3680-5000'],
      einschraenkung: 'Liste: HHS series, FH3 2-4 Module.' },
    { wr: 'hypontech-hh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['hht-5k-12k'],
      einschraenkung: 'Liste: HHT series, FH3 2-7 Module.' },
    { wr: 'ecactus-wh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['wh-spa-3-6-5-0h'],
      einschraenkung: 'Liste: WH-SPA-3.68H und WH-SPA-5.0H, FH3 je 2-4 Module.' },
    { wr: 'ecactus-wh', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['wh-shc-362-602'],
      einschraenkung: 'Liste: WH-SHC series, FH3 2-4 Module.' },
    { wr: 'senergy-se-khb', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17', '34.01'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['se-5-10khb-d3'],
      einschraenkung: 'Liste: SE 5K~30KHB-D3, FH3 2-7 Module.' },
    { wr: 'sunways-sth', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['sth-3-8k-tl-hs'],
      einschraenkung: 'Liste: STH-3-8KTL-HS series, FH3 2-4 Module.' },
    { wr: 'sunways-sth', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32', '29.17'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['sth-4-12-ktl-ht-p-cn'],
      einschraenkung: 'Liste: STH-4-12KTL-HT series, FH3 2-6 Module.' },
    { wr: 'saj-h2', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['h2-3k-6k-s2'],
      einschraenkung: 'Liste: H2-3K~6K-S2, FH3 2-4 Module.' },
    { wr: 'saj-h2', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['h2-5k-10k-t2'],
      einschraenkung: 'Liste: H2-5K~10K-T2, FH3 2-5 Module.' },
    { wr: 'sineng-sn', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['sn-3-6-0hs'],
      einschraenkung: 'Liste: SN3.0-6.0HS series, FH3 2-4 Module.' },
    { wr: 'sineng-sn', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['sn5-15ht'],
      einschraenkung: 'Liste: SN5.0-15HT series, FH3 2-5 Module.' },
    { wr: 'magarevo-hv', speicher: 'pylontech-force-h3',
      groessen: ['9.69', '14.73', '19.48', '24.32'],
      quelle: 'pylontech-hv-v243',
      wr_varianten: ['r6k-12k-h3'],
      einschraenkung: 'Liste: MEGAREVO R6~15KH3 Series, FH3 2-5 Module. Die daneben geführte Zeile R5~12KH1NA bleibt aus: Unser Gerät heißt R5K~11K4 H1, ohne NA.' },

    /* ---- ZYC SIMPO 5000 ----
     * Das Statement nennt die Geraete namentlich und macht keinen Unterschied
     * nach Turmgroesse — die Freigabe gilt deshalb fuer alle drei gefuehrten
     * Konfigurationen.
     */
    { wr: 'sma-sunny-island', speicher: 'zyc-simpo5000', groessen: ['1 Modul', 'Cabinet 6', 'Cabinet 10'],
      quelle: 'zyc-simpo5000-statement',
      einschraenkung: 'Statement nennt SI 4.4M, SI 6.0H und SI 8.0H.' },
    { wr: 'selectronic-spmc', speicher: 'zyc-simpo5000', groessen: ['1 Modul', 'Cabinet 6', 'Cabinet 10'],
      quelle: 'zyc-simpo5000-statement',
      einschraenkung: 'Statement nennt SPMC480-AU, SPMC481-AU und SPMC482-AU.' },
    { wr: 'studer-xt', speicher: 'zyc-simpo5000', groessen: ['1 Modul', 'Cabinet 6', 'Cabinet 10'],
      quelle: 'zyc-simpo5000-statement',
      einschraenkung: 'Statement nennt XTS/XTM/XTH, Next3 sowie die Laderegler VT-40/65/80 und '
        + 'VS-70/120, Letztere sind keine Wechselrichter; wir geben die Liste wieder, wie sie dasteht.' },
    { wr: 'noark-ex9n-dh', speicher: 'zyc-simpo5000', groessen: ['1 Modul', 'Cabinet 6', 'Cabinet 10'],
      quelle: 'zyc-simpo5000-statement',
      einschraenkung: 'Statement nennt zwölf Ex9N-DH-Modelle (KS- und KT-Reihe, AU-Fassungen).' },
    { wr: 'victron-cerbo', speicher: 'zyc-simpo5000', groessen: ['1 Modul', 'Cabinet 6', 'Cabinet 10'],
      quelle: 'zyc-simpo5000-statement',
      einschraenkung: 'Statement nennt rund 25 Victron-Geräte namentlich (MultiPlus, MultiPlus-II, '
        + 'Quattro, Quattro II, RS Smart Solar, Multi RS Solar, EasySolar II). Unser Katalog führt '
        + 'Victron als eine Familie über den Cerbo GX als Kommunikationsbrücke. Die Einzelmodelle '
        + 'sind dort nicht getrennt geführt.' },
    { wr: 'deye-sun-lp', speicher: 'zyc-simpo5000', groessen: ['1 Modul', 'Cabinet 6', 'Cabinet 10'],
      quelle: 'zyc-simpo5000-statement',
      wr_varianten: ['deye-sun-lp-1', 'deye-sun-lp-2', 'deye-sun-lp-5', 'deye-sun-lp-6', 'deye-sun-lp-7'],
      einschraenkung: 'Statement nennt die SG01LP1-, SG03LP1-, SG04LP1- und SG04LP3-Reihen mit '
        + 'einzelnen Leistungsstufen. Zugeordnet sind die Sammelvarianten, die diese Stufen abdecken: '
        + 'SUN-3/3.6/5/6K-SG04LP1-EU, SUN-3.6/5/6K-SG03LP1-EU, SUN-7.6/8K-SG01LP1-US/EU, '
        + 'SUN-5/6/8/10/12K-SG04LP3-EU und SUN-12/14/16K-SG01LP1-EU. NICHT zugeordnet: die im '
        + 'Statement genannten SUN-4.6K und SUN-5.5K-SG03LP1-EU sowie SUN-3.6K und SUN-5K-SG01LP1-EU, '
        + 'keine unserer Sammelzeilen deckt genau diese Stufen ab.' },
    { wr: 'goodwe-es-sbp', speicher: 'zyc-simpo5000', groessen: ['1 Modul', 'Cabinet 6', 'Cabinet 10'],
      quelle: 'zyc-simpo5000-statement',
      wr_varianten: ['gw12k-es-c10'],
      einschraenkung: 'Statement nennt genau ein GoodWe-Gerät: GW 12K-ES-C10.' },

    /* ---- ZYC SIMPO HV ----
     * Zwei Quellen, die sich nicht widersprechen, sondern verschieden weit
     * reichen: Die ZYC-Liste V1.3 (01/2025) haekt fuer KOSTAL bis HV25.6 und
     * laesst HV28.8 offen; die KOSTAL-Komplettuebersicht 04/2026 fuehrt 28,8
     * fuer G3 / MP G3. Beides steht mit eigener Quelle da — "nicht gefuehrt"
     * ist kein Ausschluss.
     */
    { wr: 'kostal-plenticore-g3', speicher: 'zyc-simpo-hv',
      groessen: ['6.4', '9.6', '12.8', '16', '19.2', '22.4', '25.6'],
      quelle: 'zyc-simpo-hv-compat',
      einschraenkung: 'Liste nennt PLENTICORE G3 S-4.0 bis L-20. Wechselrichter-Firmware '
        + 'SW 3.04.00.16312 oder höher, BMS-Firmware V1.5.0 oder höher. HV28.8 führt sie nicht.' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'zyc-simpo-hv',
      groessen: ['6.4', '9.6', '12.8', '16', '19.2', '22.4', '25.6'],
      quelle: 'zyc-simpo-hv-compat',
      einschraenkung: 'Liste nennt PLENTICORE plus G2 3.0 bis 10 sowie PLENTICORE BI G2 5.5/26 und '
        + '10/26. BMS-Firmware V1.5.0 oder höher. HV28.8 führt sie nicht.' },
    { wr: 'kostal-plenticore-g3', speicher: 'zyc-simpo-hv',
      groessen: ['6.4', '9.6', '12.8', '16', '19.2', '22.4', '25.6', '28.8'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE G3 / PLENTICORE MP G3 für alle acht Größen.' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'zyc-simpo-hv',
      groessen: ['9.6', '12.8', '16', '19.2', '22.4', '25.6'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus G2 (sowie PLENTICORE BI xx/26 G2) für 9,6 bis 25,6; '
        + '6,4 und 28,8 stehen dort nur bei G3 / MP G3 / BI 25 G3.' },
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'zyc-simpo-hv',
      groessen: ['6.4', '9.6', '12.8', '16', '19.2', '22.4', '25.6', '28.8'],
      quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: nur eine Batterie dieses Typs, keine Parallelschaltung. '
        + 'Parallelbetrieb mehrerer Türme laut Liste ohnehin nur mit ZYC Combiner Box.' },
    { wr: 'solis-s6-eh-hv', speicher: 'zyc-simpo-hv',
      groessen: ['6.4', '9.6', '12.8', '16', '19.2', '22.4', '25.6'],
      quelle: 'zyc-simpo-hv-compat',
      wr_varianten: ['s6-eh3p-5-10k2-h-eu'],
      einschraenkung: 'Liste nennt S6-EH3P(5~10)K2-H (und die AU-Fassung). Wechselrichter-Firmware '
        + 'V0266 oder höher, BMS-Firmware V1.5.0 oder höher. Die ebenfalls gelistete Zeile '
        + 'S6-EH3P(12~20)K2-H führen wir nicht: Unser Gerät heißt S6-EH3P(12-20)K-H, ohne K2, '
        + 'ob das dasselbe Modell ist, sagt kein Dokument.' },
    { wr: 'solis-rhi-hves', speicher: 'zyc-simpo-hv',
      groessen: ['9.6', '12.8', '16', '19.2', '22.4', '25.6'],
      quelle: 'zyc-simpo-hv-compat',
      wr_varianten: ['rhi-3p-5-10k-hves-5g'],
      einschraenkung: 'Liste nennt RHI-3P(5-10)K-HVES-5G ab HV9.6; HV6.4 und HV28.8 führt sie nicht.' },
    { wr: 'goodwe-et-5-10', speicher: 'zyc-simpo-hv',
      groessen: ['9.6', '12.8', '16', '19.2', '22.4', '25.6'],
      quelle: 'zyc-simpo-hv-compat',
      einschraenkung: 'Liste nennt GW5K/6.5K/8K/10K-ET und die N-Fassungen ab HV9.6. '
        + 'ARM-Firmware V27 für ET5-10, BMS V1.5.0 oder höher.' },
    { wr: 'goodwe-et-15-30', speicher: 'zyc-simpo-hv',
      groessen: ['12.8', '16', '19.2', '22.4', '25.6', '28.8'],
      quelle: 'zyc-simpo-hv-compat',
      einschraenkung: 'Liste nennt GW15K/20K/25K/29.9K/30K-ET ab HV12.8. ARM-Firmware V07 für '
        + 'ET 15-30, BMS V1.5.0 oder höher.' },
    { wr: 'goodwe-eh', speicher: 'zyc-simpo-hv',
      groessen: ['6.4', '9.6', '12.8', '16', '19.2'],
      quelle: 'zyc-simpo-hv-compat',
      einschraenkung: 'Liste nennt GW3600/5000/6000-EH und die N-Fassungen bis HV19.2. '
        + 'Firmware DSP12 / ARM28 oder höher, BMS V1.5.0 oder höher.' },
    { wr: 'goodwe-bh', speicher: 'zyc-simpo-hv',
      groessen: ['6.4', '9.6', '12.8', '16', '19.2'],
      quelle: 'zyc-simpo-hv-compat',
      einschraenkung: 'Liste nennt GW3k/3600/5000/6000-BH bis HV19.2. Firmware DSP12 / ARM28 oder '
        + 'höher, BMS V1.5.0 oder höher.' },
    { wr: 'solinteg-mh', speicher: 'zyc-simpo-hv',
      groessen: ['6.4', '9.6', '12.8', '16', '19.2'],
      quelle: 'zyc-simpo-hv-compat',
      wr_varianten: ['mhs-3k-8k-30'],
      einschraenkung: 'Liste nennt MHS-3/3.6/4.2/5/6/8K-30 bis HV19.2. BMS-Firmware V1.9.3 oder höher.' },
    { wr: 'solinteg-mh', speicher: 'zyc-simpo-hv',
      groessen: ['9.6', '12.8', '16', '19.2', '22.4', '25.6', '28.8'],
      quelle: 'zyc-simpo-hv-compat',
      wr_varianten: ['mht-4k-12k-25'],
      einschraenkung: 'Liste nennt MHT-4/5/6/8/10/12K-25 ab HV9.6. BMS-Firmware V1.9.3 oder höher.' },

    /* ---- Weitere Zeilen der KOSTAL-Komplettuebersicht 04/2026 ----
     * Beim Durcharbeiten der Liste fuer VARTA fielen zwei weitere Luecken auf:
     * LG RESU FLEX stand ueberhaupt nicht an KOSTAL, und die beiden
     * Dyness-Tuerme waren nur ueber die Dyness-Liste belegt. Die
     * KOSTAL-Zeile ist ein zweiter, eigenstaendiger Beleg — genau dafuer ist
     * eine Freigabe je Quelle vorgesehen.
     */
    { wr: 'kostal-plenticore-g3', speicher: 'lg-flex',
      groessen: ['8.6', '12.9', '17.2'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE G3 / PLENTICORE MP G3.' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'lg-flex',
      groessen: ['8.6', '12.9', '17.2'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus G2 (sowie PLENTICORE BI xx/26 und BI xx/26 G2). '
        + 'Den BI 25 G3 führt die Zeile nicht.' },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'lg-flex',
      groessen: ['8.6', '12.9', '17.2'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus (sowie plus G2, BI xx/26, BI xx/26 G2, G3 und MP G3).' },
    { wr: 'kostal-plenticore-g3', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE G3 / PLENTICORE MP G3.' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus G2 (sowie PLENTICORE BI xx/26 und BI xx/26 G2).' },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus (sowie plus G2, BI xx/26, BI xx/26 G2, G3 und MP G3). '
        + 'Den BI 25 G3 führte die Zeile bis 07/2026, in 08/2026 nicht mehr.' },
    /*
     * Der PLENTICORE BI 25 G3 stand hier bis 07/2026 — in 08/2026 nennt die
     * Dyness-Tower-Zeile ihn nicht mehr (geprüft 2026-09-07, Seite 3). Die
     * Freigabe ist deshalb entfernt und nicht etwa umdatiert worden: Ein Beleg,
     * der weggefallen ist, trägt nichts mehr. Die Dyness-eigene Liste
     * (dyness-tower-s2-compat) führt für KOSTAL nur G3/MP G3 und plus G2, also
     * bleibt kein zweiter Beleg übrig. Die Kombination ist damit „noch nicht
     * bestätigt" — nicht „inkompatibel" (Invariante 1). Der Tower PRO behält
     * den BI 25 G3, dort steht er unverändert in der Liste.
     */
    { wr: 'kostal-plenticore-g3', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE G3 / PLENTICORE MP G3.' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus G2 (sowie PLENTICORE BI xx/26 und BI xx/26 G2).' },
    { wr: 'kostal-plenticore-plus-g1', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus (sowie plus G2, BI xx/26, BI xx/26 G2, G3, MP G3 und BI 25 G3).' },
    { wr: 'kostal-plenticore-bi-25-g3', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'kostal-0826',
      einschraenkung: 'Fußnote 12: nur eine Batterie dieses Typs, keine Parallelschaltung.' },

    /* ---- VARTA.wall an KOSTAL und SMA — nachgetragen 2026-08-09 ----
     * Drei Dokumente, die sich gegenseitig stuetzen:
     *  - KOSTAL-Komplettuebersicht 04/2026 fuehrt beide Modulreihen mit
     *    denselben Groessen und nennt je Groesse die freigegebenen Geraete.
     *  - SMA Approved Batteries 2026/02 fuehrt sie fuer die STP-3SE-40-Reihe.
     *  - Die VARTA-Blaetter selbst nennen "Kostal (Plenticore BI G2, Plenticore
     *    plus G2, Plenticore G3, Plenticore MP G3)" und "SMA (Sunny Tripower
     *    Smart Energy)" als kompatible Wechselrichter.
     * Jede Zeile zitiert ihr eigenes Dokument — Mehrfachbelege sind gewollt.
     *
     * PLENTICORE plus (G1) steht bei KOSTAL NICHT in der VARTA-Zeile, nur
     * plus G2, BI xx/26 G2, G3 und MP G3. Deshalb keine Freigabe fuer die
     * G1-Familie; "nicht gefuehrt" heisst hier wie ueberall "nicht bestaetigt".
     */
    { wr: 'kostal-plenticore-g3', speicher: 'varta-wall-bm1',
      groessen: ['10', '15', '20'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE G3 / PLENTICORE MP G3. Fußnote 11: Die neue VARTA '
        + 'Master Unit BM1/BM2 (Artikelnummer 02732709002) unterstützt beide Batteriesysteme.' },
    { wr: 'kostal-plenticore-g3', speicher: 'varta-wall-bm2',
      groessen: ['9', '13.5', '18'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE G3 / PLENTICORE MP G3. Fußnote 11: Die neue VARTA '
        + 'Master Unit BM1/BM2 (Artikelnummer 02732709002) unterstützt beide Batteriesysteme.' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'varta-wall-bm1',
      groessen: ['10', '15', '20'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus G2 (sowie PLENTICORE BI xx/26 G2). '
        + 'PLENTICORE plus der ersten Generation führt die Zeile nicht.' },
    { wr: 'kostal-plenticore-plus-g2', speicher: 'varta-wall-bm2',
      groessen: ['9', '13.5', '18'],
      quelle: 'kostal-0826',
      einschraenkung: 'Liste nennt PLENTICORE plus G2 (sowie PLENTICORE BI xx/26 G2). '
        + 'PLENTICORE plus der ersten Generation führt die Zeile nicht.' },
    { wr: 'sma-sunny-tripower-smart-energy', speicher: 'varta-wall-bm1',
      groessen: ['10', '15', '20'],
      quelle: 'sma-approved-2026-02',
      einschraenkung: 'Liste nennt "Varta.wall 10 kWh / 15 kWh / 20 kWh (Varta AG)", '
        + 'Batterie-Firmware = 2.70.1, Wechselrichter-Firmware >= 3.05.18.R.' },
    { wr: 'sma-sunny-tripower-smart-energy', speicher: 'varta-wall-bm2',
      groessen: ['9', '13.5', '18'],
      quelle: 'sma-approved-2026-02',
      einschraenkung: 'Liste nennt "Varta.wall BM2 9 kWh / 13.5 kWh / 18 kWh (Varta AG)", '
        + 'Batterie-Firmware = 2.100.4, Wechselrichter-Firmware >= 3.05.26.R.' },
    { wr: 'kostal-plenticore-g3', speicher: 'varta-wall-bm2',
      groessen: ['9', '13.5', '18'],
      quelle: 'varta-wall-bm2-db',
      einschraenkung: 'Datenblatt nennt unter "Kompatible Wechselrichter": Kostal (Plenticore BI G2, '
        + 'Plenticore plus G2, Plenticore G3, Plenticore MP G3).' },
    { wr: 'sma-sunny-tripower-smart-energy', speicher: 'varta-wall-bm2',
      groessen: ['9', '13.5', '18'],
      quelle: 'varta-wall-bm2-db',
      einschraenkung: 'Datenblatt nennt unter "Kompatible Wechselrichter": SMA (Sunny Tripower Smart Energy).' },

    /* ---- GoodWe ESA: Leistungsmodul x eigenes Batteriemodul ----
     * Beleg ist das jeweilige ESA-Datenblatt selbst: Es fuehrt beide Module in
     * einem Dokument als ein System. Andere Speicher nennt es nicht — und keine
     * fremde Liste nennt die ESA-Reihe. Mehr als das steht hier deshalb nicht.
     */
    { wr: 'goodwe-esa-eta-g20', speicher: 'goodwe-esa-bat-d-g20',
      groessen: ['2 Module', '3 Module', '4 Module', '5 Module', '6 Module'],
      quelle: 'goodwe-esa-5-30-db',
      einschraenkung: 'Datenblatt führt Leistungs- und Batteriemodul als ein vorverdrahtetes ESA-System '
        + '("integrates the inverter, battery ... into a single system"). Dreiphasige Systeme: '
        + 'Batteriespannung 700–950 V. Bis zu 12 Module / 108 kWh laut demselben Blatt; '
        + 'hier geführt sind die Stufen bis 6 Module.' },
    { wr: 'goodwe-esa-eta-g20', speicher: 'goodwe-esa-bat-d-g20-8',
      groessen: ['2 Module', '3 Module', '4 Module', '5 Module', '6 Module'],
      quelle: 'goodwe-esa-5-30-db',
      einschraenkung: 'Datenblatt führt Leistungs- und Batteriemodul als ein vorverdrahtetes ESA-System '
        + '("integrates the inverter, battery ... into a single system"). Dreiphasige Systeme: '
        + 'Batteriespannung 700–950 V. Bis zu 12 Module / 108 kWh laut demselben Blatt; '
        + 'hier geführt sind die Stufen bis 6 Module.' },
    { wr: 'goodwe-esa-eha-g20', speicher: 'goodwe-esa-bat-d-g20',
      groessen: ['2 Module', '3 Module', '4 Module', '5 Module', '6 Module'],
      quelle: 'goodwe-esa-3-10-db',
      einschraenkung: 'Datenblatt führt Leistungs- und Batteriemodul als ein vorverdrahtetes ESA-System. '
        + 'Einphasige Systeme: Batteriespannung 350–550 V. Bis zu 12 Module / 108 kWh laut '
        + 'demselben Blatt; hier geführt sind die Stufen bis 6 Module.' },
    { wr: 'goodwe-esa-eha-g20', speicher: 'goodwe-esa-bat-d-g20-8',
      groessen: ['2 Module', '3 Module', '4 Module', '5 Module', '6 Module'],
      quelle: 'goodwe-esa-3-10-db',
      einschraenkung: 'Datenblatt führt Leistungs- und Batteriemodul als ein vorverdrahtetes ESA-System. '
        + 'Einphasige Systeme: Batteriespannung 350–550 V. Bis zu 12 Module / 108 kWh laut '
        + 'demselben Blatt; hier geführt sind die Stufen bis 6 Module.' },

    /* ---- Dyness Tower Pro / S2 / S3: die uebrigen Freigaben der drei Listen ----
     * Jede Zeile der Herstellertabelle mit ihrem eigenen Groessensatz. Verbucht sind
     * alle Haken der drei Listen: 247 (Pro), 257 (S2), 219 (S3).
     */
    { wr: 'afore-af-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['af3k-9-6k-dh'] },
    { wr: 'afore-af-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['af3k-30k-th'] },
    { wr: 'atess-hps', speicher: 'dyness-tower-pro',
      groessen: ['TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['hps-5000-10000tls'] },
    { wr: 'atess-hps', speicher: 'dyness-tower-pro',
      groessen: ['TP19'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['hps-30-150'] },
    { wr: 'autarco-lh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['s2-lh-5k-10k', 'lh5k-10k-mii'] },
    { wr: 'bluesun-bse', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'dunext-hybrid', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['ni-hv3-6'] },
    { wr: 'dunext-hybrid', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['dn3h-6-10ktl'] },
    { wr: 'ecactus-wh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['wh-spa-3-6-5-0h', 'wh-shc-362-602'] },
    { wr: 'goodwe-et-5-10', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'goodwe-et-15-30', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'goodwe-et-40-50', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'goodwe-bt', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'goodwe-eh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'goodwe-bh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'goodwe-ehb', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'hopewind-hynv', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'hoymiles-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['hy3-5k-10k-hv'] },
    { wr: 'hoymiles-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['hyt-5-12-hveug1', 'hat-5-10-hveug1'] },
    { wr: 'hypontech-hh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['hhs-3680-5000'] },
    { wr: 'hypontech-hh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['hht-5k-12k'] },
    { wr: 'ingeteam-sun-storage', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'jinko-jks', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'kaco-blueplanet-hybrid', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'koyoe-ky-est', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['ky-est-6k-10kh'] },
    { wr: 'koyoe-ky-est', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['ky-est-12-20kh'] },
    { wr: 'magarevo-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['r5k-11k4-h1'],
      einschraenkung: 'Liste schreibt die Marke in der Textspalte "MAGAREVO"; ihr eigenes Logo liest "MEGAREVO".' },
    { wr: 'magarevo-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['r6k-12k-h3'],
      einschraenkung: 'Liste schreibt die Marke in der Textspalte "MAGAREVO"; ihr eigenes Logo liest "MEGAREVO".' },
    { wr: 'magarevo-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['mega0100ts'],
      einschraenkung: 'Liste schreibt die Marke in der Textspalte "MAGAREVO"; ihr eigenes Logo liest "MEGAREVO".' },
    { wr: 'renac-n3-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'saj-h2', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['h2-5k-10k-t2'] },
    { wr: 'saj-h2', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['h2-3k-6k-s2'] },
    { wr: 'senergy-se-khb', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'sermatec-smt', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'sineng-sn', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['sn-3-6-0hs'] },
    { wr: 'sineng-sn', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['sn5-15ht'] },
    { wr: 'sinexcel-pw', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['pwg2-50k-100k-cn'] },
    { wr: 'solinteg-mh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['mht-25-50k-100', 'mht-4k-12k-25', 'mht-10k-20k-40'] },
    { wr: 'solinteg-mh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['mhs-3k-8k-30'] },
    { wr: 'solis-rhi-hves', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['rhi-3p-5-10k-hves-5g'] },
    { wr: 'solis-rhi-hves', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['rhi-1p7-6k-hves-5g'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['s6-eh3p-3-10k-h-pro', 's6-eh3p-5-10k2-h-eu'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['s6-eh1p-3-8-11-4k-h-us'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['s6-eh3p-12-20k-h', 's6-eh3p-29-9-50k-h'] },
    { wr: 'sosen-sse-hh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['sse-hh3-6k-p1eu'] },
    { wr: 'sosen-sse-hh', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['sse-hh8-12k-p3eu'] },
    { wr: 'sunways-sth', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['sth-4-12-ktl-ht-p-cn'] },
    { wr: 'sunways-sth', speicher: 'dyness-tower-pro',
      groessen: ['TP7', 'TP11', 'TP15'],
      quelle: 'dyness-tower-pro-compat',
      wr_varianten: ['sth-3-8k-tl-hs'] },
    { wr: 'tbb-qoma', speicher: 'dyness-tower-pro',
      groessen: ['TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'thinkpower-eph', speicher: 'dyness-tower-pro',
      groessen: ['TP11', 'TP15', 'TP19', 'TP23'],
      quelle: 'dyness-tower-pro-compat' },
    { wr: 'afore-af-hv', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['af3k-9-6k-dh'] },
    { wr: 'afore-af-hv', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['af3k-30k-th'] },
    { wr: 'atess-hps', speicher: 'dyness-tower-s2',
      groessen: ['T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['hps-5000-10000tls'] },
    { wr: 'atess-hps', speicher: 'dyness-tower-s2',
      groessen: ['T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['hps-30-150'] },
    { wr: 'autarco-lh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['s2-lh-5k-10k', 'lh5k-10k-mii'] },
    { wr: 'bluesun-bse', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'dunext-hybrid', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['ni-hv3-6'] },
    { wr: 'dunext-hybrid', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['dn3h-6-10ktl'] },
    { wr: 'ecactus-wh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['wh-spa-3-6-5-0h', 'wh-shc-362-602'] },
    { wr: 'goodwe-et-5-10', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'goodwe-et-15-30', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'goodwe-et-40-50', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'goodwe-bt', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'goodwe-eh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'goodwe-bh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'goodwe-ehb', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'hopewind-hynv', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'hoymiles-hv', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['hy3-5k-10k-hv'] },
    { wr: 'hoymiles-hv', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['hyt-5-12-hveug1', 'hat-5-10-hveug1'] },
    { wr: 'hypontech-hh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['hhs-3680-5000'] },
    { wr: 'hypontech-hh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['hht-5k-12k'] },
    { wr: 'ingeteam-sun-storage', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'jinko-jks', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'kaco-blueplanet-hybrid', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'koyoe-ky-est', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['ky-est-6k-10kh'] },
    { wr: 'koyoe-ky-est', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['ky-est-12-20kh'] },
    { wr: 'magarevo-hv', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['r5k-11k4-h1'],
      einschraenkung: 'Liste schreibt die Marke in der Textspalte "MAGAREVO"; ihr eigenes Logo liest "MEGAREVO".' },
    { wr: 'magarevo-hv', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['r6k-12k-h3'],
      einschraenkung: 'Liste schreibt die Marke in der Textspalte "MAGAREVO"; ihr eigenes Logo liest "MEGAREVO".' },
    { wr: 'magarevo-hv', speicher: 'dyness-tower-s2',
      groessen: ['T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['mega0100ts'],
      einschraenkung: 'Liste schreibt die Marke in der Textspalte "MAGAREVO"; ihr eigenes Logo liest "MEGAREVO".' },
    { wr: 'renac-n3-hv', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'saj-h2', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['h2-5k-10k-t2'] },
    { wr: 'saj-h2', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['h2-3k-6k-s2'] },
    { wr: 'senergy-se-khb', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'sermatec-smt', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'sineng-sn', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['sn-3-6-0hs'] },
    { wr: 'sineng-sn', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['sn5-15ht'] },
    { wr: 'sinexcel-pw', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['pwg2-50k-100k-cn'] },
    { wr: 'sinexcel-pw', speicher: 'dyness-tower-s2',
      groessen: ['T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['pws1-150-250k'] },
    { wr: 'solinteg-mh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['mht-25-50k-100', 'mht-4k-12k-25', 'mht-10k-20k-40'] },
    { wr: 'solinteg-mh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['mhs-3k-8k-30'] },
    { wr: 'solis-rhi-hves', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['rhi-3p-5-10k-hves-5g'] },
    { wr: 'solis-rhi-hves', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['rhi-1p7-6k-hves-5g'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['s6-eh3p-3-10k-h-pro', 's6-eh3p-5-10k2-h-eu'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['s6-eh1p-3-8-11-4k-h-us'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['s6-eh3p-12-20k-h', 's6-eh3p-29-9-50k-h'] },
    { wr: 'solplanet-asw-kh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['asw08-12kh-t1', 'asw08-12kh-t3'] },
    { wr: 'sosen-sse-hh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['sse-hh3-6k-p1eu'] },
    { wr: 'sosen-sse-hh', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['sse-hh8-12k-p3eu'] },
    { wr: 'sunways-sth', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['sth-4-12-ktl-ht-p-cn'] },
    { wr: 'sunways-sth', speicher: 'dyness-tower-s2',
      groessen: ['T7', 'T10', 'T14'],
      quelle: 'dyness-tower-s2-compat',
      wr_varianten: ['sth-3-8k-tl-hs'] },
    { wr: 'tbb-qoma', speicher: 'dyness-tower-s2',
      groessen: ['T17', 'T21'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'thinkpower-eph', speicher: 'dyness-tower-s2',
      groessen: ['T10', 'T14', 'T17', 'T21'],
      quelle: 'dyness-tower-s2-compat' },
    { wr: 'afore-af-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['af3k-9-6k-dh'] },
    { wr: 'afore-af-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['af3k-30k-th'] },
    { wr: 'atess-hps', speicher: 'dyness-tower-s3',
      groessen: ['TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['hps-5000-10000tls'] },
    { wr: 'atess-hps', speicher: 'dyness-tower-s3',
      groessen: ['TS17'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['hps-30-150'] },
    { wr: 'autarco-lh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['s2-lh-5k-10k', 'lh5k-10k-mii'] },
    { wr: 'bluesun-bse', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'dunext-hybrid', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['ni-hv3-6'] },
    { wr: 'dunext-hybrid', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['dn3h-6-10ktl'] },
    { wr: 'ecactus-wh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['wh-spa-3-6-5-0h', 'wh-shc-362-602'] },
    { wr: 'goodwe-et-5-10', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'goodwe-et-15-30', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'goodwe-et-40-50', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'goodwe-bt', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'goodwe-eh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'goodwe-bh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'goodwe-ehb', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'hopewind-hynv', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'hoymiles-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['hy3-5k-10k-hv'] },
    { wr: 'hoymiles-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['hyt-5-12-hveug1', 'hat-5-10-hveug1'] },
    { wr: 'hypontech-hh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['hhs-3680-5000'] },
    { wr: 'hypontech-hh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['hht-5k-12k'] },
    { wr: 'ingeteam-sun-storage', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'jinko-jks', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'kaco-blueplanet-hybrid', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'koyoe-ky-est', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['ky-est-6k-10kh'] },
    { wr: 'koyoe-ky-est', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['ky-est-12-20kh'] },
    { wr: 'magarevo-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['r5k-11k4-h1'],
      einschraenkung: 'Liste schreibt die Marke in der Textspalte "MAGAREVO"; ihr eigenes Logo liest "MEGAREVO".' },
    { wr: 'magarevo-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['r6k-12k-h3'],
      einschraenkung: 'Liste schreibt die Marke in der Textspalte "MAGAREVO"; ihr eigenes Logo liest "MEGAREVO".' },
    { wr: 'magarevo-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['mega0100ts'],
      einschraenkung: 'Liste schreibt die Marke in der Textspalte "MAGAREVO"; ihr eigenes Logo liest "MEGAREVO".' },
    { wr: 'renac-n3-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'saj-h2', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['h2-5k-10k-t2'] },
    { wr: 'saj-h2', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['h2-3k-6k-s2'] },
    { wr: 'senergy-se-khb', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'sermatec-smt', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'sineng-sn', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['sn-3-6-0hs'] },
    { wr: 'sineng-sn', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['sn5-15ht'] },
    { wr: 'sinexcel-pw', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['pwg2-50k-100k-cn'] },
    { wr: 'sinexcel-pw', speicher: 'dyness-tower-s3',
      groessen: ['TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['pws1-150-250k'] },
    { wr: 'solinteg-mh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['mht-25-50k-100', 'mht-4k-12k-25', 'mht-10k-20k-40'] },
    { wr: 'solinteg-mh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['mhs-3k-8k-30'] },
    { wr: 'solis-rhi-hves', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['rhi-3p-5-10k-hves-5g'] },
    { wr: 'solis-rhi-hves', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['rhi-1p7-6k-hves-5g'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['s6-eh3p-3-10k-h-pro', 's6-eh3p-5-10k2-h-eu'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['s6-eh1p-3-8-11-4k-h-us'] },
    { wr: 'solis-s6-eh-hv', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['s6-eh3p-12-20k-h', 's6-eh3p-29-9-50k-h'] },
    { wr: 'sosen-sse-hh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['sse-hh3-6k-p1eu'] },
    { wr: 'sosen-sse-hh', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['sse-hh8-12k-p3eu'] },
    { wr: 'sunways-sth', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['sth-4-12-ktl-ht-p-cn'] },
    { wr: 'sunways-sth', speicher: 'dyness-tower-s3',
      groessen: ['TS7', 'TS10', 'TS14'],
      quelle: 'dyness-tower-s3-compat',
      wr_varianten: ['sth-3-8k-tl-hs'] },
    { wr: 'tbb-qoma', speicher: 'dyness-tower-s3',
      groessen: ['TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat' },
    { wr: 'thinkpower-eph', speicher: 'dyness-tower-s3',
      groessen: ['TS10', 'TS14', 'TS17', 'TS21'],
      quelle: 'dyness-tower-s3-compat' },

    /* ------------------------------------------------------------------ SolarEdge
     * Drei Herstellerquellen tragen diese Zeilen, und sie sagen dasselbe:
     * die Kompatibilitaetsmatrix (dreiphasig), die WR-Datenblaetter (Zeile
     * „Unterstuetzte Batterietypen") und das Konfigurationsdokument der
     * 400V-Batterie (einphasig). Mehrfachbelege sind gewollt — jede Zeile wird
     * einzeln zitiert.
     */
    { wr: 'solaredge-home-hub-3ph', speicher: 'solaredge-home-batterie-48v',
      groessen: ['4.6', '9.2', '13.8', '18.4', '23.0'],
      quelle: 'solaredge-matrix-3ph-v15',
      einschraenkung: 'Matrix: 1–5 Batteriemodule pro Wechselrichter. Die daneben geführte '
        + '„SolarEdge Home Batterie 48V (W)" (1–4 Module) ist laut Fußnote nur begrenzt verfügbar '
        + 'und hier nicht aufgenommen.' },
    { wr: 'solaredge-home-hub-3ph', speicher: 'solaredge-home-batterie-48v',
      groessen: ['4.6', '9.2', '13.8', '18.4', '23.0'],
      quelle: 'solaredge-hub-3ph-db',
      einschraenkung: 'Datenblattzeile „Unterstützte Batterietypen: SolarEdge Home Batterie '
        + 'BAT-05K48 (1 – 5 Batteriemodule)".' },
    { wr: 'solaredge-home-hub-3ph', speicher: 'solaredge-home-batterie-48v',
      groessen: ['4.6', '9.2', '13.8', '18.4', '23.0'],
      quelle: 'baywa-0226',
      einschraenkung: 'Liste führt die Reihe als „Hybrid SE5K | 8K | 10K -RWB Home Hub" und '
        + 'schreibt die vierte Größe als 18,5 kWh; das Datenblatt nennt 18,4 kWh (4 × 4,6 kWh).' },

    { wr: 'solaredge-storedge-3ph', speicher: 'solaredge-home-batterie-48v',
      groessen: ['4.6', '9.2', '13.8', '18.4', '23.0'],
      quelle: 'solaredge-matrix-3ph-v15',
      einschraenkung: 'Matrix-Fußnote 2: unterstützt ab Produktionswoche 29/2021 und ausgenommen '
        + 'die „BYD-only"-Artikelnummern SE*K-RWS48BEB4. Die Produktionswoche steht in der '
        + 'Seriennummer („SxWWYY").' },
    { wr: 'solaredge-storedge-3ph', speicher: 'solaredge-home-batterie-48v',
      groessen: ['4.6'],
      quelle: 'solaredge-storedge-3ph-db',
      einschraenkung: 'Datenblatt (2022) nennt „SolarEdge Home Batterie 48V - BAT-05K48M0B-01" und '
        + 'lässt genau EINE Batterie je Wechselrichter zu. Die neuere Matrix (2025) erlaubt für '
        + 'dieselbe Paarung 1–5 Module; diese Zeile bleibt deshalb bewusst auf die kleinste Größe '
        + 'beschränkt und die Matrix trägt die größeren.' },

    { wr: 'solaredge-storedge-3ph', speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'solaredge-storedge-3ph-db',
      einschraenkung: 'Datenblattzeile „Unterstützte Batterietypen" nennt die BYD Batterie-Box '
        + 'Premium LVS 4.0, 8.0, 12.0, 16.0, 20.0, 24.0 namentlich; eine Batterie je Wechselrichter. '
        + 'BYD bestätigt die Paarung von seiner Seite in der Minimum Configuration List V1.12 '
        + '(„SolarEdge* SE 5K/7K/8K/10K-RWS", dreiphasig mindestens ein Modul und ein Turm, mehrere '
        + 'Türme nicht unterstützt, Batterie-Firmware BMU ≥ V1.16 / BMS ≥ V1.8, WR-Firmware '
        + '≥ 4.11). Diese Bestätigung steht als eigene Zeile aus Quelle byd-lvs-mcl.' },
    { wr: 'solaredge-storedge-3ph', speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'solaredge-matrix-3ph-v15',
      einschraenkung: 'Matrix: 1–6 Batteriemodule pro Wechselrichter; Fußnote 3 nimmt die '
        + 'Artikelnummern SE*K-RWS48BEB4 aus.' },

    /* ---- BYD Battery-Box Premium LVS, BYD Minimum Configuration List V1.12 ----
     * Lesart siehe Quelle 'byd-lvs-mcl': freigegeben ab dem Minimum für
     * „ON Grid" (Abschnitt 1), eine Größe ist ein Turm mit 1–6 Modulen
     * (4.0 = 1 Modul … 24.0 = 6 Module). Notstrom- und Inselbetriebswerte
     * (Abschnitte 2–4) stehen als Hinweis im Text. Zu allen Zeilen gilt der
     * Listenvermerk: Ein einzelner Turm mit 5 oder 6 Modulen darf höchstens
     * 12,8 kW Last tragen.
     */
    { wr: 'solaredge-storedge-3ph', speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste: SolarEdge SE 5K, 7K, 8K und 10K-RWS, dreiphasig mindestens ein Modul '
        + 'und ein Turm; mehrere Türme werden nicht unterstützt. Batterie-Firmware BMU ≥ V1.16, '
        + 'BMS ≥ V1.8; Wechselrichter-Firmware ≥ 4.11.' },
    { wr: 'sma-sunny-island', wr_varianten: ['si-4-4m'], speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste, Netzbetrieb: SI 4.4M einphasig ab 1 Modul; dreiphasig (Cluster) ab '
        + '4 Modulen in einem Turm. Notstrom und Inselbetrieb: einphasig ab 2 Modulen, dreiphasig ab '
        + '8 Modulen in 2 Türmen. Batterie-Firmware BMU ≥ V1.19, BMS ≥ V1.8; Wechselrichter-Firmware '
        + '≥ V1.3.1.R. BYD schreibt Einstellwerte am Sunny Island vor (Tiefentladeschutz-Untergrenze '
        + 'unter 2 %, Tiefentladeschutz-Bereich mindestens 8 %, Ladeerhaltungsbereich 3–5 %).' },
    { wr: 'sma-sunny-island', wr_varianten: ['si-6-0h'], speicher: 'byd-premium-lvs',
      groessen: ['8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste, Netzbetrieb: SI 6.0H einphasig ab 2 Modulen; dreiphasig ab 6 Modulen '
        + 'in 2 Türmen. Notstrom und Inselbetrieb: einphasig ab 4 Modulen, dreiphasig ab 12 Modulen in '
        + '3 Türmen. Batterie-Firmware BMU ≥ V1.19, BMS ≥ V1.8; Wechselrichter-Firmware ≥ V1.3.1.R; '
        + 'Einstellwerte am Sunny Island wie beim SI 4.4M.' },
    { wr: 'sma-sunny-island', wr_varianten: ['si-8-0h'], speicher: 'byd-premium-lvs',
      groessen: ['12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste, Netzbetrieb: SI 8.0H einphasig ab 3 Modulen; dreiphasig ab 8 Modulen '
        + 'in 2 Türmen. Notstrom und Inselbetrieb: einphasig ab 4 Modulen, dreiphasig ab 12 Modulen in '
        + '3 Türmen. Batterie-Firmware BMU ≥ V1.19, BMS ≥ V1.8; Wechselrichter-Firmware ≥ V1.3.1.R; '
        + 'Einstellwerte am Sunny Island wie beim SI 4.4M.' },
    { wr: 'victron-cerbo', speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste nennt zehn Victron-Geräte namentlich (Multiplus, Multigrid, Quattro '
        + 'von 5 bis 15 kVA, Easysolar, Multi RS Solar 48/6000), im Netzbetrieb ab 1 Modul; Multi RS '
        + 'Solar nur einphasig. Unser Katalog führt Victron als eine Familie über den Cerbo GX als '
        + 'Kommunikationsbrücke. Für Notstrom und Inselbetrieb verlangt die Liste je nach Gerät mehr '
        + 'Module (einphasig bis 7, ab dem Quattro 10 kVA zwei Türme). Batterie-Firmware BMU ≥ V1.16, '
        + 'BMS ≥ V1.8; Wechselrichter-Firmware ≥ V2.52.' },
    { wr: 'selectronic-spmc', wr_varianten: ['spmc480-au', 'spmc481-au'], speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste, Netzbetrieb: SPMC480-AU und SPMC481-AU einphasig ab 1 Modul, dreiphasig '
        + 'ab 3 Modulen. Notstrom: SPMC480-AU ab 2, SPMC481-AU ab 3 Modulen. Batterie-Firmware '
        + 'BMU ≥ V1.17, BMS ≥ V1.8; SP Link ≥ 14.20.x, SP Pro ≥ V12.x.' },
    { wr: 'selectronic-spmc', wr_varianten: ['spmc482-au'], speicher: 'byd-premium-lvs',
      groessen: ['8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste, Netzbetrieb: SPMC482-AU einphasig ab 2 Modulen, dreiphasig ab 6 Modulen '
        + 'in 2 Türmen. Notstrom: einphasig ab 5 Modulen in 2 Türmen, Inselbetrieb ab 3 Modulen. '
        + 'Batterie-Firmware BMU ≥ V1.17, BMS ≥ V1.8; SP Link ≥ 14.20.x, SP Pro ≥ V12.x.' },
    { wr: 'studer-xt',
      wr_varianten: ['xts-1400-48', 'xtm-2600-48', 'xtm-4000-48', 'xth-6000-48', 'xth-8000-48',
        'vt-65', 'vt-80', 'vs-70', 'vs-120'],
      speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste, Netzbetrieb: XTS, XTM, XTH sowie die Laderegler VT-65, VT-80, VS-70 und '
        + 'VS-120 ab 1 Modul, ein- und dreiphasig. Den VT-40 nennt die Liste nicht. Notstrom je nach Gerät '
        + 'ab 1 bis 5 Modulen (XTH8000-48 in 2 Türmen). Batterie-Firmware BMU ≥ V1.16, BMS ≥ V1.8; '
        + 'Wechselrichter-Firmware ≥ R664.' },
    { wr: 'studer-xt', wr_varianten: ['next3'], speicher: 'byd-premium-lvs',
      groessen: ['16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste: Next 3 nur dreiphasig, in jeder Betriebsart ab 4 Modulen in einem Turm. '
        + 'Batterie-Firmware BMU ≥ V1.16, BMS ≥ V1.8; Next-3-Firmware ≥ 0.5.0.0.' },
    { wr: 'goodwe-es-sbp', wr_varianten: ['goodwe-es-sbp-1', 'goodwe-es-sbp-2', 'goodwe-es-sbp-3'],
      speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste nennt die „ES, EM, BP, SBP Series", einphasig im Netzbetrieb ab 1 Modul, '
        + 'mit Notstrom ab 2 Modulen. Für Inselbetrieb ohne hohe Einschaltströme führt die Liste ES und '
        + 'SBP nicht. Zugeordnet sind die Katalogvarianten der ES- und SBP-Reihe; den GW 12K-ES-C10 nennt '
        + 'die Liste nicht ausdrücklich. Batterie-Firmware BMU ≥ V1.16, BMS ≥ V1.8; '
        + 'Wechselrichter-Firmware ≥ ARM V11.' },
    { wr: 'solis-eh', wr_varianten: ['solis-eh-1', 'solis-eh-3'], speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste, Netzbetrieb: S5-EH1P(3-6)K-L und S6-EH1P…K-L-EU einphasig ab 1 Modul. '
        + 'Notstrom: S6-EH1P 3 und 3,6 kW ab 2 Modulen, 4,6 und 5 kW ab 2, 6 kW ab 3 Modulen; '
        + 'S5-EH1P 4,6 bis 6 kW ab 3 Modulen. Batterie-Firmware BMU ≥ V1.24, BMS ≥ V1.14; '
        + 'Wechselrichter-Firmware S5-EH1P ≥ V35, S6-EH1P-L-EU ≥ V320020.' },
    { wr: 'deye-sun-lp', wr_varianten: ['deye-sun-lp-2', 'deye-sun-lp-5', 'deye-sun-lp-7'],
      speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste, Netzbetrieb: SUN-3.6/5/6K-SG03LP1-EU, die 7,6- und 8-kW-Fassungen der '
        + 'SG01LP1-EU und SUN-12/14/16K-SG01LP1-EU ab 1 Modul. Notstrom verlangt mehr: 3,6 bis 8 kW ab '
        + '2 bis 3 Modulen, 12 und 14 kW ab 5, 16 kW ab 6 Modulen; im Inselbetrieb mit hohen Einschaltströmen '
        + 'bis 9 Module in 3 Türmen. Batterie-Firmware BMU ≥ V1.22, BMS ≥ V1.13; '
        + 'Wechselrichter-Firmware ≥ C351.' },
    { wr: 'deye-sun-lp', wr_varianten: ['deye-sun-lp-1', 'deye-sun-lp-3', 'deye-sun-lp-6'],
      speicher: 'byd-premium-lvs',
      groessen: ['4.0', '8.0', '12.0', '16.0', '20.0', '24.0'],
      quelle: 'byd-lvs-mcl',
      einschraenkung: 'BYD-Liste, Netzbetrieb: SUN-3/3.6/5/6K-SG04LP1-EU und SUN-3.6/5/6/7.6/8K-SG05LP1-EU '
        + 'einphasig ab 1 Modul, SUN-5/6/8/10/12K-SG04LP3-EU dreiphasig ab 1 Modul. Notstrom: einphasig '
        + 'je nach Leistung ab 2 bis 3 Modulen, dreiphasig ab 2 bis 4 Modulen. Batterie-Firmware '
        + 'BMU ≥ V1.22, BMS ≥ V1.13; Wechselrichter-Firmware ≥ 1001-C015.' },

    { wr: 'solaredge-home-hub-1ph', speicher: 'solaredge-home-batterie-400v',
      groessen: ['9.7'],
      quelle: 'solaredge-hub-1ph-db',
      einschraenkung: 'Datenblattzeile „Unterstützte Batteriemodelle: SolarEdge Home Batterie 400V", '
        + 'bis zu 3 Batterien je Wechselrichter. Die Gesamt-Entladeleistung ist laut Fußnote auf die '
        + 'AC-Nennleistung des Wechselrichters begrenzt.' },
    { wr: 'solaredge-home-hub-1ph', speicher: 'solaredge-home-batterie-400v',
      groessen: ['9.7'],
      quelle: 'solaredge-bat-400v-konfig',
      einschraenkung: 'Konfigurationsdokument: kompatibel ist BAT-10K1S0B-01 an SetApp-fähigen '
        + 'Einphasen-Wechselrichtern mit HD-Wave-Technologie, erforderliche CPU-Firmware 4.14 und '
        + 'höher. Warnung des Dokuments: Die Home Batterie 400V und Batterien von Drittanbietern '
        + 'dürfen nicht an denselben Wechselrichter.' },

    { wr: 'solaredge-nexis-3ph', speicher: 'solaredge-nexis-battery',
      groessen: ['4.65', '9.3', '13.95', '18.6'],
      quelle: 'solaredge-nexis-3ph-db',
      einschraenkung: 'Datenblattzeile „Supported Battery Types: SolarEdge Nexis Battery"; bis zu 4 '
        + 'Battery Blocks je Stack und bis zu 16 Blöcke (4 Stacks) je Wechselrichter. Der Katalog '
        + 'führt einen Stack. Die Mehrfach-Stack-Ausbauten setzen laut Fußnote 2 eine erst für '
        + 'das zweite Halbjahr 2026 angekündigte Firmware voraus.' },
    { wr: 'solaredge-nexis-3ph', speicher: 'solaredge-nexis-battery',
      groessen: ['4.65', '9.3', '13.95', '18.6'],
      quelle: 'solaredge-nexis-bat-db',
      einschraenkung: 'Datenblattabschnitt „INVERTER COMPATIBILITY": SolarEdge Nexis Inverter 1ph und '
        + '3ph, bis zu 4 Blöcke je Stack.' },
  ];

  if (typeof module !== 'undefined' && module.exports) module.exports = FREIGABEN;
  if (root) root.IVBeraterDatenFreigaben = FREIGABEN;
})(typeof window !== 'undefined' ? window : null);

/*
 * inselvolt Kompatibilitätsberater — kuratierte Datenbasis (Zusammenbau).
 *
 * ÄNDERUNGEN NUR NACH v2/DATENPFLEGE.md (Rezepte A–H, Abschluss-Checkliste).
 * Feldreferenz und Vorlagen: v2/daten/SCHEMA.md.
 *
 * Seit E5 (2026-08-25) liegt die Datenbasis in vier Teildateien — daten/quellen.js,
 * daten/wechselrichter.js, daten/speicher.js, daten/freigaben.js —, damit jede
 * Datenänderung nur den Block berührt, zu dem sie gehört. Diese Datei fügt die
 * Teile zusammen und bleibt die EINZIGE Schnittstelle (IVBeraterDaten): Wer die
 * Daten nutzt, merkt von der Teilung nichts. Ausgeliefert wird weiterhin EIN
 * Theme-Asset (iv-berater-daten.js) — der Bau konkateniert die Teile in der
 * Reihenfolge des Ladeplans, der nächtliche Datendeploy bleibt unberührt.
 *
 * JEDER Datenpunkt stammt aus einem offiziellen Dokument in Datenblätter/ und trägt
 * eine Quellen-Referenz. Regeln:
 *  - Freigaben NUR aus den Herstellerlisten (Whitelist) — nie hergeleitet.
 *  - Fehlende Werte bleiben null („Datenblattwert folgt") — nie schätzen.
 *  - Preise stehen in preise.js (generiert, eigener Datenstand) — nie hier.
 */
(function (root) {
  'use strict';

  /* Globals zuerst, require nur als geprüfter Rückfall — dasselbe Muster wie
   * in berater-ui.js/familien.js: Ein Theme kann ein globales `module` leaken
   * (Legacy-Bundles); wer darauf verzweigte, riefe im Browser require() auf
   * und risse den Berater mit. Im Browser stehen die Teile als Globals (die
   * Reihenfolge sichern tools/ladeplan.js und der index.html-Test), unter
   * Node greift require. */
  function teil(browserGlobal, nodePfad) {
    return (root && root[browserGlobal])
      || (typeof require === 'function' ? require(nodePfad) : null);
  }
  var QUELLEN = teil('IVBeraterDatenQuellen', './quellen.js');
  var WECHSELRICHTER = teil('IVBeraterDatenWechselrichter', './wechselrichter.js');
  var SPEICHER = teil('IVBeraterDatenSpeicher', './speicher.js');
  var FREIGABEN = teil('IVBeraterDatenFreigaben', './freigaben.js');

  /* Laut scheitern statt mit halber Datenbasis weiterlaufen: Ein fehlender
   * Teil ist ein Bau- oder Ladefehler, kein darstellbarer Zustand. */
  if (!QUELLEN || !WECHSELRICHTER || !SPEICHER || !FREIGABEN) {
    throw new Error('berater-daten.js: Ein Teil der Datenbasis fehlt — Ladereihenfolge/Bau prüfen (quellen, wechselrichter, speicher, freigaben vor berater-daten).');
  }

  /*
   * Datenstand = jüngstes abruf_datum aller Quellen — berechnet, nicht gepflegt.
   * Ein von Hand gesetztes Datum driftet: es überlebt jede Quellen-Ergänzung
   * unverändert und behauptet dann einen Stand, den keine Quelle belegt.
   */
  function neuestesAbrufDatum(quellen) {
    return Object.keys(quellen)
      .map(function (k) { return quellen[k].abruf_datum; })
      .filter(Boolean)
      .sort()
      .pop() || null;
  }

  var DATEN = {
    stand: neuestesAbrufDatum(QUELLEN),
    quellen: QUELLEN,
    wechselrichter: WECHSELRICHTER,
    speicher: SPEICHER,
    freigaben: FREIGABEN,
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = DATEN;
  if (root) root.IVBeraterDaten = DATEN;
})(typeof window !== 'undefined' ? window : null);
